(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8329],{

/***/ 8876:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/r/surveyTaking/[collectKey]",
      function () {
        return __webpack_require__(2382);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _collectKey_page; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(5617);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/context.js
var context = __webpack_require__(6322);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/helpers.js
var helpers = __webpack_require__(993);
// EXTERNAL MODULE: ./node_modules/@sm/metrics/dist/index.js
var metrics_dist = __webpack_require__(6431);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/StaticContext/index.js
var StaticContext = __webpack_require__(6787);
;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/helper/surveyTakingWindowTitle.ts
var setSurveyTakingDocumentTitle = function(isEnabled, isWhiteLabel) {
    var title = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    var defaultTitle = "".concat(isWhiteLabel ? "Research.net" : "SurveyMonkey", " Powered Online Survey");
    if (isEnabled) {
        var textTitle = title === null || title === void 0 ? void 0 : title.replace(/<[^>]*>/g, "");
        return textTitle.toLowerCase().includes("survey") ? textTitle : "".concat(textTitle, " Survey");
    }
    return defaultTitle;
};
/* harmony default export */ var surveyTakingWindowTitle = (setSurveyTakingDocumentTitle);

// EXTERNAL MODULE: ./src/app/helpers/spageGoogleFonts.ts
var spageGoogleFonts = __webpack_require__(9542);
;// CONCATENATED MODULE: ./src/app/helpers/subdomain.ts
// from api/graphapi/src/schema/responsesRefactored, graphapi will be cleaned up after retiring respweb
var surveyTakingSubdomains = [
    "www",
    "zh",
    "da",
    "nl",
    "fi",
    "fr",
    "de",
    "it",
    "jp",
    "ko",
    "no",
    "pt",
    "ru",
    "es",
    "sv",
    "tr",
    // add regional subdomains
    "eu",
    "ca", 
];
// country TLD, that have .com domains, eg. surveymonkey.com.mx
var validSubdomains = [
    "surveymonkey",
    "localmonkey",
    "www",
    "monkeytest1",
    "monkeytest2",
    "monkeytest3",
    "localresearch", 
];
var defaultSubdomain = [
    "www"
];
var subdomainsInSurveyTakingSubdomains = function(subdomains) {
    return(// force to add type annotation by TS type check
    subdomains.reduce(function(found, segment) {
        return found && surveyTakingSubdomains.includes(segment);
    }, true));
};
var isValidSubdomain = function(requestSubdomains, collectorSubDomain) {
    var newRequestSubdomains = !requestSubdomains || requestSubdomains.length === 0 ? defaultSubdomain : requestSubdomains;
    var newCollectorSubdomain = "".concat(collectorSubDomain !== null && collectorSubDomain !== void 0 ? collectorSubDomain : "").toLowerCase();
    var collectorSubdomainSegments = newCollectorSubdomain.split(".");
    var newRequestSubdomainsAsString = newRequestSubdomains.map(function(segment) {
        return "".concat(segment !== null && segment !== void 0 ? segment : "").toLowerCase();
    }).join(".");
    // matching collector subdomain
    var matchCollectorSubdomain = newRequestSubdomainsAsString === newCollectorSubdomain;
    // check if collector sub domain is in the allowed list
    var isCollectorSubdomainInAllowedList = matchCollectorSubdomain || subdomainsInSurveyTakingSubdomains(collectorSubdomainSegments);
    if (!matchCollectorSubdomain && isCollectorSubdomainInAllowedList) {
        var isRegionalSubdomain = newRequestSubdomains.reduce(function(_, domainPart) {
            return validSubdomains.includes(domainPart);
        }, false);
        var subdomains = isRegionalSubdomain ? defaultSubdomain : newRequestSubdomains;
        return subdomainsInSurveyTakingSubdomains(subdomains);
    }
    return matchCollectorSubdomain;
};
/* harmony default export */ var subdomain = (isValidSubdomain);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(414);
// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(8499);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(6808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/@sm/question-widgets/respondent-survey.js + 2 modules
var respondent_survey = __webpack_require__(6427);
// EXTERNAL MODULE: ./node_modules/@sm/utils/dist/index.js
var utils_dist = __webpack_require__(7351);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/app/pages/SurveyTaking/v2/queries/SurveyPage.graphql
var SurveyPage_graphql = __webpack_require__(3063);
var SurveyPage_graphql_default = /*#__PURE__*/__webpack_require__.n(SurveyPage_graphql);
// EXTERNAL MODULE: ./src/app/pages/SurveyTaking/SubmitResponsesV2.graphql
var SubmitResponsesV2_graphql = __webpack_require__(2948);
var SubmitResponsesV2_graphql_default = /*#__PURE__*/__webpack_require__.n(SubmitResponsesV2_graphql);
// EXTERNAL MODULE: ./src/app/pages/SurveyTaking/hooks/SurveyVersionV2.graphql
var SurveyVersionV2_graphql = __webpack_require__(1401);
var SurveyVersionV2_graphql_default = /*#__PURE__*/__webpack_require__.n(SurveyVersionV2_graphql);
;// CONCATENATED MODULE: ./src/app/hooks/useIsomorphicLayoutEffect.ts
/*eslint spaced-comment: ["error", "never", { "exceptions": ["NOSONAR"] }] */ var ref;

/**
 * SSR Safe version of useLayoutEffect
 * @see https://code.corp.surveymonkey.com/webplatform/smweb/blob/master/apps/contentweb/src/app/pages/MRX/helpers/useIsomorphicLayoutEffect.js
 *
 * Note: `NOSONAR` is used to bypass a `minor:code-smell` error that states `createElement` is deprecated.
 * The eslint rule above disables the spaced comments to use NOSONAR as stated in the docs.
 */ var useIsomorphicLayoutEffect =  true && typeof (window === null || window === void 0 ? void 0 : (ref = window.document) === null || ref === void 0 ? void 0 : ref.createElement) !== "undefined" //NOSONAR
 ? react.useLayoutEffect : react.useEffect;
/* harmony default export */ var hooks_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);

;// CONCATENATED MODULE: ./src/app/hooks/redux.ts

/** Typed version of plain `useDispatch` */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
var useAppDispatchV2 = function() {
    return (0,es/* useDispatch */.I0)();
};
/** Typed version of plain `useSelector` */ var useAppSelectorV2 = es/* useSelector */.v9;

;// CONCATENATED MODULE: ./src/app/hooks/index.ts



;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/errors/constants.ts
var ErrorType = {
    REDIRECT: "REDIRECT",
    FOUR_OH_FOUR: "FOUR_OH_FOUR",
    COLLECTOR_CLOSED: "COLLECTOR_CLOSED",
    INVALID_OPEN_ENDED_VALIDATION: "INVALID_OPEN_ENDED_VALIDATION",
    INVALID_SURVEY_VERSION: "INVALID_SURVEY_VERSION",
    MISSING_REQUIRED_FIELD: "MISSING_REQUIRED_FIELD",
    /** @deprecated */ REQUEST_IP_DISALLOWED: "REQUEST_IP_DISALLOWED",
    SURVEY_CANNED: "SURVEY_CANNED",
    FAILED_VALIDATION: "FAILED_VALIDATION",
    INVALID_SURVEY_ID: "INVALID_SURVEY_ID",
    INVALID_RESPONSE_ID: "INVALID_RESPONSE_ID",
    INVALID_COLLECTOR_ID: "INVALID_COLLECTOR_ID",
    MISSING_OR_MALFORMED_SURVEY_ID: "MISSING_OR_MALFORMED_SURVEY_ID",
    MISSING_OR_MALFORMED_COLLECTOR_ID: "MISSING_OR_MALFORMED_COLLECTOR_ID",
    MISSING_OR_MALFORMED_RESPONSE_ID: "MISSING_OR_MALFORMED_RESPONSE_ID"
};
var defaultErrorGroups = {
    redirect: [
        ErrorType.REDIRECT,
        ErrorType.COLLECTOR_CLOSED,
        ErrorType.REQUEST_IP_DISALLOWED
    ],
    notFound: [
        ErrorType.FOUR_OH_FOUR
    ],
    validation: [
        ErrorType.MISSING_REQUIRED_FIELD,
        ErrorType.INVALID_OPEN_ENDED_VALIDATION,
        ErrorType.FAILED_VALIDATION
    ],
    canned: [
        ErrorType.SURVEY_CANNED
    ],
    gone: [
        ErrorType.INVALID_SURVEY_ID,
        ErrorType.INVALID_RESPONSE_ID,
        ErrorType.INVALID_COLLECTOR_ID
    ],
    badRequest: [
        ErrorType.MISSING_OR_MALFORMED_COLLECTOR_ID,
        ErrorType.MISSING_OR_MALFORMED_SURVEY_ID,
        ErrorType.MISSING_OR_MALFORMED_RESPONSE_ID, 
    ],
    /**  Added so it's not caught by unkownErrors. which was making the 500 error display when not needed. */ invalidSurveyVersion: [
        ErrorType.INVALID_SURVEY_VERSION
    ]
};

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/errors/index.ts




// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 4 modules
var redux_toolkit_esm = __webpack_require__(7406);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(8697);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEqual.js + 80 modules
var isEqual = __webpack_require__(8900);
;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/validation/validationManager.ts
/**
 * @todo Add @sm/question-definitions as an explicit dependency; or, import
 * from explicit dependency source. i.e. @sm/question-widgets
 *
 * As a best-practice, dependencies of a dependency should not be imported.
 */ 
var validators = {};
/**
 * Registers validator functions with a question
 * @param questionId A reference ID
 * @param validatorFns The validator functions
 */ var registerValidator = function(questionId, validatorFns) {
    validators[questionId] = validatorFns;
};
/**
 * Unregister a reference
 * @param questionId A reference ID
 */ var unregisterValidator = function(questionId) {
    if (validators[questionId]) {
        delete validators[questionId];
    }
};
/**
 * Run validators for a question
 * @param questionId The question to validate
 * @param force Force non-touched to validate
 * @returns {ValidationResult}
 */ var validate = function(questionId) {
    var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var questionValidator = validators[questionId] || [];
    var errors = questionValidator.reduce(function(prevErrors, validator) {
        var ref;
        return (0,_to_consumable_array/* default */.Z)(prevErrors).concat((0,_to_consumable_array/* default */.Z)((ref = validator(force)) !== null && ref !== void 0 ? ref : []));
    }, []);
    return {
        isValid: !errors.length,
        errors: errors
    };
};
/**
 * Runs all validators for all questions
 * @returns {ValidationResult}
 */ var runValidators = function() {
    var errors = Object.keys(validators).reduce(function(prevErrors, questionId) {
        var ref = validate(questionId, true), questionErrors = ref.errors;
        return (0,_to_consumable_array/* default */.Z)(prevErrors).concat((0,_to_consumable_array/* default */.Z)(questionErrors));
    }, []);
    return {
        isValid: !errors.length,
        errors: errors
    };
};

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/errors/transformToSurveyErrors.ts
/**
 * @todo Add @sm/question-definitions as an explicit dependency; or, import
 * from explicit dependency source. i.e. @sm/question-widgets
 *
 * As a best-practice, dependencies of a dependency should not be imported.
 */ 
var transformToSurveyErrors = function(errors) {
    return errors.map(function(param) {
        var detail = param.detail, questionId = param.questionId, type = param.type, fieldId = param.fieldId;
        return {
            questionId: questionId,
            detail: detail,
            code: (type === null || type === void 0 ? void 0 : type.includes("REQUIRED")) ? ErrorType.MISSING_REQUIRED_FIELD : ErrorType.FAILED_VALIDATION,
            field: fieldId ? [
                fieldId
            ] : null
        };
    });
};
/* harmony default export */ var errors_transformToSurveyErrors = (transformToSurveyErrors);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/v2/slices/oqaatSlice.ts
/* eslint-disable no-param-reassign */ 

var initialState = {
    views: [],
    active: null,
    isAnimating: false
};
// ========== SLICE
var sliceName = "OQAAT";
var oqaatSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: sliceName,
    initialState: initialState,
    reducers: {
        register: function(state, action) {
            state.views.push(action.payload);
        },
        unregister: function(state, action) {
            state.views = state.views.filter(function(v) {
                return v !== action.payload;
            });
        },
        setActive: function(state, param) {
            var name = param.payload;
            if (name !== null) {
                var ref;
                state.active = (ref = state.views.find(function(v) {
                    return v === name;
                })) !== null && ref !== void 0 ? ref : null;
            }
        },
        setAnimating: function(state, action) {
            state.isAnimating = action.payload;
        },
        reset: function() {
            return initialState;
        }
    }
});
var _actions = oqaatSlice.actions;
// ========== ACTIONS
var register = _actions.register, unregister = _actions.unregister, setActive = _actions.setActive, setAnimating = _actions.setAnimating, oqaatSlice_reset = _actions.reset;
// ========== THUNKS
// The built-in createAsyncThunk() function provides access to the state and dispatch actions via thunkAPI parameter - useful for writing reducers that cause side-effects (eg. dispatching other actions) which wouldn't work correctly in a regular reducer.
// Thunks are typically used for async operations: https://redux-toolkit.js.org/api/createAsyncThunk
var activateView = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(sliceName, "/activateView"), function(name, thunkAPI) {
    var dispatch = thunkAPI.dispatch;
    dispatch(setActive(name));
    if (name) setFocusToView(name);
});
var setNextActive = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(sliceName, "/setNextActive"), function(_, thunkAPI) {
    var oqaatState = thunkAPI.getState().oqaatState;
    var activeIndex = oqaatState.views.findIndex(function(v) {
        return v === oqaatState.active;
    });
    var nextActive = oqaatState.views[activeIndex + 1] || null;
    if (nextActive) {
        setFocusToView(nextActive);
    }
});
// ========== SELECTORS
/** The survey format state object */ var selectOQAATState = function(state) {
    return state.oqaatState;
};
/** The currently registered views (eg. questions, page navigation, page description). */ var selectViews = (0,reselect_es/* createSelector */.P1)(selectOQAATState, function(oqaatState) {
    return oqaatState.views;
});
/** The currently active view - triggers style changes and affects navigation */ var selectActive = (0,reselect_es/* createSelector */.P1)(selectOQAATState, function(oqaatState) {
    return oqaatState.active;
});
/** Whether there is currently a scroll animation occurring. */ var selectIsAnimating = (0,reselect_es/* createSelector */.P1)(selectOQAATState, function(oqaatState) {
    return oqaatState.isAnimating;
});
// ========== EXPORT

/* harmony default export */ var slices_oqaatSlice = (oqaatSlice.reducer);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/utils/animate.ts
/* eslint-disable no-param-reassign */ /* eslint-disable no-plusplus */ /**
 * Functions below come together from many sources:
 * @see https://gist.github.com/clauderic/13cc9207a9e5db63ee67a1588eb11811
 * @see https://gist.github.com/gre/1650294
 * Added TypeScript and some modifications
 */ /**
 * @name EasingFunctions- Useful easing equations
 * @comment only considering the t value for the range [0, 1] => [0, 1]
 */ /* istanbul ignore next */ var EasingFunctions = {
    /** @comment linear - no easing, no acceleration */ linear: function(t) {
        return t;
    },
    /** @comment easeInQuad - accelerating from zero velocity */ easeInQuad: function(t) {
        return t * t;
    },
    /** @comment easeOutQuad - decelerating to zero velocity */ easeOutQuad: function(t) {
        return t * (2 - t);
    },
    /** @comment easeInOutQuad - acceleration until halfway, then deceleration */ easeInOutQuad: function(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    /** @comment easeInCubic - accelerating from zero velocity */ easeInCubic: function(t) {
        return t * t * t;
    },
    /** @comment easeOutCubic - decelerating to zero velocity */ easeOutCubic: function(t) {
        return --t * t * t + 1;
    },
    /** @comment easeInOutCubic - acceleration until halfway, then deceleration */ easeInOutCubic: function(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    /** @comment easeInQuart - accelerating from zero velocity */ easeInQuart: function(t) {
        return t * t * t * t;
    },
    /** @comment easeOutQuart - decelerating to zero velocity */ easeOutQuart: function(t) {
        return 1 - --t * t * t * t;
    },
    /** @comment easeInOutQuart - acceleration until halfway, then deceleration */ easeInOutQuart: function(t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    /** @comment easeInQuint - accelerating from zero velocity */ easeInQuint: function(t) {
        return t * t * t * t * t;
    },
    /** @comment easeOutQuint - decelerating to zero velocity */ easeOutQuint: function(t) {
        return 1 + --t * t * t * t * t;
    },
    /** @comment easeInOutQuint - acceleration until halfway, then deceleration */ easeInOutQuint: function(t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
};
/**
 * Given a start/end point of a scroll and time elapsed, calculate the scroll position we should be at
 */ function getValue(start, end, elapsed, duration) {
    var easingType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "linear";
    if (elapsed > duration) return end;
    var easing = typeof easingType === "string" ? EasingFunctions[easingType] : easingType;
    return start + (end - start) * easing(elapsed / duration);
}
var Test__getValue = (/* unused pure expression or super */ null && (getValue));
/**
 * Smoothly animate between two values
 */ function animate(param) {
    var fromValue = param.fromValue, toValue = param.toValue, onStart = param.onStart, onUpdate = param.onUpdate, onComplete = param.onComplete, _duration = param.duration, duration = _duration === void 0 ? 600 : _duration, _easingType = param.easingType, easingType = _easingType === void 0 ? "easeOutQuart" : _easingType;
    var startTime = performance.now();
    var tick = function() {
        var elapsed = performance.now() - startTime;
        var time = getValue(fromValue, toValue, elapsed, duration, easingType);
        var callback = elapsed <= duration ? tick : onComplete;
        var updateAnimation = function() {
            onUpdate(time, callback);
        };
        window.requestAnimationFrame(updateAnimation);
    };
    onStart === null || onStart === void 0 ? void 0 : onStart();
    tick();
};

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/utils/scrollIntoView.ts

/**
 * How many animations are occurring (used in export to prevent OQAAT position
 * calculations from running unnecessarily and interfering with animation)
 * */ var animationCount = 0;
/**
 * Scroll an HTML element in to view
 * Opinionated - will scroll the element to the viewport (window) center unless `alignToTop` is set to `true`
 * @param {HTMLElement} element the HTML element to calculate position
 * @param {boolean} alignToTop If `true` scrolls to top of `element` (default `false`)
 * @param {number} customOffset offset to remove from calculated top-offset (default `0`)
 * @param {Function} onStart the callback when animation starts
 * @param {Function} onComplete the callback when animation completes
 */ // TODO: RAWR-1164 - replace this with `scroll-behaviour: smooth` once it has been fully adopted by safari
// (https://caniuse.com/css-scroll-behavior)
/* istanbul ignore next */ var scrollIntoView = function(element) {
    var alignToTop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, customOffset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, onStart = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {}, onComplete = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {};
    if (!element) return;
    var rect = element.getBoundingClientRect();
    /** total offset to the top of `element` */ var topOffset = window.scrollY + rect.top - customOffset;
    var toValue = alignToTop ? topOffset : topOffset - window.innerHeight / 2 + Math.min(rect.height, window.innerHeight - 30) / 2;
    animate({
        fromValue: window.scrollY,
        toValue: toValue,
        onStart: function() {
            animationCount += 1;
            onStart();
        },
        onUpdate: function(scrollTop, next) {
            window.scrollTo({
                left: 0,
                top: scrollTop
            });
            next();
        },
        onComplete: function() {
            animationCount -= 1;
            onComplete();
        }
    });
};
/** Whether a scroll animation is currently occurring */ var isAnimating = function() {
    return animationCount > 0;
};

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/ActiveViewScrollManager.tsx




/** Whether a `mousedown` event has occurred within 200ms, exported to be used in OQAAT focus handling */ var clicking = false;
function ActiveViewScrollManager() {
    var active = useAppSelectorV2(selectActive);
    var views = useAppSelectorV2(selectViews);
    var dispatch = useAppDispatchV2();
    var ref = (0,react.useState)([]), viewElements = ref[0], setViewElements = ref[1];
    (0,react.useEffect)(function() {
        var elements = [];
        views.forEach(function(view) {
            var el = document.getElementById("view-".concat(view));
            if (el) {
                elements.push(el);
            }
        });
        setViewElements(elements);
    }, [
        views
    ]);
    var findActiveAnchor = (0,react.useCallback)(function() {
        if (isAnimating()) {
            return;
        }
        var newIdx = -1;
        if (window.scrollY === 0) {
            newIdx = 0;
        } else {
            var winMidpoint = window.innerHeight / 2;
            viewElements.forEach(function(el, idx) {
                var rect = el.getBoundingClientRect();
                if (rect.top <= winMidpoint) {
                    newIdx = idx;
                }
            });
        }
        var currentAnchor = views[newIdx];
        if (currentAnchor && currentAnchor !== active) {
            dispatch(setActive(currentAnchor));
        }
    }, [
        views,
        active,
        viewElements,
        dispatch
    ]);
    /**
   * Set `clicking` variable on click, which is used to determine OQAAT scroll behaviour
   * for focus events.
   * note: listening to `mousedown` events as they trigger before `focus` events
   */ var handleClick = (0,react.useCallback)(function(e) {
        clicking = true;
        setTimeout(function() {
            clicking = false;
        }, 200);
    }, []);
    /**
   * Scroll to currently focused input on keydown if question is inactive
   * (makes it less confusing for the user when they've scrolled away from focused input)
   */ var handleKeydown = (0,react.useCallback)(function(e) {
        var ref, ref1, ref2;
        /** The keys which will trigger the scroll animation - matches all alphanumeric & non-word characters */ var keysToMatch = /^([a-z0-9]|\W|_)$/i;
        /** ViewId extracted from wrapping view element */ var focusedViewId = (ref1 = (ref = document.activeElement) === null || ref === void 0 ? void 0 : ref.closest("[id^='view-']")) === null || ref1 === void 0 ? void 0 : ref1.id.split("-")[1];
        if (keysToMatch.test(e.key) && focusedViewId && ((ref2 = document.activeElement) === null || ref2 === void 0 ? void 0 : ref2.tagName) === "INPUT" && views.includes(focusedViewId) && focusedViewId !== active // if the focused view is not active
        ) {
            scrollIntoView(document.activeElement);
            // activate the question being scrolled to (scroll listener is disabled during animation)
            dispatch(setActive(focusedViewId));
        }
    }, [
        dispatch,
        views,
        active
    ]);
    hooks_useIsomorphicLayoutEffect(function() {
        window.addEventListener("scroll", findActiveAnchor);
        document.addEventListener("mousedown", handleClick);
        document.addEventListener("keydown", handleKeydown);
        return function() {
            window.removeEventListener("scroll", findActiveAnchor);
            document.removeEventListener("mousedown", handleClick);
            document.removeEventListener("keydown", handleKeydown);
        };
    }, [
        findActiveAnchor,
        handleClick,
        handleKeydown
    ]);
    // Initially focus on first active view
    // Only run on first render (prevents active state being stuck on top question when scrolled up on larger screens)
    var firstUpdate = (0,react.useRef)(true);
    (0,react.useEffect)(function() {
        if (firstUpdate.current) {
            findActiveAnchor();
            if (viewElements.length) {
                firstUpdate.current = false;
            }
        }
    }, [
        viewElements,
        findActiveAnchor
    ]);
    return null;
};
/** Whether a `mousedown` event has occurred within the last 200ms */ var isClicking = function() {
    return clicking;
};

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/constants.ts
// eslint-disable-next-line import/prefer-default-export
var SurveyFormat = {
    CLASSIC: "CLASSIC",
    CONVERSATIONAL: "CONVERSATIONAL",
    ONE_QUESTION_AT_A_TIME: "ONE_QUESTION_AT_A_TIME",
    SYMPTOM_TRACKING: "SYMPTOM_TRACKING"
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/validation/delayedValidation.ts


/** Globally shared reference to track the next element that'll receive focus */ var nextFocusElRef = null;
/** Globally shared reference for a post-focus callback */ var blurPostFocusCallbacks = [];
var blurPostFocusCallback = null;
var isFocusableElementWithDisabled = function(el) {
    return [
        "INPUT",
        "TEXTAREA",
        "SELECT",
        "BUTTON"
    ].includes(el.nodeName);
};
var isFocusableElementWithHref = function(el) {
    return [
        "A",
        "AREA"
    ].includes(el.nodeName);
};
var isFocusableElWithControls = function(el) {
    return [
        "AUDIO",
        "VIDEO"
    ].includes(el.nodeName);
};
/**
 * Helper to check if `el` can be focused
 * Ref: https://allyjs.io/data-tables/focusable.html
 */ var isFocusable = function(el) {
    if (el.getAttribute("tabindex")) {
        return true;
    }
    if (el.nodeName === "LABEL" || el.nodeName === "LEGEND") {
        // special case - Label redirects to focus element
        // Legend TBD - appears to do the same
        return true;
    }
    if (isFocusableElementWithDisabled(el)) {
        return !el.disabled;
    }
    if (isFocusableElementWithHref(el)) {
        return !!el.href;
    }
    if (isFocusableElWithControls(el)) {
        return el.controls;
    }
    if (el.nodeName === "DETAILS") {
        return true;
    }
    return false;
};
/** @ignore - do not use - exported for test only */ var _isFocusable = (/* unused pure expression or super */ null && (isFocusable));
/** Sets reference for next focus target - before it receives focus */ var setNextFocusElement = function(e) {
    if (e.target && isFocusable(e.target)) {
        nextFocusElRef = e.target;
    } else {
        nextFocusElRef = null;
    }
};
/**
 * Decided if `callback` should be called immediately after the
 * next element received focus
 */ var deferToAfterFocusChanged = function(callback) {
    if (!nextFocusElRef) {
        // call imediately if there is no next focus target
        callback();
        return;
    }
    // register callback
    blurPostFocusCallbacks = (0,_to_consumable_array/* default */.Z)(blurPostFocusCallbacks).concat([
        callback
    ]);
    blurPostFocusCallback = function() {
        blurPostFocusCallbacks.forEach(function(fn) {
            return fn();
        });
        // reset variables
        blurPostFocusCallbacks = [];
        blurPostFocusCallback = null;
    };
};
/**
 * Wrapper to allow a registered function to be called after the next element
 * has received focus, to circumvent layout shifts before the click is registerd -
 * which could cause the element's `onClick` to never fire if the layout-shift
 * moves it from under the cursor.
 */ var runAfterFocusChangedFn = function() {
    if (blurPostFocusCallback) {
        blurPostFocusCallback();
    }
    nextFocusElRef = null;
};
/**
 * Cleanup in case `runAfterFocusChangedFn` is not handled by the target
 * element's `onClick` handler
 */ var cleanupCall = function(e) {
    var ref;
    var nodeName = (ref = e.target) === null || ref === void 0 ? void 0 : ref.nodeName;
    // don't run for `<label/>` - wait for associated element to receive focus
    if ((nextFocusElRef || blurPostFocusCallback) && nodeName !== "LABEL") {
        runAfterFocusChangedFn();
    }
};
/**
 * Helper to register the `deferToAfterFocusChanged` global
 * auxillary event-handlers, that register next targets and
 * calls `runAfterFocusChangedFn` in case it is not handled
 * manually by the target element's `onClick` handler
 */ var useGlobalAfterFocusChangedHandler = function() {
    (0,react.useEffect)(function() {
        // register the next focus target - called before blur
        window.addEventListener("mousedown", setNextFocusElement);
        // listen to `click` to bubble up for cleanup
        window.addEventListener("click", cleanupCall);
        return function() {
            window.removeEventListener("mousedown", setNextFocusElement);
            window.removeEventListener("click", cleanupCall);
        };
    }, []);
};

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/utils/isChildFunction.ts
/** Type-guard for `children` being a function */ var isChildFunction = function(c) {
    return typeof c === "function";
};
/* harmony default export */ var utils_isChildFunction = ((/* unused pure expression or super */ null && (isChildFunction)));

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/validation/types.ts
/**
 * @todo Add @sm/question-definitions as an explicit dependency; or, import
 * from explicit dependency source. i.e. @sm/question-widgets
 *
 * As a best-practice, dependencies of a dependency should not be imported.
 */ var ValidationStatus = {
    OK: "ok",
    Error: "error"
};

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/validation/index.ts




;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/utils/setFocusToView.ts


/** css selector for form elements that can be focused within a question-type */ var focusableElements = [
    "button",
    "textarea",
    'input:not([type="hidden"])',
    "select",
    '[tabindex]:not([tabindex="-1"])', 
].map(function(el) {
    return "".concat(el, ':not([disabled]):not([aria-hidden]):not([id^="question-title-legend-"] *)');
}) // ignore question-header, disabled and aria hidden
.join(", ");
/** focuses first focusable form element in `baseElement` (ignores anchors etc in the head) */ var focusFirstElement = function(baseElement) {
    var firstFocusableEl = baseElement.querySelector(focusableElements);
    firstFocusableEl === null || firstFocusableEl === void 0 ? void 0 : firstFocusableEl.focus({
        preventScroll: true
    });
};
/**
 * Set focus to the view with the given name.
 *
 * Error-animation offset assumes it contains the top-most remaining error
 *
 * @param viewName The name of the view to find the first input to set focus to
 * @param focusOnInput if true the first (form) input will be focused
 * @param viewNamesInOrder All views of the page in order to identify which ones are above `viewName`
 * (only needed for classic mode)
 * @param isClassic if true handles scrolling and align to the top of the question
 */ var setFocusToView = function(viewName) {
    var focusOnInput = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, viewNamesInOrder = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], isClassic = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var viewEl = document.getElementById("view-".concat(viewName));
    if (!viewEl) {
        return;
    }
    if (focusOnInput) {
        focusFirstElement(viewEl);
    } else {
        viewEl.focus({
            preventScroll: true
        });
    }
    if (!isClassic) {
        return; // OQAAT is done here
    }
    // Classic only
    /** views above question with error to focus */ var viewsAbove = viewNamesInOrder.slice(0, viewNamesInOrder.indexOf(viewName));
    /** combined size in px of errors above that are in the process of collapsing */ var errorsAboveOffset = 0;
    if (viewsAbove.length > 0) {
        // query for all errors above view to focus
        var errorRowsAbove = document.querySelectorAll(viewsAbove.map(function(v) {
            return "#error-row-".concat(v);
        }).join(", "));
        errorsAboveOffset = Array.from(errorRowsAbove).reduce(function(offeset, el) {
            return offeset + (el.offsetHeight || 0);
        }, 0);
    }
    var errorRow = document.getElementById("error-row-".concat(viewName));
    deferToAfterFocusChanged(function() {
        scrollIntoView(errorRow !== null && errorRow !== void 0 ? errorRow : viewEl, true, errorsAboveOffset);
    });
};
/* harmony default export */ var utils_setFocusToView = ((/* unused pure expression or super */ null && (setFocusToView)));

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/utils/index.ts





;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/views/useFormatView.ts



function useFormatView(name) {
    // computed state will only re-render if computed value changes
    var isActive = useAppSelectorV2(function(param) {
        var oqaatState = param.oqaatState;
        return oqaatState.active === name;
    });
    var dispatch = useAppDispatchV2();
    (0,react.useEffect)(function() {
        dispatch(register(name));
        return function() {
            dispatch(unregister(name));
        };
    }, [
        dispatch,
        name
    ]);
    return {
        isActive: isActive
    };
};

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/views/useStyles.ts


var useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    var ref;
    var _obj;
    return {
        shield: (_obj = {
            opacity: function(param) {
                var active = param.active, noShield = param.noShield;
                return !!noShield || active ? 1 : 0.5;
            },
            paddingBottom: function(param) {
                var autoPadding = param.autoPadding;
                return autoPadding ? "80px" : 0;
            }
        }, (0,_define_property/* default */.Z)(_obj, "@media (max-width: ".concat((ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref.xs.max, ")"), {
            paddingBottom: function(param) {
                var autoPadding = param.autoPadding;
                return autoPadding ? "270px" : 0;
            }
        }), // separate title and body elements to allow distinction in the focus event
        (0,_define_property/* default */.Z)(_obj, '& fieldset > *:not([id^="question-title-legend-"]), & fieldset > [id^="question-title-legend-"] > *', {
            pointerEvents: function(param) {
                var active = param.active, noShield = param.noShield;
                return active || noShield ? "auto" : "none";
            }
        }), (0,_define_property/* default */.Z)(_obj, "cursor", function(param) {
            var active = param.active, noShield = param.noShield;
            return active || noShield ? "auto" : "pointer";
        }), // prevent default browser outline for the focused view
        (0,_define_property/* default */.Z)(_obj, "outline", "none"), _obj)
    };
});
/* harmony default export */ var views_useStyles = (useStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/views/OQAATView.tsx













function OQAATFormatView(_param) {
    var name = _param.name, _noShield = _param.noShield, noShield = _noShield === void 0 ? false : _noShield, _autoPadding = _param.autoPadding, autoPadding = _autoPadding === void 0 ? true : _autoPadding, className = _param.className, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "noShield",
        "autoPadding",
        "className",
        "children"
    ]);
    var dispatch = useAppDispatchV2();
    var isActive = useFormatView(name).isActive;
    var shield = views_useStyles({
        active: isActive,
        noShield: noShield,
        autoPadding: autoPadding
    }).shield;
    /** On click, if the current view isn't active, focus it to trigger the focus handler below */ var handleClick = (0,react.useCallback)(function() {
        if (!isActive) {
            setFocusToView(name);
        }
    }, [
        isActive,
        name
    ]);
    /** Scroll to the focus target, and activate the appropriate view. */ var handleFocus = (0,react.useCallback)(function(e) {
        var target = e.target;
        var targetTop = target.getBoundingClientRect().top;
        var isQuestionTitle = target.id.startsWith("question-title-legend-");
        var isViewElement = target.id.startsWith("view-");
        // lookup the related view element in case the user clicked on the title or an input
        var targetViewElement = isViewElement ? target : target.closest("[id^=view-]");
        if (!targetViewElement) {
            return;
        }
        var isCurrentView = targetViewElement.id === "view-".concat(name);
        var isAboveView = (targetTop !== null && targetTop !== void 0 ? targetTop : 0) < 0;
        var isCurrentViewButOutOfViewport = isCurrentView && isAboveView;
        if (!isActive || !isClicking() || isCurrentViewButOutOfViewport) {
            // Scroll to the target (either the question or answer) if the question is inactive,
            // OR to any target (incl. links & tooltips) if not a result of clicking,
            // OR to the question itself if the top of the question is above the viewport.
            deferToAfterFocusChanged(function() {
                if (!isQuestionTitle && !isActive && isClicking()) {
                    focusFirstElement(targetViewElement);
                }
                scrollIntoView(target);
            });
        }
        if (isActive || !isCurrentView) {
            return;
        }
        if (noShield) {
            // defer to make done with error-change click work
            deferToAfterFocusChanged(function() {
                dispatch(setActive(name));
            });
            return;
        }
        dispatch(setActive(name));
    }, [
        name,
        isActive,
        noShield,
        dispatch
    ]);
    // only re-render children if their active state changes
    var content = (0,react.useMemo)(function() {
        if (isChildFunction(children)) {
            return children(isActive, function() {
                return dispatch(setNextActive());
            });
        }
        if (children) {
            return /*#__PURE__*/ react.cloneElement(children, {
                active: isActive,
                onSubmit: function() {
                    return dispatch(setNextActive());
                }
            });
        }
        return null;
    }, [
        children,
        dispatch,
        isActive
    ]);
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onFocus: handleFocus,
        onMouseDown: noShield || isActive ? undefined : function(e) {
            return e.preventDefault();
        },
        onClick: noShield ? undefined : handleClick,
        // `offset-target-container` is needed for pages/_document.page.tsx to calculate initial `marginTop`
        className: classnames_default()("offset-target-container", shield, className)
    }, props), {
        id: "view-".concat(name),
        "data-testid": "OQAATView__".concat(name),
        tabIndex: -1,
        children: content
    })));
}
/* harmony default export */ var OQAATView = (OQAATFormatView);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/views/ClassicView.tsx






function ClassicFormatView(_param) {
    var name = _param.name, noShield = _param.noShield, className = _param.className, autoPadding = _param.autoPadding, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "noShield",
        "className",
        "autoPadding",
        "children"
    ]);
    var content = isChildFunction(children) ? children(true, function() {}) : children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        id: "view-".concat(name)
    }, props), {
        "data-testid": "ClassicView__".concat(name),
        children: content
    }));
}
/* harmony default export */ var ClassicView = (ClassicFormatView);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/views/index.ts





// EXTERNAL MODULE: ./node_modules/crypto-js/aes.js
var aes = __webpack_require__(452);
var aes_default = /*#__PURE__*/__webpack_require__.n(aes);
// EXTERNAL MODULE: ./node_modules/crypto-js/enc-utf8.js
var enc_utf8 = __webpack_require__(5743);
var enc_utf8_default = /*#__PURE__*/__webpack_require__.n(enc_utf8);
;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/helper/localStoreAnswers.ts





/**
 * Decrypts answers from localstorage item answers_<collectorKey> HTML entities in a string.
 * @param collectorKey
 * @returns decrypted answers
 */ var decryptAnswers = function() {
    var collectorKey = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "collectKey";
    if (false) {}
    var encryptedAnswers = window.localStorage.getItem("answers_".concat(collectorKey));
    var decryptedAnswers = {};
    if (encryptedAnswers) {
        try {
            var bytes = aes_default().decrypt(encryptedAnswers, collectorKey);
            decryptedAnswers = JSON.parse(bytes.toString((enc_utf8_default())));
        } catch (error) {
        // return empty object below
        }
    }
    return decryptedAnswers;
};
/*
 * helper without decryption
 */ var overrideAnswersFromLocalStorage = function(questions, localStorageAnswers) {
    var ref;
    var overriddenResponses = questions === null || questions === void 0 ? void 0 : (ref = questions.items) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, curr) {
        var ref;
        var ref1;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, curr.id, {
            questionId: curr.id,
            values: (ref1 = (ref = localStorageAnswers[curr.id]) === null || ref === void 0 ? void 0 : ref.values) !== null && ref1 !== void 0 ? ref1 : [],
            touched: false,
            isDirty: false
        }));
    }, {});
    return overriddenResponses;
};

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/helper/mapImplicitResponse.ts
/**
 * Extracts the random-assignment variableID
 * @param question question with assignments
 * @returns `variable_id` of the chosen question text (Text A/B) or question image (Image A/B)
 * or `null` if it was not founds
 */ var mapImplicitResponse = function(question) {
    var ref;
    var assignments = question === null || question === void 0 ? void 0 : question.heading.assignments;
    if (!question || !assignments || assignments.length === 0) {
        return null;
    }
    if (question.variant === "IMAGE") {
        var currentAssignment = assignments.find(function(param) {
            var image = param.heading.image;
            var ref;
            return (image === null || image === void 0 ? void 0 : image.id) === ((ref = question.heading.default.image) === null || ref === void 0 ? void 0 : ref.id);
        });
        var ref1;
        return (ref1 = currentAssignment === null || currentAssignment === void 0 ? void 0 : currentAssignment.id) !== null && ref1 !== void 0 ? ref1 : null;
    }
    var ref2;
    return (ref2 = (ref = assignments.find(function(param) {
        var text = param.heading.text;
        return text === question.heading.default.text;
    })) === null || ref === void 0 ? void 0 : ref.id) !== null && ref2 !== void 0 ? ref2 : null;
};
/* harmony default export */ var helper_mapImplicitResponse = ((/* unused pure expression or super */ null && (mapImplicitResponse)));

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/helper/mapSurveyAnswersToResponse.ts




/** Fills answers and adds "other" value */ var mapMultipleChoiceAnswers = function(values, responseBase, variant) {
    return values.reduce(function(acc, param) {
        var answerId = param.id, type = param.type, value = param.value;
        if (answerId) {
            var response = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, responseBase), {
                answerId: answerId
            });
            if (type === "ANSWER" || type === "COMMENT" || variant === "MANY_FIELDS") {
                response.answerText = value;
            }
            return (0,_to_consumable_array/* default */.Z)(acc).concat([
                response
            ]);
        }
        return acc;
    }, []);
};
/** Formats response for DateTime */ var mapDateTimeAnswers = function(// values: ResponseValue<DateTimeAnswerPayload>[],
values, responseBase) {
    return values.reduce(function(acc, param) {
        var answerId = param.id, _value = param.value, date = _value.date, hour = _value.hour, minute = _value.minute, period = _value.period;
        if (answerId) {
            var formattedDate = date !== null && date !== void 0 ? date : undefined;
            var formattedTime = hour && minute && period ? "".concat(hour, ":").concat(minute, " ").concat(period) : undefined;
            return (0,_to_consumable_array/* default */.Z)(acc).concat([
                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, responseBase), {
                    answerId: answerId,
                    answerText: [
                        formattedDate,
                        formattedTime
                    ].join(" ").trim()
                })
            ]);
        }
        return acc;
    }, []);
};
/**
 * Function that maps an individual answer to the shape expected by the API, returned as an array.
 * Reference - expected shapes for each question type:
 * @see https://code.corp.surveymonkey.com/pages/devmonkeys/ResponsesAPI/?shell#the-answer-object
 */ var mapAnswerResponse = function(param, param1, responseBase) {
    var values = param.values, family = param1.family, variant = param1.variant;
    switch(family){
        // single textbox & comment box
        case "OPEN_ENDED":
            {
                switch(variant){
                    case "SINGLE_LINE":
                    case "ESSAY":
                        {
                            var ref;
                            if (!((ref = values[0]) === null || ref === void 0 ? void 0 : ref.value)) {
                                return [];
                            }
                            return [
                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, responseBase), {
                                    answerText: values[0].value
                                })
                            ];
                        }
                    case "MANY_FIELDS":
                        return mapMultipleChoiceAnswers(values, responseBase, variant);
                }
                return []; // needed for no-fallthrough lint rule
            }
        // multiple choice, dropdown, & checkbox (& possibly single/many image choice, may need refinement)
        case "MULTIPLE_CHOICE":
            {
                // same logic for all variants:
                // SINGLE_ANSWER_RADIO, SINGLE_ANSWER_MENU, MANY_ANSWERS_CHECKBOX, SINGLE_ANSWER_IMAGE, MANY_ANSWERS_IMAGE;
                return mapMultipleChoiceAnswers(values, responseBase);
            }
        // presentational questions
        case "PRESENTATION":
            {
                // same for Image and Text
                return [
                    responseBase
                ];
            }
        case "RATING_SCALE":
            {
                switch(variant){
                    case "NPS":
                        {
                            var ref1;
                            if (!((ref1 = values[0]) === null || ref1 === void 0 ? void 0 : ref1.value)) {
                                return [];
                            }
                            var response = [
                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, responseBase), {
                                    answerId: values[0].id,
                                    columnId: values[0].value
                                }), 
                            ];
                            return response;
                        }
                    case "SINGLE_ANSWER_RADIO":
                        {
                            return values.reduce(function(acc, row) {
                                var rowValue = row === null || row === void 0 ? void 0 : row.value;
                                if (!row || !rowValue || !Array.isArray(rowValue)) {
                                    return acc;
                                }
                                if (rowValue[0].type) {
                                    return (0,_to_consumable_array/* default */.Z)(acc).concat([
                                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, responseBase), {
                                            answerId: row.id,
                                            answerText: rowValue[0].value
                                        })
                                    ]);
                                }
                                var response = rowValue.map(function(param) {
                                    var value = param.value;
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, responseBase), {
                                        answerId: row.id,
                                        columnId: value
                                    });
                                });
                                return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)(response));
                            }, []);
                        }
                    default:
                        {
                            // eslint-disable-next-line no-console
                            console.warn("Rating scale variant not implemented: ", variant);
                            return [];
                        }
                }
            }
        // matrix
        case "MATRIX":
            {
                switch(variant){
                    case "MENU":
                    case "MANY_ANSWERS_CHECKBOX":
                    case "SINGLE_ANSWER_RADIO":
                        {
                            return values.reduce(function(acc, row) {
                                var ref;
                                var rowValue = row === null || row === void 0 ? void 0 : row.value;
                                if (!row || !rowValue || !Array.isArray(rowValue)) {
                                    return acc;
                                }
                                // for comment per question
                                if (rowValue[0].type) {
                                    return (0,_to_consumable_array/* default */.Z)(acc).concat([
                                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, responseBase), {
                                            answerId: row.id,
                                            answerText: rowValue[0].value
                                        })
                                    ]);
                                }
                                // for comment per row
                                if ((ref = rowValue[1]) === null || ref === void 0 ? void 0 : ref.type) {
                                    return (0,_to_consumable_array/* default */.Z)(acc).concat([
                                        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, responseBase), {
                                            answerId: row.id,
                                            answerText: rowValue[1].value
                                        })
                                    ]);
                                }
                                var response = rowValue.map(function(param) {
                                    var value = param.value;
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, responseBase), {
                                        answerId: row.id,
                                        columnId: value
                                    });
                                });
                                return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)(response));
                            }, []);
                        }
                    default:
                        {
                            // eslint-disable-next-line no-console
                            console.warn("Matrix variant not implemented: ", variant);
                            return [];
                        }
                }
            }
        // date/time
        case "DATETIME":
            {
                return mapDateTimeAnswers(values, responseBase);
            }
        default:
            {
                // keep this warning while we integrate all Question Types
                // eslint-disable-next-line no-console
                console.warn("Question Type not mapped:", family, variant);
                return [];
            }
    }
};
/**
 *
 * @param questions Array containing questions from current page
 * @param answers Object containing answers for the current page with questionId as the key
 * @param pageId Current survey page that user is responding to
 * @returns an array of responses matching the shape expected by mutation, empty responses discarded.
 */ var mapSurveyAnswersToResponse = function(param) {
    var questions = param.questions, answers = param.answers, pageId = param.pageId;
    return Object.values(answers).reduce(function(responses, answer) {
        /** The base response object containing properties to be included with each response */ var responseBase = {
            pageId: pageId,
            questionId: answer.questionId
        };
        // get the current question for the answer by matching questionId from answer
        var currentQuestion = questions.find(function(q) {
            return q.id === answer.questionId;
        });
        if (!currentQuestion) {
            // this should not happen but just to safe log for debugging
            // eslint-disable-next-line no-console
            console.error("could not find question for Answer", answer);
            return responses;
        }
        var implicitResponse = mapImplicitResponse(currentQuestion);
        if (implicitResponse) {
            responseBase.randomAssignmentId = implicitResponse;
        }
        return (0,_to_consumable_array/* default */.Z)(responses).concat((0,_to_consumable_array/* default */.Z)(mapAnswerResponse(answer, currentQuestion, responseBase)));
    }, []);
};
/* harmony default export */ var helper_mapSurveyAnswersToResponse = ((/* unused pure expression or super */ null && (mapSurveyAnswersToResponse)));

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/constants.ts
/** The maximum number of questions which can display on a page */ var MAX_QUESTIONS_ON_PAGE = 105;
/** The default return values for survey submission */ var DEFAULT_SUBMIT_RESULT = {
    encryptedSmParam: "",
    encryptedSMParamforQuizResults: "",
    success: false,
    userErrors: null,
    respondent: null
};

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/v2/slices/surveySlice.ts
/* eslint-disable no-param-reassign */ 














/** Different views that are designed like a survey page but have different content */ var SurveyView = {
    Taking: "TAKING",
    ThankYou: "THANK_YOU",
    Password: "PASSWORD"
};
var surveySlice_initialState = {
    surveyTakingPayload: undefined,
    survey: undefined,
    activePage: undefined,
    collector: undefined,
    clientToken: undefined,
    questions: {
        items: []
    },
    answers: {},
    surveyView: SurveyView.Taking,
    surveyEndPageUrl: "abc",
    encryptedInstantResultsSmParam: "abc",
    currentPageId: undefined,
    pagePath: undefined,
    collectorKey: undefined,
    encrytedSurveyParams: undefined,
    environment: undefined
};
// ========== SLICE
var surveySlice_sliceName = "survey";
var surveySlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: surveySlice_sliceName,
    initialState: surveySlice_initialState,
    reducers: {
        initEnvironment: function(state, action) {
            state.environment = action.payload;
        },
        initializeSurvey: function(state, action) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
            state.surveyTakingPayload = action.payload;
            state.survey = (ref = action.payload.respondentSession) === null || ref === void 0 ? void 0 : ref.survey;
            state.collector = (ref1 = action.payload.respondentSession) === null || ref1 === void 0 ? void 0 : ref1.collector;
            state.surveyEndPageUrl = (ref2 = action.payload.respondentSession) === null || ref2 === void 0 ? void 0 : ref2.respondent.surveyEndPageUrl;
            state.encryptedInstantResultsSmParam = (ref3 = action.payload.respondentSession) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.respondent) === null || ref4 === void 0 ? void 0 : ref4.encryptedInstantResultsSmParam;
            var _surveyTakingCurrentPage;
            state.activePage = (_surveyTakingCurrentPage = action.payload.surveyTakingCurrentPage) !== null && _surveyTakingCurrentPage !== void 0 ? _surveyTakingCurrentPage : {};
            state.pagePath = action.payload.respondentSession.pagePath;
            state.currentPageId = (ref5 = action.payload.surveyTakingCurrentPage) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.surveyPage) === null || ref6 === void 0 ? void 0 : ref6.id;
            state.questions = (ref7 = action.payload.surveyTakingCurrentPage) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.surveyPage) === null || ref8 === void 0 ? void 0 : ref8.surveyPageQuestions;
            var ref16;
            state.encrytedSurveyParams = (ref16 = (ref9 = action.payload.respondentSession) === null || ref9 === void 0 ? void 0 : ref9.encryptedSmParam) !== null && ref16 !== void 0 ? ref16 : undefined;
            var ref17;
            state.clientToken = (ref17 = (ref10 = action.payload.respondentSession) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.respondent) === null || ref11 === void 0 ? void 0 : ref11.clientToken) !== null && ref17 !== void 0 ? ref17 : undefined;
            var ref18;
            // initialize answers
            state.answers = (ref18 = (ref12 = action.payload.surveyTakingCurrentPage) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.surveyPage) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.surveyPageQuestions) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.items) === null || ref15 === void 0 ? void 0 : ref15.reduce(function(acc, curr) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, curr.id, {
                    questionId: curr.id,
                    values: [],
                    touched: false,
                    isDirty: false
                }));
            }, {})) !== null && ref18 !== void 0 ? ref18 : {};
        },
        setAnswers: function(state, action) {
            state.answers = action.payload;
        },
        setQuestions: function(state, action) {
            state.questions = action.payload;
        },
        setActivePage: function(state, action) {
            var ref;
            var _payload = action.payload, activePage = _payload.activePage, questions = _payload.questions, answers = _payload.answers;
            state.activePage = activePage;
            state.questions = questions;
            state.answers = answers;
            state.currentPageId = activePage === null || activePage === void 0 ? void 0 : (ref = activePage.surveyPage) === null || ref === void 0 ? void 0 : ref.id;
        },
        updateAnswers: function(state, action) {
            var mergedAnswers = (0,_object_spread/* default */.Z)({}, state.answers, action.payload);
            state.answers = mergedAnswers;
        },
        setClientToken: function(state, action) {
            state.clientToken = action.payload;
        },
        setCurrentPageId: function(state, action) {
            state.currentPageId = action.payload;
        },
        setEncrytedSurveyParams: function(state, action) {
            state.encrytedSurveyParams = action.payload;
        },
        setPagePath: function(state, action) {
            state.pagePath = action.payload;
        },
        setCollectorKey: function(state, action) {
            state.collectorKey = action.payload;
        },
        setSurveyView: function(state, action) {
            state.surveyView = action.payload;
        },
        setCookie: function(state, action) {
            var tmp = state.environment, ref = tmp === void 0 ? {} : tmp, domain = ref.domain, tld = ref.tld;
            var _payload = action.payload, name = _payload.name, value = _payload.value, expiration = _payload.expiration;
            js_cookie_default().set(name, value, {
                expires: expiration,
                domain: ".".concat(domain, ".").concat(tld),
                secure: true,
                sameSite: "None"
            });
        },
        surveyComplete: function(state, action) {
            var ref, ref1, ref2, ref3, ref4;
            var ref5;
            var isThankYouEnabled = (ref5 = (ref = state.collector) === null || ref === void 0 ? void 0 : (ref1 = ref.thankYouPage) === null || ref1 === void 0 ? void 0 : ref1.isEnabled) !== null && ref5 !== void 0 ? ref5 : false;
            var ref6;
            var surveyResultsUrl = (ref6 = (ref2 = state.collector) === null || ref2 === void 0 ? void 0 : ref2.surveyResultsUrl) !== null && ref6 !== void 0 ? ref6 : null;
            var _payload = action.payload, smParamForSurveyComplete = _payload.smParamForSurveyComplete, reqLocale = _payload.reqLocale;
            var environment = state.environment;
            var isCurrentViewCustomThankYou = state.surveyView === "THANK_YOU";
            var showQuizResultsPage = ((ref3 = state.survey) === null || ref3 === void 0 ? void 0 : ref3.isQuiz) && ((ref4 = state.survey.quizOptions) === null || ref4 === void 0 ? void 0 : ref4.showResults);
            var showInstantResultsPage = !showQuizResultsPage && surveyResultsUrl;
            var showThankYouView = !showInstantResultsPage && isThankYouEnabled && !isCurrentViewCustomThankYou;
            var surveyEndPageRedirect = !showThankYouView;
            var redirectUrl = null;
            if (showQuizResultsPage) {
                if (surveyResultsUrl) {
                    var _encryptedInstantResultsSmParam;
                    js_cookie_default().set("sm_ir", (_encryptedInstantResultsSmParam = state.encryptedInstantResultsSmParam) !== null && _encryptedInstantResultsSmParam !== void 0 ? _encryptedInstantResultsSmParam : "", {
                        domain: ".".concat(environment === null || environment === void 0 ? void 0 : environment.domain, ".").concat(environment === null || environment === void 0 ? void 0 : environment.tld),
                        secure: true,
                        sameSite: "None"
                    });
                }
                redirectUrl = "/r/quiz/results?sm=".concat(smParamForSurveyComplete, "&lang=").concat(reqLocale);
            } else if (showInstantResultsPage) {
                var _encryptedInstantResultsSmParam1;
                js_cookie_default().set("sm_ir", (_encryptedInstantResultsSmParam1 = state.encryptedInstantResultsSmParam) !== null && _encryptedInstantResultsSmParam1 !== void 0 ? _encryptedInstantResultsSmParam1 : "", {
                    domain: ".".concat(environment === null || environment === void 0 ? void 0 : environment.domain, ".").concat(environment === null || environment === void 0 ? void 0 : environment.tld),
                    secure: true,
                    sameSite: "None"
                });
                redirectUrl = surveyResultsUrl;
            } else if (showThankYouView) {
                state.surveyView = "THANK_YOU";
            } else if (surveyEndPageRedirect) {
                var _surveyEndPageUrl;
                redirectUrl = (_surveyEndPageUrl = state.surveyEndPageUrl) !== null && _surveyEndPageUrl !== void 0 ? _surveyEndPageUrl : null;
            }
            if (redirectUrl) {
                window.location.replace(redirectUrl);
            }
        },
        reset: function() {
            return surveySlice_initialState;
        },
        postSurveyCompleteCleanup: function(state, action) {
            var collectorKey = action.payload.collectorKey;
            js_cookie_default().remove("RE_".concat(collectorKey), {
                path: "/"
            });
            js_cookie_default().remove("REPID_".concat(collectorKey), {
                path: "/"
            });
            window.localStorage.removeItem("answers_".concat(collectorKey));
        }
    }
});
var surveySlice_actions = surveySlice.actions;
// ========== ACTIONS
var initializeSurvey = surveySlice_actions.initializeSurvey, initEnvironment = surveySlice_actions.initEnvironment, setAnswers = surveySlice_actions.setAnswers, setQuestions = surveySlice_actions.setQuestions, setActivePage = surveySlice_actions.setActivePage, updateAnswers = surveySlice_actions.updateAnswers, setClientToken = surveySlice_actions.setClientToken, surveySlice_reset = surveySlice_actions.reset, setSurveyView = surveySlice_actions.setSurveyView, surveyComplete = surveySlice_actions.surveyComplete, setCurrentPageId = surveySlice_actions.setCurrentPageId, setEncrytedSurveyParams = surveySlice_actions.setEncrytedSurveyParams, setPagePath = surveySlice_actions.setPagePath, setCollectorKey = surveySlice_actions.setCollectorKey, setCookie = surveySlice_actions.setCookie, postSurveyCompleteCleanup = surveySlice_actions.postSurveyCompleteCleanup;
// ========== THUNKS
/**
 * Update an answer - the specific answer is inferred by the `questionId` inside the answer object.
 * Error validation is also run for the new answer and the errors state is updated accordingly.
 *
 */ var updateAnswer = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(surveySlice_sliceName, "/updateAnswer"), function(answer, thunkAPI) {
    var ref;
    var questionId = answer.questionId;
    var surveyState = thunkAPI.getState().surveyState;
    var dispatch = thunkAPI.dispatch;
    if (!answer.touched) {
        return; // no need for updates if answer was not touched
    }
    var ref1 = validate(questionId), isValid = ref1.isValid, errors = ref1.errors;
    deferToAfterFocusChanged(function() {
        // defer to make done with error-change click work
        if (!isValid) {
            var questionErrors = transformToSurveyErrors(errors);
            dispatch(setErrorsById({
                id: questionId,
                newErrors: questionErrors
            }));
        } else {
            dispatch(removeErrorsById(questionId));
        }
    });
    var mergedAnswers = (0,_object_spread/* default */.Z)({}, surveyState.answers, (0,_define_property/* default */.Z)({}, questionId, answer));
    var _collectorKey;
    var collectorKey = (_collectorKey = surveyState.collectorKey) !== null && _collectorKey !== void 0 ? _collectorKey : "collectKey";
    var allPageAnswers = (0,_object_spread/* default */.Z)({}, decryptAnswers(collectorKey), mergedAnswers);
    var encryptedAnswers = aes_default().encrypt(JSON.stringify(allPageAnswers), collectorKey || "collectKey").toString();
    window.localStorage.setItem("answers_".concat(collectorKey || "collectKey"), encryptedAnswers);
    var ref2;
    dispatch(updateAnswers((0,_define_property/* default */.Z)({}, questionId, (0,_object_spread/* default */.Z)({}, (ref2 = (ref = surveyState.answers) === null || ref === void 0 ? void 0 : ref[questionId]) !== null && ref2 !== void 0 ? ref2 : {}, answer))));
});
/**
 * Submit the survey response.
 * Currently requires the mutation function to be passed as a parameter as it is generated by hook.
 * Note: dateStarted and dateCompleted also need to be passed in as part of a solution to
 * fix failing integration tests involving mocked timers and promises.
 *  */ // to be updated with responsesAPI integration
var submitSurvey = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(surveySlice_sliceName, "/submit"), function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param, param1) {
        var mutation, dateStarted, dateCompleted, reqLocale, getState, surveyState, ref, ref1, ref2, ref3, ref4, ref5, _answers, ref6, responses, _tmp, _collector, collectorId, isAnonymous, thankYouPage, surveyResultsUrl, _survey, version, _language, surveyLangId, isQuiz, quizOptions, ref7, generateQuizResultsSMParams, _id, ref8, ref9, tmp, submitSurveyResponse, _tmp1, _tmp2, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    mutation = param.mutation, dateStarted = param.dateStarted, dateCompleted = param.dateCompleted, reqLocale = param.reqLocale, getState = param1.getState;
                    surveyState = getState().surveyState;
                    if (!(surveyState.survey && surveyState.collector)) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {};
                    responses = mapSurveyAnswersToResponse((_tmp.questions = (ref5 = (ref = surveyState.activePage) === null || ref === void 0 ? void 0 : (ref1 = ref.surveyPage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.surveyPageQuestions) === null || ref2 === void 0 ? void 0 : ref2.items) !== null && ref5 !== void 0 ? ref5 : [], _tmp.answers = (_answers = surveyState.answers) !== null && _answers !== void 0 ? _answers : {}, _tmp.pageId = (ref6 = (ref3 = surveyState.activePage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.surveyPage) === null || ref4 === void 0 ? void 0 : ref4.id) !== null && ref6 !== void 0 ? ref6 : "", _tmp)); // this typecast is necessary because gql InputMaybe types expect null values, which are not allowed in the response
                    _collector = surveyState.collector, collectorId = _collector.id, isAnonymous = _collector.isAnonymous, thankYouPage = _collector.thankYouPage, surveyResultsUrl = _collector.surveyResultsUrl;
                    _survey = surveyState.survey, version = _survey.version, _language = _survey.language, surveyLangId = _language.id, isQuiz = _survey.isQuiz, quizOptions = _survey.quizOptions;
                    generateQuizResultsSMParams = isQuiz && ((ref7 = quizOptions === null || quizOptions === void 0 ? void 0 : quizOptions.showResults) !== null && ref7 !== void 0 ? ref7 : false);
                    _tmp1 = {};
                    return [
                        4,
                        mutation((_tmp1.variables = {
                            surveyId: (_id = surveyState.survey.id) !== null && _id !== void 0 ? _id : "",
                            input: {
                                collectorId: collectorId,
                                isAnonymous: isAnonymous !== null && isAnonymous !== void 0 ? isAnonymous : false,
                                surveyVersion: version !== null && version !== void 0 ? version : 1,
                                dateStarted: dateStarted,
                                dateCompleted: dateCompleted,
                                respondentId: "",
                                responses: responses,
                                generateQuizResultsSMParams: generateQuizResultsSMParams,
                                surveyLangId: surveyLangId,
                                redirectUrl: surveyState.surveyEndPageUrl,
                                reqLocale: reqLocale,
                                isThankYouEnabled: (ref8 = thankYouPage === null || thankYouPage === void 0 ? void 0 : thankYouPage.isEnabled) !== null && ref8 !== void 0 ? ref8 : false,
                                instantResultsUrl: surveyResultsUrl !== null && surveyResultsUrl !== void 0 ? surveyResultsUrl : null
                            }
                        }, _tmp1))
                    ];
                case 2:
                    _tmp2 = {};
                    ref9 = _state.sent(), tmp = ref9.data, submitSurveyResponse = (tmp === void 0 ? _tmp2 : tmp).submitSurveyResponse;
                    return [
                        2,
                        submitSurveyResponse
                    ];
                case 3:
                    error = _state.sent();
                    // To be completed in server error validation story
                    console.log(error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        DEFAULT_SUBMIT_RESULT
                    ];
            }
        });
    });
    return function(_, _1) {
        return _ref.apply(this, arguments);
    };
}());
// ========== SELECTORS
/** The survey state object */ var selectSurveyState = function(state) {
    return state.surveyState;
};
/** The survey object */ var selectSurvey = (0,reselect_es/* createSelector */.P1)(selectSurveyState, function(surveyState) {
    return surveyState.survey;
});
/** The current page object */ var selectActivePage = (0,reselect_es/* createSelector */.P1)(selectSurveyState, function(surveyState) {
    return surveyState.activePage;
});
/** The collector object */ var selectCollector = (0,reselect_es/* createSelector */.P1)(selectSurveyState, function(surveyState) {
    return surveyState.collector;
});
/** The client token */ var selectClientToken = (0,reselect_es/* createSelector */.P1)(selectSurveyState, function(surveyState) {
    return surveyState.clientToken;
});
var selectSurveyView = (0,reselect_es/* createSelector */.P1)(selectSurveyState, function(surveyState) {
    return surveyState.surveyView;
});
var surveySlice_ref;
/** The survey format (eg. classic or OQAAT) */ var selectSurveyFormat = (0,reselect_es/* createSelector */.P1)(selectSurvey, function(survey) {
    return (surveySlice_ref = survey === null || survey === void 0 ? void 0 : survey.format) !== null && surveySlice_ref !== void 0 ? surveySlice_ref : SurveyFormat.ONE_QUESTION_AT_A_TIME;
});
/** Object containing all answers for the current page */ var selectAnswers = (0,reselect_es/* createSelector */.P1)(selectSurveyState, function(surveyState) {
    return surveyState.answers;
});
/** Object containing all answers for the current page */ var selectQuestions = (0,reselect_es/* createSelector */.P1)(selectSurveyState, function(surveyState) {
    return surveyState.questions;
});
/** The answer object for the question specified by Id */ var selectAnswerById = (0,reselect_es/* createSelector */.P1)([
    selectAnswers,
    function(_, questionId) {
        return questionId;
    }
], function(answers, questionId) {
    return answers === null || answers === void 0 ? void 0 : answers[questionId];
});
/**
 * The total number of questions that have a value (i.e. answered), on the current page
 * note: currently only works with single-value questions
 * TODO: refactor to include answered questions on other pages once we get that data from the backend
 *  */ var selectTotalAnswers = (0,reselect_es/* createSelector */.P1)(selectAnswers, function(answers) {
    return !answers ? 0 : Object.values(answers).reduce(function(acc, answer) {
        var ref, ref1;
        return ((ref = answer.values) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.value) ? acc + 1 : acc;
    }, 0);
});
var selectPagePath = (0,reselect_es/* createSelector */.P1)(selectSurveyState, function(surveyState) {
    return surveyState.pagePath;
});
var selectCurrentPageId = (0,reselect_es/* createSelector */.P1)(selectSurveyState, function(surveyState) {
    var ref, ref1;
    return (ref = surveyState.activePage) === null || ref === void 0 ? void 0 : (ref1 = ref.surveyPage) === null || ref1 === void 0 ? void 0 : ref1.id;
});
var selectCollectorKey = (0,reselect_es/* createSelector */.P1)(selectSurveyState, function(surveyState) {
    return surveyState.collectorKey;
});
var selectEncrytedSurveyParams = (0,reselect_es/* createSelector */.P1)(selectSurveyState, function(surveyState) {
    return surveyState.encrytedSurveyParams;
});
// ========== EXPORT
/* harmony default export */ var slices_surveySlice = (surveySlice.reducer);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/SurveyFormatView.tsx








function SurveyFormatViewFactory(_param) {
    var name = _param.name, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name"
    ]);
    var format = useAppSelectorV2(selectSurveyFormat);
    var View = react.useMemo(function() {
        switch(format){
            case SurveyFormat.ONE_QUESTION_AT_A_TIME:
                {
                    return OQAATView;
                }
            case SurveyFormat.CLASSIC:
            default:
                {
                    return ClassicView;
                }
        }
    }, [
        format
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(View, (0,_object_spread/* default */.Z)({
        name: name
    }, props));
}
/* harmony default export */ var SurveyFormatView = (SurveyFormatViewFactory);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/types/view.ts


;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/types/index.ts


;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyFormat/index.ts








;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/errors/helpers/sortByQuestionOrder.ts
/** Helper to sort by `questionOrder` (if it exists and both questionIds exist in it) */ var sortByQuestionOrder = function(order) {
    return function(param, param1) {
        var a = param.questionId, b = param1.questionId;
        if (!order || !a || !b || !order.includes(a) || !order.includes(b)) {
            return 0;
        }
        return order.indexOf(a) - order.indexOf(b);
    };
};
/* harmony default export */ var helpers_sortByQuestionOrder = ((/* unused pure expression or super */ null && (sortByQuestionOrder)));

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/v2/slices/errorsSlice.ts
/* eslint-disable no-param-reassign */ 









var errorsSlice_initialState = {
    meta: {},
    groups: defaultErrorGroups,
    errors: [],
    questionOrder: []
};
// ========== SLICE
var errorsSlice_sliceName = "errors";
var errorsSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: errorsSlice_sliceName,
    initialState: errorsSlice_initialState,
    reducers: {
        setMeta: function(state, action) {
            state.meta = action.payload;
        },
        addError: function(state, action) {
            state.errors = (0,_to_consumable_array/* default */.Z)(state.errors).concat([
                action.payload
            ]).sort(sortByQuestionOrder(state.questionOrder));
        },
        setErrors: function(state, param) {
            var errors = param.payload;
            state.errors = errors.sort(sortByQuestionOrder(state.questionOrder));
        },
        setErrorsById: function(state, action) {
            var _payload = action.payload, id = _payload.id, newErrors = _payload.newErrors;
            var ids = Array.isArray(id) ? id : [
                id
            ];
            state.errors = (0,_to_consumable_array/* default */.Z)(state.errors.filter(function(e) {
                return !ids.includes(e.questionId);
            })).concat((0,_to_consumable_array/* default */.Z)(newErrors)).sort(sortByQuestionOrder(state.questionOrder));
        },
        removeErrorsById: function(state, param) {
            var id = param.payload;
            var ids = Array.isArray(id) ? id : [
                id
            ];
            state.errors = state.errors.filter(function(e) {
                return !ids.includes(e.questionId);
            });
        },
        removeErrorsByType: function(state, param) {
            var type = param.payload;
            var types = Array.isArray(type) ? type : [
                type
            ];
            state.errors = state.errors.filter(function(e) {
                return !types.includes(e.code);
            }).sort(sortByQuestionOrder(state.questionOrder));
        },
        setQuestionOrder: function(state, action) {
            state.questionOrder = action.payload;
        },
        reset: function() {
            return errorsSlice_initialState;
        }
    },
    // extraReducers allow us to listen to actions from other slices and update this slice's state accordingly.
    // https://redux-toolkit.js.org/api/createslice#extrareducers
    extraReducers: {
        // update questionOrder when the survey is initialized
        // `survey/initializeSurvey` is the same as `initializeSurvey.type` from `surveySlice.ts`
        // needed to be hardcoded to break circular dependency
        "survey/initializeSurvey": function(state, action) {
            var ref, ref1, ref2, ref3;
            state.questionOrder = ((ref = action.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.surveyTakingCurrentPage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.surveyPage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.surveyPageQuestions) === null || ref3 === void 0 ? void 0 : ref3.items.map(function(q) {
                return q.id;
            })) || [];
        }
    }
});
var errorsSlice_actions = errorsSlice.actions;
// ========== ACTIONS
var setMeta = errorsSlice_actions.setMeta, addError = errorsSlice_actions.addError, setErrors = errorsSlice_actions.setErrors, setErrorsById = errorsSlice_actions.setErrorsById, removeErrorsById = errorsSlice_actions.removeErrorsById, removeErrorsByType = errorsSlice_actions.removeErrorsByType, setQuestionOrder = errorsSlice_actions.setQuestionOrder, errorsSlice_reset = errorsSlice_actions.reset;
// ========== THUNKS
/** Focus the first question which has a validation error */ var focusFirstQuestionError = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(errorsSlice_sliceName, "/focusFirstQuestionError"), function(_, thunkAPI) {
    var ref;
    var ref1 = thunkAPI.getState(), errorsState = ref1.errorsState, survey = ref1.surveyState.survey;
    var validationErrors = errorsState.errors.filter(function(e) {
        return errorsState.groups.validation.includes(e.code);
    });
    var firstError = (validationErrors === null || validationErrors === void 0 ? void 0 : (ref = validationErrors[0]) === null || ref === void 0 ? void 0 : ref.questionId) || null;
    if (firstError) {
        requestAnimationFrame(function() {
            setFocusToView(firstError, true, errorsState.questionOrder, (survey === null || survey === void 0 ? void 0 : survey.format) === "CLASSIC");
        });
    }
});
/** Run error validation for all questions on the page */ var validatePage = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(errorsSlice_sliceName, "/validatePage"), function(_, thunkAPI) {
    var ref = runValidators(), isValid = ref.isValid, errors = ref.errors;
    var errorsState = thunkAPI.getState().errorsState;
    var dispatch = thunkAPI.dispatch;
    if (!isValid) {
        // temporary while aligning error-shape between Server and SMQ
        var questionErrors = errors_transformToSurveyErrors(errors);
        var questionIds = questionErrors.map(function(a) {
            return a.questionId;
        });
        dispatch(setErrorsById({
            id: questionIds,
            newErrors: questionErrors
        }));
    } else {
        dispatch(removeErrorsByType(errorsState.groups.validation));
    }
    return isValid;
});
/** Update the question order array based on the current page in store */ var updateQuestionOrder = (0,redux_toolkit_esm/* createAsyncThunk */.hg)("".concat(errorsSlice_sliceName, "/updateQuestionOrder"), function(_, thunkAPI) {
    var ref, ref1, ref2;
    var surveyState = thunkAPI.getState().surveyState;
    var dispatch = thunkAPI.dispatch;
    dispatch(setQuestionOrder(((ref = surveyState.activePage) === null || ref === void 0 ? void 0 : (ref1 = ref.surveyPage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.surveyPageQuestions) === null || ref2 === void 0 ? void 0 : ref2.items.map(function(q) {
        return q.id;
    })) || []));
});
// ========== SELECTORS
/** The errors state object */ var selectErrorsState = function(state) {
    return state.errorsState;
};
/** The list of errors that currently exist in the survey */ var selectErrors = (0,reselect_es/* createSelector */.P1)(selectErrorsState, function(errorsState) {
    return errorsState.errors;
});
/** Error codes grouped by category */ var selectErrorGroups = (0,reselect_es/* createSelector */.P1)(selectErrorsState, function(errorsState) {
    return errorsState.groups;
});
/** Error metadata */ var selectMeta = (0,reselect_es/* createSelector */.P1)(selectErrorsState, function(errorsState) {
    return errorsState.meta;
});
var selectHasNoErrors = (0,reselect_es/* createSelector */.P1)(selectErrors, function(errors) {
    return errors.length === 0;
});
var selectHasVersionChanged = (0,reselect_es/* createSelector */.P1)(selectErrors, function(errors) {
    return errors.some(function(param) {
        var code = param.code;
        return code === ErrorType.INVALID_SURVEY_VERSION;
    });
});
var selectHasNotFoundErrors = (0,reselect_es/* createSelector */.P1)([
    selectErrors,
    selectErrorGroups
], function(errors, groups) {
    return errors.some(function(param) {
        var code = param.code;
        return groups.notFound.includes(code);
    });
});
var selectHasRedirectErrors = (0,reselect_es/* createSelector */.P1)([
    selectErrors,
    selectErrorGroups
], function(errors, groups) {
    return errors.some(function(param) {
        var code = param.code;
        return groups.redirect.includes(code);
    });
});
var selectHasValidationErrors = (0,reselect_es/* createSelector */.P1)([
    selectErrors,
    selectErrorGroups
], function(errors, groups) {
    return errors.some(function(param) {
        var code = param.code;
        return groups.validation.includes(code);
    });
});
var selectHasGoneErrors = (0,reselect_es/* createSelector */.P1)([
    selectErrors,
    selectErrorGroups
], function(errors, groups) {
    return errors.some(function(param) {
        var code = param.code;
        return groups.gone.includes(code);
    });
});
var selectHasCannedErrors = (0,reselect_es/* createSelector */.P1)(selectErrors, function(errors) {
    return errors.some(function(param) {
        var code = param.code;
        return code === ErrorType.SURVEY_CANNED;
    });
});
var selectHasBadRequestErrors = (0,reselect_es/* createSelector */.P1)([
    selectErrors,
    selectErrorGroups
], function(errors, groups) {
    return errors.some(function(param) {
        var code = param.code;
        return groups.badRequest.includes(code);
    });
});
var selectHasUnknownErrors = (0,reselect_es/* createSelector */.P1)([
    selectErrors,
    selectErrorGroups
], function(errors, groups) {
    return errors.some(function(param) {
        var code = param.code;
        return !Object.values(groups).flat().includes(code);
    });
});
/** The list of errors for the question specified by Id */ // createSelector generates a memoized selector - useful in cases where the the return value will
// always trigger a re-render, eg. filter() or map() which always return a new array reference.
// https://redux.js.org/usage/deriving-data-selectors#createselector-overview
// It can be passed arguments by passing in additional "selectors" in the first argument as an array.
// The return values of each input selector are the arguments passed to the memoized selector.
// https://redux.js.org/usage/deriving-data-selectors#passing-input-parameters
var selectErrorsById = (0,reselect_es/* createSelector */.P1)([
    selectErrors,
    function(_, id) {
        return id;
    }
], function(errors, id) {
    return errors.filter(function(e) {
        return e.questionId === id;
    });
}, {
    memoizeOptions: {
        // Deep equality check for the result array, needed since a new array is returned each time
        resultEqualityCheck: isEqual/* default */.Z,
        // Cache size for unique selector instances. Since this selector is used in multiple
        // components simultaneously, this preserves memoization which would be lost otherwise.
        // Currently set to 105 for the maximum number of questions - may need to be updated in future
        maxSize: MAX_QUESTIONS_ON_PAGE
    }
});
/** The list of errors that exist for the specified type */ var selectErrorsByType = (0,reselect_es/* createSelector */.P1)([
    selectErrors,
    function(_, type) {
        return type;
    }
], function(errors, type) {
    var types = Array.isArray(type) ? type : [
        type
    ];
    return errors.filter(function(e) {
        return types.includes(e.code);
    });
});
/** The meta info from an error */ var selectErrorMetaByType = (0,reselect_es/* createSelector */.P1)([
    selectErrors,
    selectMeta,
    function(_, type) {
        return type;
    }
], function(errors, meta, type) {
    var types = Array.isArray(type) ? type : [
        type
    ];
    var errorType = errors.filter(function(e) {
        return types.includes(e.code);
    })[0];
    if (errorType) {
        var _code;
        var defaultMeta = (_code = meta[errorType.code]) !== null && _code !== void 0 ? _code : {};
        return (0,_object_spread/* default */.Z)({}, defaultMeta, errorType.meta);
    }
    return null;
});
// ========== EXPORT
/* harmony default export */ var slices_errorsSlice = (errorsSlice.reducer);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/hooks/useVerifySurveyVersion.ts








/**
 * Query the survey version and check if it has changed
 * @returns {boolean} true if the survey version has changed, false otherwise
 */ var verifySurveyVersion = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apolloClient, survey, clientToken) {
        var ref, ref1, surveyVersion, _tmp, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    _tmp = {};
                    return [
                        4,
                        apolloClient.query((_tmp.query = (SurveyVersionV2_graphql_default()), _tmp.variables = {
                            surveyId: (ref = survey === null || survey === void 0 ? void 0 : survey.id) !== null && ref !== void 0 ? ref : ""
                        }, _tmp.context = {
                            headers: {
                                "x-client-token": clientToken
                            }
                        }, _tmp.// prevent cached survey version from being used
                        fetchPolicy = "network-only", _tmp))
                    ];
                case 1:
                    ref1 = _state.sent(), surveyVersion = ref1.data.surveyVersion;
                    if (surveyVersion !== (survey === null || survey === void 0 ? void 0 : survey.version)) {
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        2,
                        false
                    ];
                case 2:
                    error = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        false
                    ];
            }
        });
    });
    return function verifySurveyVersion(apolloClient, survey, clientToken) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Hook that returns a function which will query the current survey version and apply
 * version changed errors if necessary
 */ var useVerifySurveyVersion = function() {
    var survey = useAppSelectorV2(selectSurvey);
    var clientToken = useAppSelectorV2(selectClientToken);
    var dispatch = useAppDispatchV2();
    /** Reference to the main apolloClient */ var apolloClient = (0,react_hooks_esm/* useApolloClient */.xJ)();
    var verify = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var versionChanged, _tmp;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            verifySurveyVersion(apolloClient, survey, clientToken)
                        ];
                    case 1:
                        versionChanged = _state.sent();
                        _tmp = {};
                        if (versionChanged) {
                            dispatch(addError((_tmp.code = ErrorType.INVALID_SURVEY_VERSION, _tmp.detail = "", _tmp.questionId = null, _tmp.field = null, _tmp)));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function verify() {
            return _ref.apply(this, arguments);
        };
    }();
    return verify;
};

// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./src/app/components/core/BypassBlock/useStyles.ts

var useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    return {
        skipLinks: {
            fontFamily: theme.type.fontFamily.base,
            fontSize: theme.type.fontSize.body,
            fontWeight: theme.type.fontWeight.medium,
            top: 0,
            left: 0,
            zIndex: 999999,
            overflow: "hidden",
            position: "absolute",
            clip: "rect(0 0 0 0)",
            width: "1px",
            height: "1px",
            padding: [
                0
            ],
            "&:focus-within": {
                position: "fixed",
                clip: "auto",
                width: "100%",
                height: "auto",
                padding: [
                    10
                ]
            },
            backgroundColor: "#fff",
            // add spacing between multiple skip links
            "& > a": {
                marginRight: "8px",
                color: theme.palette.text.link,
                textDecoration: "underline",
                "&:hover, &:focus": {
                    outlineOffset: 2,
                    outline: "2px solid ".concat(theme.palette.text.link)
                }
            }
        }
    };
});
/* harmony default export */ var BypassBlock_useStyles = (useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/core/BypassBlock/BypassBlock.tsx







/**
 * BypassBlock for accessible skip links
 * @example
 * ```ts
 * <BypassBlock className={optionalOverrideClasses}>
 *   <a href="#main-content">Skip to Content</a>
 * </BypassBlock>
 * // ...
 * <main id="main-content" />
 * ```
 */ function BypassBlock(_param) {
    var children = _param.children, className = _param.className, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    var skipLinks = BypassBlock_useStyles().skipLinks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()(skipLinks, className)
    }, restProps), {
        children: children
    }));
}
/* harmony default export */ var BypassBlock_BypassBlock = (BypassBlock);

;// CONCATENATED MODULE: ./src/app/components/core/BypassBlock/index.ts


// EXTERNAL MODULE: ./node_modules/@wds/utils/dist/index.es.js
var index_es = __webpack_require__(5420);
;// CONCATENATED MODULE: ./src/app/components/core/RichText/useStyles.ts



var listSpacing = {
    margin: [
        16,
        0
    ],
    padding: [
        0,
        0,
        0,
        40
    ]
};
var mediaReset = {
    border: 0,
    maxWidth: "100%"
};
var RichText_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)({
    richTextContent: {
        // Typography
        "& a": {
            // Links are not themed by default. Users must select a link color in the editor
            color: "blue",
            textDecoration: "underline",
            "&:hover": {
                cursor: "pointer"
            },
            "&:focus": {
                outline: "currentColor auto 1px"
            }
        },
        "& ol": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, listSpacing), {
            listStyleType: "decimal"
        }),
        "& ul": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, listSpacing), {
            listStyle: "disc outside none",
            "& ul li": {
                listStyle: "circle"
            }
        }),
        "& p": {
            margin: [
                13,
                0
            ]
        },
        "& b": {
            fontWeight: "bold"
        },
        "& strong": {
            fontWeight: "bold"
        },
        "& em": {
            fontStyle: "italic"
        },
        "& i": {
            fontStyle: "italic"
        },
        "& big": {
            fontSize: "larger"
        },
        "& small": {
            fontSize: "smaller"
        },
        "& sup": {
            fontSize: "75%",
            lineHeight: 0,
            position: "relative",
            top: "-0.5em",
            verticalAlign: "baseline"
        },
        // Media embeds
        "& iframe": mediaReset,
        "& img": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mediaReset), {
            height: "auto",
            "-ms-interpolation-mode": "bicubic"
        }),
        "& span[data-tooltip]": {
            position: "relative",
            display: "inline",
            borderBottom: [
                [
                    1,
                    "dashed"
                ]
            ],
            textDecoration: "inherit",
            cursor: "pointer"
        }
    }
});
/* harmony default export */ var RichText_useStyles = (RichText_useStyles_useStyles);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/@wds/styles/dist/index.es.js
var dist_index_es = __webpack_require__(4779);
;// CONCATENATED MODULE: ./src/app/components/core/Tooltip/useStyles.ts



var Tooltip_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    var ref;
    var _obj;
    return {
        tooltip: (_obj = {
            "span[data-tooltip] &": {
                display: "none"
            }
        }, (0,_define_property/* default */.Z)(_obj, "@media (min-width: ".concat((ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref.md.min, ")"), {
            "span[data-tooltip]:hover &, span[data-tooltip]:focus &": {
                display: "inline-block"
            }
        }), (0,_define_property/* default */.Z)(_obj, "position", "absolute"), (0,_define_property/* default */.Z)(_obj, "left", function(param) {
            var center = param.center;
            return center;
        }), (0,_define_property/* default */.Z)(_obj, "bottom", 20), (0,_define_property/* default */.Z)(_obj, "width", 275), (0,_define_property/* default */.Z)(_obj, "transform", "translate(-50%, -5px)"), (0,_define_property/* default */.Z)(_obj, "textAlign", "center"), (0,_define_property/* default */.Z)(_obj, "zIndex", 12), (0,_define_property/* default */.Z)(_obj, "fontSize", 13), (0,_define_property/* default */.Z)(_obj, "&:after", {
            position: "absolute",
            bottom: -4,
            left: "50%",
            width: 10,
            height: 10,
            backgroundColor: "white",
            content: '""',
            marginLeft: -5,
            transform: "rotate(45deg)",
            boxShadow: [
                [
                    3,
                    5,
                    5,
                    "rgb(0 0 0 / 0.07)"
                ]
            ],
            zIndex: 13
        }), _obj),
        tooltipBody: {
            display: "inline-block",
            maxWidth: 275,
            color: "black",
            fontWeight: 300,
            fontFamily: dist_index_es/* WrenchTheme.type.fontFamily.base */.Qb.type.fontFamily.base,
            fontStyle: "normal",
            boxShadow: [
                [
                    0,
                    2,
                    10,
                    0,
                    "rgb(0 0 0 / 0.14)"
                ]
            ],
            background: "white",
            padding: [
                [
                    12,
                    16
                ]
            ],
            lineHeight: 1.4,
            borderRadius: 2,
            textAlign: "left"
        }
    };
});
/* harmony default export */ var Tooltip_useStyles = (Tooltip_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/core/Tooltip/Modal/useStyles.ts

var Modal_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    return {
        modalOverlay: {
            zIndex: 999,
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end"
        },
        modal: {
            position: "relative",
            width: "85vw",
            minHeight: "20vw",
            marginBottom: 20,
            background: theme.palette.background.light,
            borderRadius: 2
        },
        closeBtn: {
            position: "absolute",
            cursor: "pointer",
            background: theme.palette.transparent,
            right: 0,
            border: 0,
            padding: 8,
            marginTop: 0,
            color: "black",
            zIndex: 105
        },
        tooltipText: {
            color: theme.palette.text.dark,
            fontFamily: theme.type.fontFamily.base,
            fontSize: 13,
            fontWeight: 400,
            lineHeight: "1.4",
            padding: [
                28,
                12,
                16
            ]
        }
    };
});
/* harmony default export */ var Modal_useStyles = (Modal_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/core/FocusTrap/FocusTrap.tsx


var focusableSelectors = [
    "a[href]",
    "button",
    "textarea",
    'input:not([type="hidden"])',
    "select",
    '[tabindex]:not([tabindex="-1"])', 
];
var FocusTrap = function(param) {
    var children = param.children;
    var modalRef = (0,react.useRef)(null);
    var handleKeyDown = function(event) {
        var ref;
        if (event.key !== "Tab") return;
        var focusableModalElements = (ref = modalRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll(focusableSelectors.join(", "));
        if (focusableModalElements) {
            var firstFocusableElement = focusableModalElements[0];
            var lastFocusableElement = focusableModalElements[focusableModalElements.length - 1];
            if (event.shiftKey && event.target === firstFocusableElement) {
                // handle focus back from first element
                event.preventDefault();
                lastFocusableElement === null || lastFocusableElement === void 0 ? void 0 : lastFocusableElement.focus();
            } else if (!event.shiftKey && event.target === lastFocusableElement) {
                // handle focus fwd from last element
                event.preventDefault();
                firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus();
            }
        }
    };
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: modalRef,
        onKeyDown: handleKeyDown,
        children: children
    }));
};
/* harmony default export */ var FocusTrap_FocusTrap = (FocusTrap);

;// CONCATENATED MODULE: ./src/app/components/core/FocusTrap/withFocusTrap.tsx




var withFocusTrap = function(Component) {
    return function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FocusTrap_FocusTrap, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, props))
        });
    };
};
/* harmony default export */ var FocusTrap_withFocusTrap = (withFocusTrap);

;// CONCATENATED MODULE: ./src/app/components/core/FocusTrap/index.ts



;// CONCATENATED MODULE: ./src/app/components/core/Tooltip/Modal/Modal.tsx






var COPY = (0,dist/* defineMessages */.vU)({
    CLOSE_MODAL: {
        id: "core.Modal.CloseModal",
        defaultMessage: "Close tooltip",
        description: "[Type: label][Vis: Med] - close button text"
    }
});
var Modal = function(param) {
    var tooltip = param.tooltip, closeModal = param.closeModal;
    var ref = Modal_useStyles(), modalOverlay = ref.modalOverlay, closeBtn = ref.closeBtn, modal = ref.modal, tooltipText = ref.tooltipText;
    var closeRef = react.useRef(null);
    var tooltipId = (0,index_es/* uniqueId */.EL)("tooltip-modal");
    var handleClick = function(e) {
        // click on button or overlay should close modal
        e.stopPropagation();
        if (e.currentTarget === e.target) {
            closeModal();
        }
    };
    react.useEffect(function() {
        // listen for ESC to close modal
        var handleKeydown = function(e) {
            if (e.key === "Escape") {
                e.stopPropagation();
                closeModal();
            }
        };
        document.addEventListener("keydown", handleKeydown);
        return function() {
            document.removeEventListener("keydown", handleKeydown);
        };
    }, [
        closeModal
    ]);
    react.useEffect(function() {
        var ref;
        (ref = closeRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: modalOverlay,
        onClick: handleClick,
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: modal,
            role: "dialog",
            "aria-modal": "true",
            "aria-describedby": tooltipId,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: closeBtn,
                    ref: closeRef,
                    onClick: handleClick,
                    "aria-label": (0,dist.t)(COPY.CLOSE_MODAL),
                    children: "\xd7"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    id: tooltipId,
                    className: tooltipText,
                    children: tooltip
                })
            ]
        })
    });
};
/* harmony default export */ var Modal_Modal = (FocusTrap_withFocusTrap(Modal));

;// CONCATENATED MODULE: ./src/app/components/core/Tooltip/Modal/index.ts


;// CONCATENATED MODULE: ./src/app/components/core/Tooltip/Tooltip.tsx








/** Displays a tooltip on hover for large screens and a modal on click for small screens */ function Tooltip(param) {
    var container = param.container, className = param.className, _id = param.id, id = _id === void 0 ? "" : _id;
    /** container center position to display tooltip */ var center = container.offsetWidth / 2;
    var ref;
    var text = (ref = container.getAttribute("data-tooltip")) !== null && ref !== void 0 ? ref : "";
    var theme = (0,context/* useSurveyTheme */.u7)();
    var ref1 = Tooltip_useStyles({
        center: center
    }), tooltip = ref1.tooltip, tooltipBody = ref1.tooltipBody;
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showModal = ref2[0], setShowModal = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState("TOOLTIP"), 2), mode = ref3[0], setMode = ref3[1];
    var closeModal = function() {
        setShowModal(false);
        container.focus();
    };
    react.useEffect(function() {
        container.setAttribute("role", "tooltip");
        // make tooltip anchor focusable
        if (!container.hasAttribute("tabIndex")) {
            container.setAttribute("tabIndex", "0");
        }
        // opens modal if matches small screen breakpoint
        var openModal = function() {
            var ref;
            var _min;
            var mql = window.matchMedia("(max-width: ".concat((_min = theme === null || theme === void 0 ? void 0 : (ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref.md.min) !== null && _min !== void 0 ? _min : "769px", ")"));
            if (mql.matches) {
                setMode("MODAL");
                setShowModal(true);
            } else {
                setMode("TOOLTIP");
            }
        };
        var handleClick = function() {
            openModal();
        };
        var handleKeydown = function(e) {
            if (e.code === "Enter" || e.code === "Space") {
                e.preventDefault();
                e.stopPropagation();
                openModal();
            }
        };
        // listen for click, ENTER or SPACE to open modal
        container.addEventListener("click", handleClick);
        container.addEventListener("keydown", handleKeydown);
        return function() {
            container.removeEventListener("click", handleClick);
            container.removeEventListener("keydown", handleKeydown);
        };
    }, [
        container,
        mode,
        showModal,
        theme
    ]);
    var modalEl = showModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal, {
        tooltip: text,
        closeModal: closeModal
    }) : null;
    var tooltipEl = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(tooltip, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            id: id,
            className: tooltipBody,
            "aria-hidden": "true",
            children: text
        })
    });
    var child = mode === "MODAL" ? modalEl : tooltipEl;
    var containerEl = mode === "MODAL" ? document.body : container;
    return /*#__PURE__*/ react_dom.createPortal(child, containerEl);
}
/* harmony default export */ var Tooltip_Tooltip = (Tooltip);

;// CONCATENATED MODULE: ./src/app/components/core/Tooltip/index.ts


;// CONCATENATED MODULE: ./src/app/components/core/RichText/RichText.tsx









// Support iframe video embeds and their matching attributes
var sanitizeOptions = {
    ADD_TAGS: [
        "iframe"
    ],
    ADD_ATTR: [
        "target",
        "allow",
        "allowfullscreen",
        "frameborder",
        "sandbox",
        "scrolling"
    ]
};
function RichText(_param) {
    var elementId = _param.id, tmp = _param.element, Element = tmp === void 0 ? "div" : tmp, text = _param.text, className = _param.className, containerProps = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "element",
        "text",
        "className"
    ]);
    var ref = (0,react.useState)([]), tooltipNodes = ref[0], setTooltipNodes = ref[1];
    var richTextContent = RichText_useStyles().richTextContent;
    var tooltipRef = react.useRef(null);
    react.useEffect(function() {
        if (tooltipRef === null || tooltipRef === void 0 ? void 0 : tooltipRef.current) {
            var el = tooltipRef === null || tooltipRef === void 0 ? void 0 : tooltipRef.current;
            setTooltipNodes(Array.from(el.querySelectorAll("[data-tooltip]")));
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, (0,_object_spread/* default */.Z)({
                id: elementId,
                className: classnames_default()(richTextContent, className),
                dangerouslySetInnerHTML: {
                    __html: (0,utils_dist.sanitizeString)(text, sanitizeOptions)
                },
                ref: tooltipRef,
                translate: "no"
            }, containerProps)),
            tooltipNodes.map(function(container) {
                var id = (0,index_es/* uniqueId */.EL)("rich-text-tooltip");
                container.setAttribute("aria-describedby", id);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip, {
                    container: container,
                    id: id
                }, id);
            })
        ]
    });
}
/* harmony default export */ var RichText_RichText = (RichText);

;// CONCATENATED MODULE: ./src/app/components/core/RichText/index.ts


;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyTitleV2/useStyles.ts



var useStyles_ref;
var useSurveyStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    return {
        surveyTitle: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            color: (useStyles_ref = theme === null || theme === void 0 ? void 0 : theme.titleColor) !== null && useStyles_ref !== void 0 ? useStyles_ref : "#00bf6f",
            lineHeight: 1.25,
            paddingBottom: 24,
            margin: 0,
            textAlign: function(param) {
                var align = param.align;
                return align.toLowerCase();
            }
        }, theme === null || theme === void 0 ? void 0 : theme.surveyTitle), {
            // reset font weight changed by the theme above
            "& strong": {
                fontWeight: "bold !important"
            }
        })
    };
});
/* harmony default export */ var SurveyTitleV2_useStyles = (useSurveyStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyTitleV2/SurveyTitleV2.tsx






var SurveyTitleV2 = function(_param) {
    var id = _param.id, _element = _param.element, element = _element === void 0 ? "h1" : _element, text = _param.text, _align = _param.align, align = _align === void 0 ? "LEFT" : _align, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "element",
        "text",
        "align"
    ]);
    var surveyTitle = SurveyTitleV2_useStyles({
        align: align
    }).surveyTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText_RichText, (0,_object_spread/* default */.Z)({
        id: id,
        element: element,
        text: text,
        className: surveyTitle,
        "data-testid": "SurveyTitleV2__Title"
    }, otherProps));
};
/* harmony default export */ var SurveyTitleV2_SurveyTitleV2 = (SurveyTitleV2);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyTitleV2/index.ts


;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/helper/createHeadingLevel.tsx
/* eslint-disable no-param-reassign */ /**
 * Cascade Headings
 * Always start with an H1 heading level element.
 * If SurveyTitle is not enabled, PageTitle will become H1
 * If both Titles are not enabled, the effect cascades down.
 *
 * @see https://gist.github.com/t-schemmer/f7591f8eff678c3af274c90f0cf9f86a
 */ var createHeadingLevel = function() {
    var initial = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var headingLevel = initial;
    return function() {
        var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, reset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (headingLevel === 0 && offset <= 0 || offset > 1) {
            offset = 1;
        }
        if (reset) {
            headingLevel = 1;
        }
        headingLevel = Math.max(headingLevel === 0 ? 1 : 2, Math.min(headingLevel + offset, 6));
        return "h".concat(headingLevel);
    };
};
/* harmony default export */ var helper_createHeadingLevel = (createHeadingLevel);

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Logos/index.js + 3 modules
var Logos = __webpack_require__(7120);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/index.js + 1 modules
var SurveyTheme = __webpack_require__(4693);
;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyLink/useStyles.ts

var decorationMap = new Map([
    [
        "auto",
        {
            default: "none",
            focus: "underline"
        }
    ],
    [
        "always",
        {
            default: "underline",
            focus: "underline"
        }
    ],
    [
        "never",
        {
            default: "none",
            focus: "none"
        }
    ],
    [
        "inverse",
        {
            default: "underline",
            focus: "none"
        }
    ], 
]);
var SurveyLink_useStyles_ref, ref1;
var SurveyLink_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    return {
        surveyAnchor: {
            "-webkit-font-smoothing": "antialiased",
            fontFamily: "inherit",
            fontSize: "inherit",
            fontWeight: 400,
            color: theme.questionColor,
            textDecoration: function(param) {
                var underline = param.underline;
                var ref1;
                return (SurveyLink_useStyles_ref = (ref1 = decorationMap.get(underline)) === null || ref1 === void 0 ? void 0 : ref1.default) !== null && SurveyLink_useStyles_ref !== void 0 ? SurveyLink_useStyles_ref : "none";
            },
            "&:hover, &:focus": {
                textDecoration: function(param) {
                    var underline = param.underline;
                    var ref;
                    return (ref1 = (ref = decorationMap.get(underline)) === null || ref === void 0 ? void 0 : ref.focus) !== null && ref1 !== void 0 ? ref1 : "underline";
                },
                outlineOffset: 1,
                outline: "1px solid ".concat(theme.answerColor),
                // Safari seems to have an outline bug, may not render without boxshadow
                boxShadow: "0 0 1px transparent"
            }
        }
    };
});
/* harmony default export */ var SurveyLink_useStyles = (SurveyLink_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyLink/SurveyLink.tsx







/**
 * A Survey-Styled Link
 */ function SurveyLink(_param) {
    var className = _param.className, _underline = _param.underline, underline = _underline === void 0 ? "auto" : _underline, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "underline",
        "children"
    ]);
    var styles = SurveyLink_useStyles({
        underline: underline
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()(styles.surveyAnchor, className)
    }, props), {
        children: children
    }));
}
/* harmony default export */ var SurveyLink_SurveyLink = (SurveyLink);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyLink/index.ts



;// CONCATENATED MODULE: ./src/app/components/Survey/FooterPoweredByLogoBlock/useStyles.ts

var FooterPoweredByLogoBlock_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(wrenchTheme) {
    var fontFamily = wrenchTheme.type.fontFamily.base;
    // smallest font-size is 14px in wrenchTheme.type.fontSize.bodySm (cannot use)
    var fontSize = "12px";
    var lineHeight = "15px";
    return {
        container: {
            margin: "0 auto",
            padding: 0,
            textAlign: "center"
        },
        text: {
            display: "inline-block",
            textAlign: "center",
            padding: 0,
            width: "100%",
            margin: "0",
            color: function(param) {
                var surveyTheme = param.surveyTheme;
                return surveyTheme.questionColor;
            },
            fontFamily: fontFamily,
            fontSize: fontSize,
            lineHeight: lineHeight
        },
        logo: function(param) {
            var logoColor = param.logoColor;
            return {
                width: "100%",
                height: "100%",
                color: logoColor,
                fill: logoColor
            };
        },
        logoContainer: {
            width: 157,
            height: 23,
            margin: [
                2,
                0
            ],
            display: "block"
        },
        imageLink: {
            display: "inline-flex",
            justifyContent: "center",
            padding: [
                0,
                25
            ]
        }
    };
});
/* harmony default export */ var FooterPoweredByLogoBlock_useStyles = (FooterPoweredByLogoBlock_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/FooterPoweredByLogoBlock/index.tsx








var FooterPoweredByLogoBlock_COPY = (0,dist/* defineMessages */.vU)({
    POWERED_BY: {
        id: "Survey.FooterPoweredByLogoBlock.PoweredBy",
        defaultMessage: "Powered by",
        description: "[Type: Paragraph][Vis: high] - Powered by text"
    },
    CTA_UNDER_LOGO: {
        id: "Survey.FooterPoweredByLogoBlock.CtaUnderLogo",
        defaultMessage: 'See how easy it is to <span id="surveyLinkEl">create a survey</span>.',
        description: '[Type: Paragraph][Vis: high] - "See how easy it is to create a survey" footer-CTA under the logo'
    },
    LOGO: {
        id: "Survey.FooterPoweredByLogoBlock.Logo",
        defaultMessage: "Survey monkey logo",
        description: "[Type: Link][Vis: low] - Survey monkey logo alt text for link in image"
    }
});
function FooterPoweredByLogoBlock(param) {
    var isGrayScale = param.isGrayScale;
    var ref = (0,react.useContext)(StaticContext/* StaticContext */.vN), _environment = ref.environment, domain = _environment.domain, subdomain = _environment.subdomain, tld = _environment.tld;
    var CURRENT_DOMAIN_URL = "https://".concat(subdomain, ".").concat(domain, ".").concat(tld);
    var POWERED_BY_SURVEY_MONKEY_LOGO_URL = "".concat(CURRENT_DOMAIN_URL, "/?ut_source=survey_poweredby_home");
    var CREATE_SURVEY_LINK_HOW_IT_WORKS = "".concat(CURRENT_DOMAIN_URL, "/mp/take-a-tour/?ut_source=survey_poweredby_howitworks");
    var surveyTheme = (0,SurveyTheme/* useSurveyTheme */.u7)();
    var logoColor = (0,react.useMemo)(function() {
        var isDarkBackground = surveyTheme.isDark;
        if (isDarkBackground) {
            return "#FFFFFF";
        }
        return isGrayScale ? "rgba(0,0,0, 0.5)" : "";
    }, [
        isGrayScale,
        surveyTheme.isDark
    ]);
    var ref1 = FooterPoweredByLogoBlock_useStyles({
        surveyTheme: surveyTheme,
        logoColor: logoColor
    }), container = ref1.container, text = ref1.text, logoContainer = ref1.logoContainer, logo = ref1.logo, imageLink = ref1.imageLink;
    /** Wrapper for @sm/intl react-based tokenization  */ var SurveyLinkEl = function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyLink_SurveyLink, {
            target: "_blank",
            href: CREATE_SURVEY_LINK_HOW_IT_WORKS,
            rel: "noreferrer",
            underline: "always",
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                    desc: FooterPoweredByLogoBlock_COPY.POWERED_BY
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyLink_SurveyLink, {
                className: imageLink,
                rel: "noreferrer",
                target: "_blank",
                href: POWERED_BY_SURVEY_MONKEY_LOGO_URL,
                "aria-label": (0,dist.t)(FooterPoweredByLogoBlock_COPY.LOGO),
                "data-testid": "FooterPoweredByLogoBlock__Logo",
                underline: "never",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    role: "presentation",
                    "aria-hidden": "true",
                    className: logoContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* LogoWithText */.u, {
                        className: logo
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                    desc: FooterPoweredByLogoBlock_COPY.CTA_UNDER_LOGO,
                    values: {
                        surveyLinkEl: SurveyLinkEl
                    }
                })
            })
        ]
    });
}
/* harmony default export */ var Survey_FooterPoweredByLogoBlock = (FooterPoweredByLogoBlock);

;// CONCATENATED MODULE: ./src/app/components/Survey/FooterPrivacyAndCookieNotice/useStyles.ts

var FooterPrivacyAndCookieNotice_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    return {
        text: {
            color: theme.questionColor,
            fontSize: 12,
            fontWeight: 400,
            lineHeight: "18px"
        },
        routerDebugInfo: {
            display: "block",
            opacity: "0.1",
            textAlign: "center"
        }
    };
});
/* harmony default export */ var FooterPrivacyAndCookieNotice_useStyles = (FooterPrivacyAndCookieNotice_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/FooterPrivacyAndCookieNotice/index.tsx






var DEFAULT_COPY = (0,dist/* defineMessages */.vU)({
    PRIVACY: {
        id: "Survey.FooterPrivacyAndCookieNotice.Privacy",
        defaultMessage: "Privacy",
        description: "[Type: Link][Vis: high] - Privacy anchor element"
    },
    COOKIE_NOTICE: {
        id: "Survey.FooterPrivacyAndCookieNotice.CookieNotice",
        defaultMessage: "Cookie Notice",
        description: "[Type: Link][Vis: high] - Cookie notice anchor element"
    },
    REPORT: {
        id: "Survey.FooterPrivacyAndCookieNotice.Report",
        defaultMessage: "Report a problem with this survey",
        description: "[Type: Link][Vis: high] - Report a problem anchor element"
    }
});
var FooterPrivacyAndCookieNotice = function(param) {
    var reportProblemURL = param.reportProblemURL, showReportProblem = param.showReportProblem, pageRequestId = param.pageRequestId, showRequestId = param.showRequestId;
    var ref = (0,react.useContext)(StaticContext/* StaticContext */.vN), _environment = ref.environment, domain = _environment.domain, subdomain = _environment.subdomain, tld = _environment.tld;
    var CURRENT_DOMAIN_URL = "https://".concat(subdomain, ".").concat(domain, ".").concat(tld);
    var COOKIE_NOTICE_URL = "".concat(CURRENT_DOMAIN_URL, "/mp/legal/cookies/?ut_source=survey_pp");
    var PRIVACY_BASICS_URL = "".concat(CURRENT_DOMAIN_URL, "/mp/legal/privacy/?ut_source=survey_pp");
    var ref1 = FooterPrivacyAndCookieNotice_useStyles(), text = ref1.text, routerDebugInfo = ref1.routerDebugInfo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: text,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyLink_SurveyLink, {
                rel: "noreferrer",
                target: "_blank",
                href: PRIVACY_BASICS_URL,
                "data-testid": "FooterPrivacyAndCookieNotice__Privacy",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                    desc: DEFAULT_COPY.PRIVACY
                })
            }),
            " ",
            "&",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyLink_SurveyLink, {
                rel: "noreferrer",
                target: "_blank",
                href: COOKIE_NOTICE_URL,
                "data-testid": "FooterPrivacyAndCookieNotice__Cookie",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                    desc: DEFAULT_COPY.COOKIE_NOTICE
                })
            }),
            showRequestId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: routerDebugInfo,
                "aria-hidden": "true",
                children: [
                    "respweb:",
                    pageRequestId
                ]
            }),
            showReportProblem && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        "aria-hidden": true,
                        children: "\xa0\xa0|\xa0\xa0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyLink_SurveyLink, {
                        href: reportProblemURL,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                            desc: DEFAULT_COPY.REPORT
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Survey_FooterPrivacyAndCookieNotice = (FooterPrivacyAndCookieNotice);

;// CONCATENATED MODULE: ./src/app/components/Survey/GooglePrivacyPolicy/useStyles.ts

var GooglePrivacyPolicy_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)({
    anchorContainer: {
        fontSize: 12,
        lineHeight: "18px",
        display: "block",
        textAlign: "center",
        margin: "0 auto"
    }
});
/* harmony default export */ var GooglePrivacyPolicy_useStyles = (GooglePrivacyPolicy_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/GooglePrivacyPolicy/index.tsx





var GooglePrivacyPolicy_DEFAULT_COPY = (0,dist/* defineMessages */.vU)({
    PRIVACY: {
        id: "Survey.GooglePrivacyPolicy.Privacy",
        defaultMessage: "Google Privacy Policy",
        description: "[Type: Link][Vis: med] - Google Privacy Policy anchor element"
    }
});
var GooglePrivacyPolicy = function(param) {
    var googlePrivacyPolicyURL = param.googlePrivacyPolicyURL;
    var anchorContainer = GooglePrivacyPolicy_useStyles().anchorContainer;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: anchorContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyLink_SurveyLink, {
            href: googlePrivacyPolicyURL,
            underline: "always",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                desc: GooglePrivacyPolicy_DEFAULT_COPY.PRIVACY
            })
        })
    });
};
/* harmony default export */ var Survey_GooglePrivacyPolicy = (GooglePrivacyPolicy);

;// CONCATENATED MODULE: ./src/app/components/Survey/FooterContainer/useStyles.ts

var FooterContainer_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)({
    surveyFooter: {},
    privacyComponentContainer: {
        paddingTop: 80,
        margin: "0 auto",
        textAlign: "center"
    }
});
/* harmony default export */ var FooterContainer_useStyles = (FooterContainer_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/FooterContainer/index.tsx










/**
 * TODO: Move this component and it's dependant child-components under
 * SurveyTaking/components; rename to SurveyFooter
 */ function FooterContainer(_param, ref) {
    var tmp = _param.element, Element = tmp === void 0 ? "footer" : tmp, className = _param.className, isGrayScale = _param.isGrayScale, showReportProblem = _param.showReportProblem, reportProblemURL = _param.reportProblemURL, isGoogleSubdomain = _param.isGoogleSubdomain, googlePrivacyPolicyURL = _param.googlePrivacyPolicyURL, showPrivacyCookiePolicy = _param.showPrivacyCookiePolicy, showRequestId = _param.showRequestId, pageRequestId = _param.pageRequestId, containerProps = (0,_object_without_properties/* default */.Z)(_param, [
        "element",
        "className",
        "isGrayScale",
        "showReportProblem",
        "reportProblemURL",
        "isGoogleSubdomain",
        "googlePrivacyPolicyURL",
        "showPrivacyCookiePolicy",
        "showRequestId",
        "pageRequestId"
    ]);
    var _$ref = FooterContainer_useStyles(), surveyFooter = _$ref.surveyFooter, privacyComponentContainer = _$ref.privacyComponentContainer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Element, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: classnames_default()(surveyFooter, className)
    }, containerProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey_FooterPoweredByLogoBlock, {
                isGrayScale: isGrayScale
            }),
            isGoogleSubdomain && /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey_GooglePrivacyPolicy, {
                googlePrivacyPolicyURL: googlePrivacyPolicyURL
            }),
            showPrivacyCookiePolicy && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: privacyComponentContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey_FooterPrivacyAndCookieNotice, {
                    showReportProblem: showReportProblem,
                    showRequestId: showRequestId,
                    pageRequestId: pageRequestId,
                    reportProblemURL: reportProblemURL
                })
            })
        ]
    }));
}
/* harmony default export */ var Survey_FooterContainer = (/*#__PURE__*/(0,react.forwardRef)(FooterContainer));

;// CONCATENATED MODULE: ./src/app/components/Survey/PageTitle/useStyles.ts



var useStyles_useSurveyStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    return {
        pageTitle: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            color: theme === null || theme === void 0 ? void 0 : theme.titleColor,
            lineHeight: 1.25,
            marginTop: 0,
            marginBottom: 12
        }, theme === null || theme === void 0 ? void 0 : theme.pageTitle), {
            // reset font weight changed by the theme above
            "& strong": {
                fontWeight: "bold !important"
            }
        }),
        questionNumber: function(param) {
            var isRTL = param.isRTL;
            return {
                margin: isRTL ? "0 0 0 0.25em" : "0 0.25em 0 0"
            };
        }
    };
});
/* harmony default export */ var PageTitle_useStyles = (useStyles_useSurveyStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/PageTitle/PageTitle.tsx








var PageTitle = function(_param) {
    var id = _param.id, tmp = _param.element, Element = tmp === void 0 ? "h2" : tmp, text = _param.text, _numbered = _param.numbered, numbered = _numbered === void 0 ? false : _numbered, number = _param.number, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "element",
        "text",
        "numbered",
        "number"
    ]);
    var isRTL = (0,react.useContext)(dist/* L10NContext */.kR).isRTL;
    var ref = PageTitle_useStyles({
        isRTL: isRTL
    }), pageTitle = ref.pageTitle, questionNumber = ref.questionNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Element, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: id,
        "data-testid": "PageTitle__Title",
        className: pageTitle
    }, otherProps), {
        children: [
            numbered && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: questionNumber,
                children: [
                    number,
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText_RichText, {
                element: "span",
                text: text
            })
        ]
    }));
};
/* harmony default export */ var PageTitle_PageTitle = (PageTitle);

;// CONCATENATED MODULE: ./src/app/components/Survey/PageTitle/index.ts


;// CONCATENATED MODULE: ./src/app/components/Survey/PageDescription/useStyles.ts



var PageDescription_useStyles_useSurveyStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    return {
        pageDescription: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            color: theme.questionColor,
            lineHeight: 1.25,
            paddingBottom: 15
        }, theme === null || theme === void 0 ? void 0 : theme.questionTitle), {
            // reset font weight changed by the theme above
            "& strong": {
                fontWeight: "bold !important"
            }
        })
    };
});
/* harmony default export */ var PageDescription_useStyles = (PageDescription_useStyles_useSurveyStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/PageDescription/PageDescription.tsx




var PageDescription = function(param) {
    var _element = param.element, element = _element === void 0 ? "div" : _element, text = param.text;
    var pageDescription = PageDescription_useStyles().pageDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText_RichText, {
        element: element,
        text: text,
        className: pageDescription,
        "data-testid": "PageDescription__Text"
    });
};
/* harmony default export */ var PageDescription_PageDescription = (PageDescription);

;// CONCATENATED MODULE: ./src/app/components/Survey/PageDescription/index.ts


// EXTERNAL MODULE: ./src/app/components/Survey/SurveyButton/index.ts + 2 modules
var SurveyButton = __webpack_require__(6524);
;// CONCATENATED MODULE: ./src/app/helpers/themeLayout.ts
var isPartial = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return layoutName.includes("PARTIAL");
};
var isCenter = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return layoutName.includes("CENTER");
};
var isLeft = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return layoutName.includes("LEFT");
};
var isRight = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return layoutName.includes("RIGHT");
};
var isLeftOrRight = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return isLeft(layoutName) || isRight(layoutName);
};
var isPartialSide = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return isPartial(layoutName) && isLeftOrRight(layoutName);
};
var isPartialLeft = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return isPartial(layoutName) && isLeft(layoutName);
};
var isPartialRight = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return isPartial(layoutName) && isRight(layoutName);
};
var isPartialHalf = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return isPartial(layoutName) && layoutName.includes("HALF");
};
var isPartialThird = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return isPartial(layoutName) && layoutName.includes("THIRD");
};
var isBanner = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return layoutName.includes("BANNER");
};
var isFull = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return layoutName.includes("FULL");
};
var isFullLeftOrRight = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return isFull(layoutName) && !isCenter(layoutName);
};
var getThemeLayoutType = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return {
        isPartial: isPartial(layoutName),
        isCenter: isCenter(layoutName),
        isLeft: isLeft(layoutName),
        isRight: isRight(layoutName),
        isLeftOrRight: isLeftOrRight(layoutName),
        isPartialSide: isPartialSide(layoutName),
        isPartialLeft: isPartialLeft(layoutName),
        isPartialRight: isPartialRight(layoutName),
        isPartialHalf: isPartialHalf(layoutName),
        isPartialThird: isPartialThird(layoutName),
        isBanner: isBanner(layoutName),
        isFull: isFull(layoutName)
    };
};
var getLayoutSize = function() {
    var layoutName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var lo = getThemeLayoutType(layoutName);
    var size = "full";
    if (lo.isFull && lo.isLeftOrRight) {
        if (lo.isLeft) {
            size += "Left";
        } else {
            size += "Right";
        }
    } else if (lo.isPartialSide && !lo.isPartialThird) {
        size = "half";
    } else if (lo.isPartialThird) {
        size = "third";
    } else if (lo.isBanner) {
        size = "top";
    }
    return size;
};

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/Layout/useStyles.ts





/**
 * The current use of breakpoints do NOT match production breakpoints, so
 * they are as close as possible.
 */ var partialSize = function(theme) {
    var ref, ref1, ref2;
    var fullDimensions = {
        width: "0%",
        height: "100%",
        minHeight: "auto"
    };
    var _obj;
    return ({
        full: fullDimensions,
        fullLeft: fullDimensions,
        fullRight: fullDimensions,
        top: {
            width: "auto"
        },
        half: (_obj = {
            width: "0%"
        }, (0,_define_property/* default */.Z)(_obj, "@media (min-width: ".concat((ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref.sm.min, ")"), {
            width: "34%"
        }), (0,_define_property/* default */.Z)(_obj, "@media (min-width: ".concat((ref1 = theme.breakpoints) === null || ref1 === void 0 ? void 0 : ref1.md.min, ")"), {
            width: "50%"
        }), _obj),
        third: (0,_define_property/* default */.Z)({
            width: "0%"
        }, "@media (min-width: ".concat((ref2 = theme.breakpoints) === null || ref2 === void 0 ? void 0 : ref2.sm.min, ")"), {
            width: "34%"
        })
    })[getLayoutSize(theme.layout)];
};
var imageSize = function(theme) {
    var base = partialSize(theme);
    var size = !isPartial(theme.layout) ? "full" : getLayoutSize(theme.layout);
    return (0,_object_spread/* default */.Z)({}, base, size === "full" || size === "top" ? {
        width: "100%"
    } : {});
};
var contentSize = function(theme) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var _obj, _obj1, _obj2;
    return ({
        full: {
            width: "100%"
        },
        fullLeft: (_obj = {
            width: "100%"
        }, (0,_define_property/* default */.Z)(_obj, "@media (min-width: ".concat((ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref.sm.min, ")"), {
            width: "66%",
            marginRight: "34%"
        }), (0,_define_property/* default */.Z)(_obj, "@media (min-width: ".concat((ref1 = theme.breakpoints) === null || ref1 === void 0 ? void 0 : ref1.md.min, ")"), {
            width: "50%",
            marginRight: "50%"
        }), _obj),
        fullRight: (_obj1 = {
            width: "100%"
        }, (0,_define_property/* default */.Z)(_obj1, "@media (min-width: ".concat((ref2 = theme.breakpoints) === null || ref2 === void 0 ? void 0 : ref2.sm.min, ")"), {
            width: "66%",
            marginLeft: "34%"
        }), (0,_define_property/* default */.Z)(_obj1, "@media (min-width: ".concat((ref3 = theme.breakpoints) === null || ref3 === void 0 ? void 0 : ref3.md.min, ")"), {
            width: "50%",
            marginLeft: "50%"
        }), _obj1),
        top: {
            width: "100%"
        },
        half: (_obj2 = {
            width: "100%"
        }, (0,_define_property/* default */.Z)(_obj2, "@media (min-width: ".concat((ref4 = theme.breakpoints) === null || ref4 === void 0 ? void 0 : ref4.sm.min, ")"), {
            width: "66%"
        }), (0,_define_property/* default */.Z)(_obj2, "@media (min-width: ".concat((ref5 = theme.breakpoints) === null || ref5 === void 0 ? void 0 : ref5.md.min, ")"), {
            width: "50%"
        }), _obj2),
        third: (0,_define_property/* default */.Z)({
            width: "100%"
        }, "@media (min-width: ".concat((ref6 = theme.breakpoints) === null || ref6 === void 0 ? void 0 : ref6.sm.min, ")"), {
            width: "66%"
        })
    })[getLayoutSize(theme.layout)];
};
var mainPadding = function(theme) {
    var ref, ref1, ref2, ref3, ref4;
    var _obj, _obj1;
    return isLeftOrRight(theme.layout) && !isBanner(theme.layout) ? (_obj = {
        padding: [
            40,
            24,
            0,
            24
        ]
    }, (0,_define_property/* default */.Z)(_obj, "@media (min-width: ".concat((ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref.sm.min, ")"), {
        padding: [
            40,
            40,
            0,
            40
        ]
    }), (0,_define_property/* default */.Z)(_obj, "@media (min-width: ".concat((ref1 = theme.breakpoints) === null || ref1 === void 0 ? void 0 : ref1.xl.min, ")"), {
        padding: [
            80,
            80,
            0,
            80
        ]
    }), _obj) : (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, "@media (min-width: ".concat((ref2 = theme.breakpoints) === null || ref2 === void 0 ? void 0 : ref2.sm.max, ")"), {
        padding: [
            80,
            140,
            0,
            140
        ]
    }), (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat((ref3 = theme.breakpoints) === null || ref3 === void 0 ? void 0 : ref3.sm.max, ")"), {
        padding: [
            80,
            80,
            0,
            80
        ]
    }), (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat((ref4 = theme.breakpoints) === null || ref4 === void 0 ? void 0 : ref4.xs.max, ")"), {
        padding: [
            40,
            40,
            0,
            40
        ]
    }), _obj1);
};
var Layout_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    var ref, ref1, ref2, ref3;
    var imgOverlayColor = (theme === null || theme === void 0 ? void 0 : (ref = theme.surveyPage) === null || ref === void 0 ? void 0 : ref.backgroundImage) !== undefined || isPartial(theme.layout) ? theme === null || theme === void 0 ? void 0 : (ref1 = theme.surveyPage) === null || ref1 === void 0 ? void 0 : ref1.overlayColor : theme === null || theme === void 0 ? void 0 : theme.primaryBackgroundColor;
    var partialBgImage = [
        "linear-gradient(".concat(imgOverlayColor, ", ").concat(imgOverlayColor, ")"),
        theme === null || theme === void 0 ? void 0 : (ref2 = theme.surveyPage) === null || ref2 === void 0 ? void 0 : ref2.backgroundImage
    ].filter(function(o) {
        return typeof o !== "undefined";
    }).join(", ");
    return {
        layoutContainer: {
            direction: function(param) {
                var isRTL = param.isRTL;
                return isRTL ? "rtl" : "ltr";
            },
            display: "flex",
            flexDirection: isBanner(theme.layout) ? "column" : "row"
        },
        layoutPartialContainer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            position: "relative",
            order: isPartialRight(theme.layout) ? 2 : 1,
            minHeight: "40px",
            padding: isBanner(theme.layout) ? [
                40,
                40
            ] : {}
        }, partialSize(theme)), {
            "&:before": (0,_object_spread/* default */.Z)({
                display: "block",
                position: isBanner(theme.layout) ? "absolute" : "fixed",
                content: '""',
                zIndex: -10,
                top: 0,
                left: !isPartialRight(theme.layout) ? 0 : {},
                right: isPartialRight(theme.layout) ? 0 : {},
                height: "100%",
                background: {
                    position: "50% 50%",
                    size: "cover",
                    image: partialBgImage
                }
            }, imageSize(theme))
        }),
        layoutContentContainer: (0,_object_spread/* default */.Z)({
            boxSizing: "border-box",
            color: theme === null || theme === void 0 ? void 0 : theme.questionColor,
            fontFamily: theme === null || theme === void 0 ? void 0 : (ref3 = theme.questionTitle) === null || ref3 === void 0 ? void 0 : ref3.fontFamily,
            minHeight: "100%",
            backgroundColor: isPartial(theme.layout) ? theme === null || theme === void 0 ? void 0 : theme.primaryBackgroundColor : undefined,
            order: isPartialRight(theme.layout) ? 1 : 2
        }, contentSize(theme)),
        layoutTopContainer: {},
        layoutMainContainer: (0,_object_spread/* default */.Z)({
            maxWidth: "896px",
            margin: isCenter(theme.layout) || isBanner(theme.layout) ? "0 auto" : {}
        }, mainPadding(theme)),
        layoutLogoContainer: {
            padding: isBanner(theme.layout) ? [
                40,
                40
            ] : [
                8,
                40,
                0,
                40
            ]
        },
        layoutToolbarContainer: {
            display: "flex",
            flexDirection: "row",
            // May change depend on RTL?
            justifyContent: "flex-end",
            alignItems: "center",
            boxSizing: "border-box",
            padding: [
                12,
                12,
                0,
                0
            ],
            width: "100%",
            "& > *:not(:first-child)": {
                // May change depend on RTL?
                marginLeft: "10px"
            }
        }
    };
});
/* harmony default export */ var Layout_useStyles = (Layout_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/Layout/Layout.tsx











var defaultContainerProps = {
    layoutContainer: {
        id: "survey-layout-container"
    },
    partialContainer: {
        id: "survey-layout-partial-container"
    },
    contentContainer: {
        id: "survey-layout-content-container"
    },
    topContainer: {
        id: "survey-layout-top-container"
    },
    mainContainer: {
        id: "survey-main-content"
    },
    logoContainer: {
        id: "survey-logo-container"
    },
    toolbarContainer: {
        id: "survey-toolbar-container"
    }
};
function Layout(param) {
    var tmp = param.options, containerOptions = tmp === void 0 ? {} : tmp, Logo = param.logo, Tools = param.tools, children = param.children;
    var ref = (0,context/* useSurveyTheme */.u7)(), layoutName = ref.layout;
    var isBanner = getThemeLayoutType(layoutName).isBanner;
    var isRTL = (0,react.useContext)(dist/* L10NContext */.kR).isRTL;
    var isToolbarEnabled = !!Tools;
    var isLogoEnabled = !!Logo;
    var ref1 = Layout_useStyles({
        isRTL: isRTL
    }), layoutContainer = ref1.layoutContainer, layoutLogoContainer = ref1.layoutLogoContainer, layoutPartialContainer = ref1.layoutPartialContainer, layoutToolbarContainer = ref1.layoutToolbarContainer, layoutContentContainer = ref1.layoutContentContainer, layoutTopContainer = ref1.layoutTopContainer, layoutMainContainer = ref1.layoutMainContainer;
    var _ref = (0,react.useMemo)(function() {
        return Object.keys(containerOptions).reduce(function(result, key) {
            var _key;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, result), (0,_define_property/* default */.Z)({}, key, (_key = containerOptions[key]) !== null && _key !== void 0 ? _key : {}));
        }, defaultContainerProps);
    }, [
        containerOptions
    ]), _layoutContainer = _ref.layoutContainer, layoutContainerClasses = _layoutContainer.className, _partialContainer = _ref.partialContainer, partialContainerClasses = _partialContainer.className, _contentContainer = _ref.contentContainer, contentContainerClasses = _contentContainer.className, _topContainer = _ref.topContainer, topContainerClasses = _topContainer.className, _mainContainer = _ref.mainContainer, mainContainerClasses = _mainContainer.className, _toolbarContainer = _ref.toolbarContainer, toolbarContainerClasses = _toolbarContainer.className, _logoContainer = _ref.logoContainer, logoContainerClasses = _logoContainer.className, layoutContainerProps = (0,_object_without_properties/* default */.Z)(_ref.layoutContainer, [
        "className"
    ]), partialContainerProps = (0,_object_without_properties/* default */.Z)(_ref.partialContainer, [
        "className"
    ]), contentContainerProps = (0,_object_without_properties/* default */.Z)(_ref.contentContainer, [
        "className"
    ]), topContainerProps = (0,_object_without_properties/* default */.Z)(_ref.topContainer, [
        "className"
    ]), mainContainerProps = (0,_object_without_properties/* default */.Z)(_ref.mainContainer, [
        "className"
    ]), toolbarContainerProps = (0,_object_without_properties/* default */.Z)(_ref.toolbarContainer, [
        "className"
    ]), logoContainerProps = (0,_object_without_properties/* default */.Z)(_ref.logoContainer, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()(layoutContainer, layoutContainerClasses)
    }, layoutContainerProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: classnames_default()(layoutPartialContainer, partialContainerClasses)
            }, partialContainerProps), {
                children: isBanner && isLogoEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: classnames_default()(layoutLogoContainer, logoContainerClasses)
                }, logoContainerProps), {
                    children: Logo
                }))
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: classnames_default()(layoutContentContainer, contentContainerClasses)
            }, contentContainerProps), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        // `offset-height-exclusion` is needed for pages/_document.page.tsx to calculate initial `marginTop`
                        className: classnames_default()("offset-height-exclusion", layoutTopContainer, topContainerClasses)
                    }, topContainerProps), {
                        children: [
                            isToolbarEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                className: classnames_default()(layoutToolbarContainer, toolbarContainerClasses)
                            }, toolbarContainerProps), {
                                children: Tools
                            })),
                            !isBanner && isLogoEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                className: classnames_default()(layoutLogoContainer, logoContainerClasses)
                            }, logoContainerProps), {
                                children: Logo
                            }))
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        // `offset-main-container` is needed for pages/_document.page.tsx to set initial `marginTop`
                        className: classnames_default()("offset-main-container", layoutMainContainer, mainContainerClasses),
                        suppressHydrationWarning: true
                    }, mainContainerProps), {
                        children: children
                    }))
                ]
            }))
        ]
    }));
}
/* harmony default export */ var Layout_Layout = (Layout);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/Layout/index.ts


;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/QuestionList/utils.ts

/**
 * Group questions based each question's layout config
 * @param questions
 * @description
 * - if a question has layout config as new row, it will start a new group
 * - if a question has layout config as right aligned, it will be grouped with the previous group together
 * @example
 * input = [
 *   { layout: { placement: 'NEW_ROW' }},
 *   { layout: { placement: 'RIGHT_ALIGNED' }},
 *   { layout: { placement: 'NEW_ROW' }},
 *   { layout: { placement: 'RIGHT_ALIGNED' }},
 * ]
 *
 * output = [
 *   [ { layout: { placement: 'NEW_ROW' }}, { layout: { placement: 'RIGHT_ALIGNED' }} ],
 *   [ { layout: { placement: 'NEW_ROW' }}, { layout: { placement: 'RIGHT_ALIGNED' }} ]
 * ]
 */ var groupQuestionsWithLayoutConfig = function(questions) {
    return questions.reduce(function(groups, question) {
        if ("layout" in question && "placement" in question.layout && question.layout.placement === "RIGHT_ALIGNED") {
            var preGroup = groups.pop();
            var newGroup = preGroup ? (0,_to_consumable_array/* default */.Z)(preGroup).concat([
                question
            ]) : [
                question
            ];
            groups.push(newGroup);
        } else {
            groups.push([
                question
            ]);
        }
        return groups;
    }, []);
};
/* harmony default export */ var utils = (groupQuestionsWithLayoutConfig);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/QuestionRowLayout/useStyles.ts


var QuestionRowLayout_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var _obj, _obj1;
    return {
        gridRow: (0,_define_property/* default */.Z)({
            display: "grid",
            gap: "20px",
            maxWidth: "100%",
            marginBottom: "40px"
        }, "@media (max-width: ".concat((ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref.xs.max, ")"), {
            gridTemplateColumns: "minmax(auto, 100%)"
        }),
        gridItem: // applies to all maxQuestionsPerRow - just show 1 per row for small screens
        (0,_define_property/* default */.Z)({
            boxSizing: "border-box"
        }, "@media (max-width: ".concat((ref1 = theme.breakpoints) === null || ref1 === void 0 ? void 0 : ref1.xs.max, ")"), {
            paddingRight: "0 !important",
            width: "100% !important"
        }),
        // Each row configuration has its own static class to work around a
        // JSS / media - query bug when combining variable props and media-queries
        // see RAWR-735
        gridItem1Item: {
            gridTemplateColumns: "minmax(0, 1fr)",
            width: "100%"
        },
        gridItem2Items: (0,_define_property/* default */.Z)({}, "@media (min-width: ".concat((ref2 = theme.breakpoints) === null || ref2 === void 0 ? void 0 : ref2.sm.min, ")"), {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
        }),
        gridItem3Items: (_obj = {}, (0,_define_property/* default */.Z)(_obj, "@media (min-width: ".concat((ref3 = theme.breakpoints) === null || ref3 === void 0 ? void 0 : ref3.sm.min, ") and (max-width: ").concat((ref4 = theme.breakpoints) === null || ref4 === void 0 ? void 0 : ref4.md.max, ")"), {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
        }), (0,_define_property/* default */.Z)(_obj, "@media (min-width: ".concat((ref5 = theme.breakpoints) === null || ref5 === void 0 ? void 0 : ref5.lg.min, ")"), {
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))"
        }), _obj),
        gridItem4Items: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, "@media (min-width: ".concat((ref6 = theme.breakpoints) === null || ref6 === void 0 ? void 0 : ref6.sm.min, ") and (max-width: ").concat((ref7 = theme.breakpoints) === null || ref7 === void 0 ? void 0 : ref7.md.max, ")"), {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
        }), (0,_define_property/* default */.Z)(_obj1, "@media (min-width: ".concat((ref8 = theme.breakpoints) === null || ref8 === void 0 ? void 0 : ref8.lg.min, ")"), {
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))"
        }), _obj1)
    };
});
/* harmony default export */ var QuestionRowLayout_useStyles = (QuestionRowLayout_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/QuestionRowLayout/QuestionRowLayout.tsx





function QuestionRowLayout(param) {
    var children = param.children, _maxQuestionsPerRow = param.maxQuestionsPerRow, maxQuestionsPerRow = _maxQuestionsPerRow === void 0 ? 4 : _maxQuestionsPerRow, _isOQAAT = param.isOQAAT, isOQAAT = _isOQAAT === void 0 ? true : _isOQAAT;
    var ref = QuestionRowLayout_useStyles(), gridItem = ref.gridItem, gridRow = ref.gridRow, gridItem1Item = ref.gridItem1Item, gridItem2Items = ref.gridItem2Items, gridItem3Items = ref.gridItem3Items, gridItem4Items = ref.gridItem4Items;
    if (isOQAAT) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        });
    }
    var numOfQuestions = react.Children.count(children);
    var itemCount = Math.min(numOfQuestions, maxQuestionsPerRow);
    var _obj;
    var gridItemClasses = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, gridRow, true), (0,_define_property/* default */.Z)(_obj, gridItem1Item, itemCount === 1 || !itemCount), (0,_define_property/* default */.Z)(_obj, gridItem2Items, itemCount === 2), (0,_define_property/* default */.Z)(_obj, gridItem3Items, itemCount === 3), (0,_define_property/* default */.Z)(_obj, gridItem4Items, itemCount === 4), _obj));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-testid": "QuestionRowLayout__Test",
        className: gridItemClasses,
        children: react.Children.map(children, function(child) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: gridItem,
                children: child
            });
        })
    });
}
/* harmony default export */ var QuestionRowLayout_QuestionRowLayout = (QuestionRowLayout);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/QuestionRowLayout/index.ts


// EXTERNAL MODULE: ./node_modules/lodash-es/unescape.js + 6 modules
var lodash_es_unescape = __webpack_require__(1356);
;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/helper/decodeHtmlEntities.ts

/**
 * Decodes HTML entities in a string.
 * eg. 'hello &#931; &#927; &#937; &#128522;' becomes 'hello Σ Ο Ω 😊'
 * @param str The string to be decoded
 * @returns The decoded string
 */ var decodeHtmlEntities = function(str) {
    if (!str) return str;
    return (0,lodash_es_unescape/* default */.Z)(str).replace(/&#(\d+);/g, function(_, dec) {
        return String.fromCodePoint(dec);
    });
};
/* harmony default export */ var helper_decodeHtmlEntities = ((/* unused pure expression or super */ null && (decodeHtmlEntities)));

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/errors/transformFromSurveyErrors.ts
/**
 * @todo Add @sm/question-definitions as an explicit dependency; or, import
 * from explicit dependency source. i.e. @sm/question-widgets
 *
 * As a best-practice, dependencies of a dependency should not be imported.
 */ 

function transformFromSurveyErrors(errors) {
    return errors.map(function(param) {
        var questionId = param.questionId, field = param.field, detail = param.detail, code = param.code;
        return {
            questionId: questionId,
            detail: decodeHtmlEntities(detail),
            // defaults to "TEXT_LENGTH", presently no way of knowing (consider adding UNKNOWN to SMQ)
            type: code === ErrorType.MISSING_REQUIRED_FIELD ? "REQUIRED" : "TEXT_LENGTH",
            fieldId: field === null || field === void 0 ? void 0 : field[0]
        };
    });
}
/* harmony default export */ var errors_transformFromSurveyErrors = (transformFromSurveyErrors);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/QuestionList/QuestionList.tsx













/** Wrapper to flatten `displayOptions` */ function SingleQuestionControllerWrapper(_param) {
    var question = _param.question, props = (0,_object_without_properties/* default */.Z)(_param, [
        "question"
    ]);
    var errors = useAppSelectorV2(function(state) {
        return selectErrorsById(state, question.id);
    });
    var answer = useAppSelectorV2(function(state) {
        return selectAnswerById(state, question.id);
    });
    var displayOptions = (0,_object_spread/* default */.Z)({
        errors: errors_transformFromSurveyErrors(errors),
        answer: answer,
        registerValidator: registerValidator,
        unregisterValidator: unregisterValidator
    }, props);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(respondent_survey/* SingleQuestionController */.SK, {
        question: question,
        displayOptions: displayOptions
    });
}
function QuestionList(param) {
    var questions = param.questions, answers = param.answers, _isOQAAT = param.isOQAAT, isOQAAT = _isOQAAT === void 0 ? true : _isOQAAT;
    var groups = (0,react.useMemo)(function() {
        return utils(questions);
    }, [
        questions
    ]);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: groups.map(function(group) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(QuestionRowLayout_QuestionRowLayout, {
                isOQAAT: isOQAAT,
                maxQuestionsPerRow: isOQAAT ? 1 : 4,
                children: group.map(function(question) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(SurveyFormatView, {
                        name: question.id,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleQuestionControllerWrapper, {
                            question: question,
                            answer: (ref = answers === null || answers === void 0 ? void 0 : answers[question.id]) !== null && ref !== void 0 ? ref : undefined
                        })
                    }, question.id);
                })
            }, "group_".concat(group.map(function(g) {
                return g.id;
            }).concat("-")));
        })
    });
}
/* harmony default export */ var QuestionList_QuestionList = (QuestionList);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/QuestionList/index.ts


;// CONCATENATED MODULE: ./src/app/components/Survey/PersistentProgressBar/useStyles.ts



function getWidthFromLayout(layout) {
    var width = "";
    if (isFull(layout) || isBanner(layout)) {
        width = "100%";
    } else if (isPartialHalf(layout)) {
        width = "50%";
    } else if (isPartialThird(layout)) {
        width = "66%";
    }
    return width;
}
function getLeftRightFromLayout(layout) {
    // Default to browser behavior
    var left = "auto";
    var right = "auto";
    /**
   *  PartialLeft => Partial (half or third) space is left empty on the LEFT side while survey content is on the right.
   *    * right = 0 ensures the bar is at the edge on right side.
   *    * left is set to 'auto'
   *
   *  PartialRight:
   *    * ProgressBar should be on the edge of left side => left = 0
   *    * right = 'auto'
   *
   *  isFull and isBanner:
   *    * In both these cases, progress bar already has 100% width, left = 0 ensures it sticks to left edge
   *    * right = 'auto
   */ if (isPartialLeft(layout)) {
        right = "0";
    } else {
        left = "0";
    }
    return {
        left: left,
        right: right
    };
}
var PersistentProgressBar_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = getLeftRightFromLayout(theme.layout), left = ref7.left, right = ref7.right;
    var ref8, _secondaryAccentColor;
    var _obj, _obj1;
    return {
        progressBarContainer: (_obj = {
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            direction: "ltr",
            background: theme.primaryAccentColor,
            position: "fixed",
            bottom: 0,
            height: 48,
            left: left,
            right: right,
            width: getWidthFromLayout(theme.layout)
        }, (0,_define_property/* default */.Z)(_obj, "@media (max-width: ".concat((ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref.sm.max, ")"), {
            // for partial layouts (except banner), container should be 2/3 of the screen width between 640px and 768px
            width: !isFull(theme.layout) && !isBanner(theme.layout) ? "66%" : "100%"
        }), (0,_define_property/* default */.Z)(_obj, "@media (max-width: ".concat((ref1 = theme.breakpoints) === null || ref1 === void 0 ? void 0 : ref1.xs.max, ")"), {
            width: "100%"
        }), _obj),
        text: {
            fontFamily: (ref8 = theme === null || theme === void 0 ? void 0 : (ref2 = theme.questionBody) === null || ref2 === void 0 ? void 0 : ref2.fontFamily) !== null && ref8 !== void 0 ? ref8 : null,
            color: (_secondaryAccentColor = theme.secondaryAccentColor) !== null && _secondaryAccentColor !== void 0 ? _secondaryAccentColor : {},
            direction: function(param) {
                var isRTL = param.isRTL;
                return isRTL ? "rtl" : null;
            },
            fontSize: 15
        },
        progressBar: (_obj1 = {
            width: 200,
            marginLeft: 20
        }, // hide the progress bar at appropriate breakpoints depending on layout
        (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat((ref3 = theme.breakpoints) === null || ref3 === void 0 ? void 0 : ref3.md.max, ")"), {
            display: isPartialHalf(theme.layout) ? "none" : "block"
        }), (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat((ref4 = theme.breakpoints) === null || ref4 === void 0 ? void 0 : ref4.sm.max, ")"), {
            display: isPartialThird(theme.layout) || isPartialHalf(theme.layout) ? "none" : "block"
        }), (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat((ref5 = theme.breakpoints) === null || ref5 === void 0 ? void 0 : ref5.xs.max, ")"), {
            display: "block"
        }), (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat((ref6 = theme.breakpoints) === null || ref6 === void 0 ? void 0 : ref6.xxs.max, ")"), {
            display: "none"
        }), _obj1)
    };
});
/* harmony default export */ var PersistentProgressBar_useStyles = (PersistentProgressBar_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/core/ProgressBar/useStyles.ts

var ProgressBar_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)({
    container: {
        border: function(param) {
            var borderColor = param.borderColor;
            return "1px solid ".concat(borderColor);
        },
        borderRadius: function(param) {
            var radius = param.radius;
            return radius;
        },
        height: function(param) {
            var height = param.height;
            return height;
        },
        backgroundColor: function(param) {
            var emptyColor = param.emptyColor;
            return emptyColor;
        }
    },
    bar: {
        width: function(param) {
            var value = param.value;
            return "".concat(value, "%");
        },
        height: "100%",
        transition: "width 200ms",
        backgroundColor: function(param) {
            var progressColor = param.progressColor;
            return progressColor;
        },
        borderRadius: 12
    }
});
/* harmony default export */ var ProgressBar_useStyles = (ProgressBar_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/core/ProgressBar/ProgressBar.tsx







var ProgressBar = function(_param) {
    var value = _param.value, _borderColor = _param.borderColor, borderColor = _borderColor === void 0 ? "#000" : _borderColor, _progressColor = _param.progressColor, progressColor = _progressColor === void 0 ? "#000" : _progressColor, _emptyColor = _param.emptyColor, emptyColor = _emptyColor === void 0 ? "transparent" : _emptyColor, _radius = _param.radius, radius = _radius === void 0 ? 5 : _radius, _height = _param.height, height = _height === void 0 ? 8 : _height, className = _param.className, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "borderColor",
        "progressColor",
        "emptyColor",
        "radius",
        "height",
        "className"
    ]);
    /** Limit `value` to the range between `0` and `100` */ var boundedValue = Math.max(0, Math.min(value, 100));
    var ref = ProgressBar_useStyles({
        value: boundedValue,
        borderColor: borderColor,
        progressColor: progressColor,
        emptyColor: emptyColor,
        radius: radius,
        height: height
    }), container = ref.container, bar = ref.bar;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "progressbar",
        "aria-valuenow": boundedValue,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        className: classnames_default()(container, className)
    }, otherProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: bar
        })
    }));
};
/* harmony default export */ var ProgressBar_ProgressBar = (ProgressBar);

;// CONCATENATED MODULE: ./src/app/components/core/ProgressBar/index.ts


;// CONCATENATED MODULE: ./src/app/components/core/VisuallyHidden/useStyles.ts

var VisuallyHidden_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)({
    hidden: {
        clip: " rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: "1px",
        width: "1px",
        overflow: "hidden",
        position: "absolute",
        whiteSpace: "nowrap"
    }
});
/* harmony default export */ var VisuallyHidden_useStyles = (VisuallyHidden_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/core/VisuallyHidden/index.tsx



function VisuallyHidden(param) {
    var children = param.children, isHidden = param.isHidden;
    var hidden = VisuallyHidden_useStyles().hidden;
    return isHidden ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: hidden,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
}
/* harmony default export */ var core_VisuallyHidden = (VisuallyHidden);

;// CONCATENATED MODULE: ./src/app/components/Survey/PersistentProgressBar/PersistentProgressBar.tsx










var PersistentProgressBar_COPY = (0,dist/* defineMessages */.vU)({
    ANSWERED_WITH_PROGRESS_SR_PREFIX: {
        id: "Survey.PersistentProgressBar.AnsweredWithProgressSrPrefix",
        defaultMessage: '<span id="visuallyHiddenEl">Current Progress,</span> {current} of {total} answered',
        description: '[Type: Label][Vis: med] - Shows the total number of questions answered with a visually hidden, speech readout prefix ("visuallyHiddenEl") denoting question progress'
    }
});
// No need for use memo since the only time the re-rendering happens is when the value change or theme
// Also very light calculation
var getCurrentValue = function(value, total) {
    // Avoid division by 0
    if (total <= 0) {
        return 0;
    }
    // Return the percentage
    return value / total * 100;
};
/** Wrapper for @sm/intl react-based tokenization  */ var VisuallyHiddenEl = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(core_VisuallyHidden, {
        isHidden: true,
        children: children
    });
};
function PersistentProgressBar(param, ref) {
    var _id = param.id, id = _id === void 0 ? "persistent-progress" : _id, value = param.value, total = param.total, isRTL = param.isRTL;
    var theme = (0,context/* useSurveyTheme */.u7)();
    var _$ref = PersistentProgressBar_useStyles({
        isRTL: !!isRTL
    }), progressBarContainer = _$ref.progressBarContainer, progressBar = _$ref.progressBar, text = _$ref.text;
    var totalAnswers = useAppSelectorV2(selectTotalAnswers);
    var boundedCurrentValue = getCurrentValue(value !== null && value !== void 0 ? value : totalAnswers, total);
    var progressId = id;
    var progressLabelId = "".concat(progressId, "-label");
    var progressBarId = "".concat(progressId, "-bar");
    return(// `offset-viewport-exclusion` is needed for pages/_document.page.tsx to calculate initial `marginTop`
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: progressId,
        className: classnames_default()("offset-viewport-exclusion", progressBarContainer),
        ref: ref,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                id: progressLabelId,
                "aria-live": "polite",
                "aria-atomic": true,
                className: text,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                    desc: PersistentProgressBar_COPY.ANSWERED_WITH_PROGRESS_SR_PREFIX,
                    values: {
                        current: value !== null && value !== void 0 ? value : totalAnswers,
                        total: total,
                        visuallyHiddenEl: VisuallyHiddenEl
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar_ProgressBar, {
                id: progressBarId,
                "aria-labelledby": progressLabelId,
                value: boundedCurrentValue,
                borderColor: theme.secondaryAccentColor,
                progressColor: theme.secondaryAccentColor,
                radius: 5,
                height: 8,
                className: progressBar
            })
        ]
    }));
}
/* harmony default export */ var PersistentProgressBar_PersistentProgressBar = (/*#__PURE__*/(0,react.forwardRef)(PersistentProgressBar));

;// CONCATENATED MODULE: ./src/app/components/Survey/PersistentProgressBar/index.ts


// EXTERNAL MODULE: ./node_modules/@wds/modal/dist/index.es.js
var modal_dist_index_es = __webpack_require__(2304);
// EXTERNAL MODULE: ./node_modules/@wds/icons/dist/index.es.js
var icons_dist_index_es = __webpack_require__(9224);
// EXTERNAL MODULE: ./node_modules/@wds/button/dist/index.es.js + 1 modules
var button_dist_index_es = __webpack_require__(7837);
;// CONCATENATED MODULE: ./src/app/components/Survey/ModifiedSurveyDialog/useStyles.ts

var ModifiedSurveyDialog_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)({
    text: {
        margin: 0
    }
});
/* harmony default export */ var ModifiedSurveyDialog_useStyles = (ModifiedSurveyDialog_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/ModifiedSurveyDialog/index.tsx








var ModifiedSurveyDialog_DEFAULT_COPY = (0,dist/* defineMessages */.vU)({
    WARNING_ICON: {
        id: "Survey.ModifiedSurveyDialog.WarningIcon",
        defaultMessage: "Warning",
        description: "[Type: Paragraph][Vis: low] - Alt text for warning icon"
    },
    MODIFIED_HEADER: {
        id: "Survey.ModifiedSurveyDialog.ModifiedHeader",
        defaultMessage: "This survey was modified by its creator",
        description: "[Type: Header][Vis: High] - Header for modified dialog"
    },
    MODIFIED_DESCRIPTION: {
        id: "Survey.ModifiedSurveyDialog.ModifiedDescription",
        defaultMessage: "For questions on the page you’re currently on, you’ll need to re-submit your answers. Your answers for previous pages are saved (you’ll see them when you click OK). Survey creators usually make changes only when it’s vital to the data, so thank you for your patience.",
        description: "[Type: Paragraph][Vis: medium] - Description text for modified survey modal"
    },
    BUTTON: {
        id: "Survey.ModifiedSurveyDialog.Button",
        defaultMessage: "OK",
        description: "[Type: Button][Vis: High] - Button text"
    },
    CLOSE_DIALOG: {
        id: "Survey.ModifiedSurveyDialog.CloseDialog",
        defaultMessage: "Close dialog",
        description: "[Type: Button][Vis: High] - Label text for accessibility"
    }
});
function ModifiedSurveyDialog(param) {
    var onConfirmClick = param.onConfirmClick;
    var text = ModifiedSurveyDialog_useStyles().text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_es/* Modal */.u, {
        show: true,
        dismissible: false,
        size: "md",
        "data-testid": "ModifiedSurveyDialog",
        role: "alertdialog",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_es/* Modal.Header */.u.Header, {
                header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_es/* IconWarningFilled */.Hjf, {
                            title: (0,dist.t)(ModifiedSurveyDialog_DEFAULT_COPY.WARNING_ICON),
                            color: "darkMuted"
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                            desc: ModifiedSurveyDialog_DEFAULT_COPY.MODIFIED_HEADER
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_es/* Modal.Body */.u.Body, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: text,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                        desc: ModifiedSurveyDialog_DEFAULT_COPY.MODIFIED_DESCRIPTION
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_es/* Modal.Footer */.u.Footer, {
                align: "right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_es/* Button */.zx, {
                    label: (0,dist.t)(ModifiedSurveyDialog_DEFAULT_COPY.CLOSE_DIALOG),
                    onClick: onConfirmClick,
                    buttonType: "button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                        desc: ModifiedSurveyDialog_DEFAULT_COPY.BUTTON
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var Survey_ModifiedSurveyDialog = (FocusTrap_withFocusTrap(ModifiedSurveyDialog));

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/helper/surveyFormatEnum.ts
var surveyFormatEnum_SurveyFormat;
(function(SurveyFormat) {
    SurveyFormat["CLASSIC"] = "CLASSIC";
    SurveyFormat["OQAAT"] = "ONE_QUESTION_AT_A_TIME";
    SurveyFormat["CONVERSATIONAL"] = "CONVERSATIONAL";
})(surveyFormatEnum_SurveyFormat || (surveyFormatEnum_SurveyFormat = {}));
/* harmony default export */ var surveyFormatEnum = (surveyFormatEnum_SurveyFormat);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/helper/extrapolateSurveyData.ts


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
var extrapolateSurveyData = function(survey) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39;
    var _availableSurveyLanguages;
    return {
        isOQAAT: survey.format === surveyFormatEnum.OQAAT,
        isClassicMode: survey.format === surveyFormatEnum.CLASSIC,
        isFooterEnabled: (ref = survey.design) === null || ref === void 0 ? void 0 : (ref1 = ref.footer) === null || ref1 === void 0 ? void 0 : ref1.enabled,
        isProgressBarEnabled: !!((ref2 = survey.design) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.progressBar) === null || ref3 === void 0 ? void 0 : ref3.enabled),
        isQuestionNumberingEnabled: (ref4 = survey.design) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.questionNumbering) === null || ref5 === void 0 ? void 0 : ref5.enabled,
        isSurveyTitleEnabled: (ref6 = survey.design) === null || ref6 === void 0 ? void 0 : ref6.surveyTitle.enabled,
        logo: {
            enabled: (ref7 = survey.design) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.logo) === null || ref8 === void 0 ? void 0 : ref8.enabled,
            size: (ref9 = survey.design) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.logo) === null || ref10 === void 0 ? void 0 : ref10.size,
            height: (ref11 = survey.design) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.logo) === null || ref12 === void 0 ? void 0 : ref12.height,
            width: (ref13 = survey.design) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.logo) === null || ref14 === void 0 ? void 0 : ref14.width,
            verticalAlignment: (ref15 = survey.design) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.logo) === null || ref16 === void 0 ? void 0 : ref16.verticalAlignment,
            imageUrl: (ref17 = survey.design) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.logo) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.image) === null || ref19 === void 0 ? void 0 : ref19.url,
            description: (ref20 = survey.design) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.logo) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.image) === null || ref22 === void 0 ? void 0 : ref22.description
        },
        totalPages: survey === null || survey === void 0 ? void 0 : (ref23 = survey.pages) === null || ref23 === void 0 ? void 0 : ref23.totalCount,
        showPageTitles: (ref24 = survey.design) === null || ref24 === void 0 ? void 0 : ref24.showPageTitles,
        showPageNumbers: !!((ref25 = survey.design) === null || ref25 === void 0 ? void 0 : ref25.showPageNumbers),
        showRequiredQuestionAsterisks: (ref26 = survey.design) === null || ref26 === void 0 ? void 0 : ref26.showRequiredQuestionAsterisks,
        surveyTitle: survey.title,
        surveyTitleAlignment: (ref27 = survey.design) === null || ref27 === void 0 ? void 0 : ref27.surveyTitle.horizontalAlignment,
        surveyTitleHTML: survey.titleHTML,
        themeVersion: (ref28 = survey.design) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.theme) === null || ref29 === void 0 ? void 0 : ref29.version,
        totalQuestionsCount: survey.questionCount,
        answerableQuestionCount: survey === null || survey === void 0 ? void 0 : survey.answerableQuestionCount,
        labels: {
            ok: (ref30 = survey.navigation) === null || ref30 === void 0 ? void 0 : ref30.ok.label,
            previous: (ref31 = survey.navigation) === null || ref31 === void 0 ? void 0 : ref31.previous.label,
            next: (ref32 = survey.navigation) === null || ref32 === void 0 ? void 0 : ref32.next.label,
            done: (ref33 = survey.navigation) === null || ref33 === void 0 ? void 0 : ref33.done.label
        },
        progressBar: {
            position: (ref34 = survey.design) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.progressBar) === null || ref35 === void 0 ? void 0 : ref35.position,
            showPercent: (ref36 = survey.design) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.progressBar) === null || ref37 === void 0 ? void 0 : ref37.showPercent,
            showPageCount: (ref38 = survey.design) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.progressBar) === null || ref39 === void 0 ? void 0 : ref39.showPageNumber
        },
        languages: [
            survey.defaultSurveyLanguage
        ].concat((0,_to_consumable_array/* default */.Z)((_availableSurveyLanguages = survey.availableSurveyLanguages) !== null && _availableSurveyLanguages !== void 0 ? _availableSurveyLanguages : [])).sort(function(a, b) {
            return a.displayName.localeCompare(b.displayName);
        })
    };
};
/* harmony default export */ var helper_extrapolateSurveyData = (extrapolateSurveyData);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/useStyles.ts

var SurveyTaking_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    return {
        // Document banner container
        surveyHeaderContainer: {},
        // Exit-link container
        surveyToolbarContainer: {},
        // Survey Title container
        surveyTitleContainer: {},
        // Page Header container
        pageHeaderContainer: {},
        // Main container
        mainContainer: {
            outline: "none"
        },
        layoutMainContainer: {
            marginTop: function(param) {
                var offsetTop = param.offsetTop;
                return "".concat(offsetTop, "px");
            }
        },
        // Form
        questionContainer: {
            paddingTop: "32px"
        },
        // Page Footer Container
        pageFooterContainer: {
            margin: [
                30,
                0,
                24
            ]
        },
        pageNavigationContainer: {},
        // May not be used
        // Page description OK button
        sronlyFocus: {
            "&:not(:focus),&:not(:hover)": {
                clip: "rect(1px, 1px, 1px, 1px)",
                clipPath: "inset(50%)",
                height: 1,
                width: 1,
                overflow: "hidden",
                padding: 0
            }
        },
        pageDescriptionOkButton: {
            marginTop: 40
        },
        surveyFooterContainer: {
            padding: [
                0,
                0,
                40,
                0
            ],
            marginBottom: function(param) {
                var _offsetBottom = param.offsetBottom, offsetBottom = _offsetBottom === void 0 ? 0 : _offsetBottom;
                return "".concat(offsetBottom, "px");
            }
        },
        classicProgressBarTop: {
            marginBottom: "36px"
        },
        customThankyouContainer: {
            display: "flex",
            justifyContent: "center",
            fontSize: theme.questionBody.fontSize
        }
    };
});
/* harmony default export */ var SurveyTaking_useStyles = (SurveyTaking_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/Logo/useStyles.ts

// Logo alignment comes in as `verticalAlignment`, and the keys represent
// values available from GraphQL API (SurveyLogoAlignment).  Presently, the
// only options to choose from are: CENTER, LEFT_TOP, RIGHT_TOP.
var surveyLogoAlignment = {
    CENTER: {
        justify: "center",
        align: "center"
    },
    LEFT_TOP: {
        justify: "flex-start",
        align: "flex-start"
    },
    RIGHT_TOP: {
        justify: "flex-end",
        align: "flex-start"
    },
    // Here for other values when implemented
    BASELINE: {
        justify: "flex-start",
        align: "baseline"
    },
    BOTTOM: {
        justify: "center",
        align: "flex-end"
    },
    LEFT_MIDDLE: {
        justify: "flex-start",
        align: "center"
    },
    RIGHT_MIDDLE: {
        justify: "flex-end",
        align: "center"
    },
    TOP: {
        justify: "center",
        align: "flex-start"
    }
};
var isActualSize = function(size) {
    // presently, `null` is returned in place of 'ACTUAL', here for any regression.
    return size === null || size === "ACTUAL";
};
var Logo_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)({
    logoContainer: {
        display: "flex",
        width: "100%",
        justifyContent: function(param) {
            var verticalAlignment = param.verticalAlignment;
            return verticalAlignment && surveyLogoAlignment[verticalAlignment].justify;
        },
        alignItems: function(param) {
            var verticalAlignment = param.verticalAlignment;
            return verticalAlignment && surveyLogoAlignment[verticalAlignment].align;
        }
    },
    logoWrapper: {
        width: function(param) {
            var size = param.size, width = param.width;
            return size && !isActualSize(size) ? width : "auto";
        },
        height: function(param) {
            var size = param.size, height = param.height;
            return size && !isActualSize(size) ? height : "auto";
        }
    },
    logoImage: {
        width: "100%",
        height: "100%"
    }
});
/* harmony default export */ var Logo_useStyles = (Logo_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/Logo/Logo.tsx






function Logo(_param) {
    var id = _param.id, size = _param.size, height = _param.height, width = _param.width, imageUrl = _param.imageUrl, verticalAlignment = _param.verticalAlignment, altText = _param.description, props = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "size",
        "height",
        "width",
        "imageUrl",
        "verticalAlignment",
        "description"
    ]);
    var ref = Logo_useStyles({
        verticalAlignment: verticalAlignment !== null && verticalAlignment !== void 0 ? verticalAlignment : "LEFT_TOP",
        size: size !== null && size !== void 0 ? size : "ACTUAL",
        width: width !== null && width !== void 0 ? width : 0,
        height: height !== null && height !== void 0 ? height : 0
    }), logoContainer = ref.logoContainer, logoWrapper = ref.logoWrapper, logoImage = ref.logoImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: id,
        className: logoContainer
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: logoWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: imageUrl !== null && imageUrl !== void 0 ? imageUrl : "",
                alt: altText !== null && altText !== void 0 ? altText : "",
                className: logoImage
            })
        })
    }));
}
/* harmony default export */ var Logo_Logo = ((/* unused pure expression or super */ null && (Logo)));

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/Logo/index.ts


;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/hooks/useCenterContainerOffset.ts


var useCenterContainerOffset = function(centerTarget, mainContainer, viewportExclusions, heightExclusions, adjustment) {
    var ref;
    /**
   * Global variable set in template during the initial rendering
   * (to reduce layout change)
   *
   * _will never be set during SSR render_
   */ var preReactOffsetTop = (ref = globalThis.SM) === null || ref === void 0 ? void 0 : ref.__OFFSET_TOP_OF_SURVEY__;
    var ref1 = (0,react.useState)(preReactOffsetTop !== null && preReactOffsetTop !== void 0 ? preReactOffsetTop : 0), offsetTop = ref1[0], setOffsetTop = ref1[1];
    var calculateOffsetTop = (0,react.useCallback)(function() {
        var winH = window.innerHeight;
        var ref;
        var targetContainerHeight = (ref = centerTarget === null || centerTarget === void 0 ? void 0 : centerTarget.offsetHeight) !== null && ref !== void 0 ? ref : 0;
        if (!centerTarget || targetContainerHeight === 0) {
            // do not calculate offset if ref is not set yet
            return;
        }
        var ref1;
        var viewport = winH - viewportExclusions.reduce(function(a, ref) {
            var _$ref;
            return a + ((ref1 = (_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.offsetHeight) !== null && ref1 !== void 0 ? ref1 : 0);
        }, 0);
        var ref2;
        var excludeHeight = heightExclusions.reduce(function(a, ref) {
            var _$ref;
            return a + ((ref2 = (_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.offsetHeight) !== null && ref2 !== void 0 ? ref2 : 0);
        }, 0);
        var margin = targetContainerHeight > 0 ? Math.max(10, viewport / 2 - targetContainerHeight / 2 - excludeHeight) : 0;
        var ref3;
        margin = (ref3 = adjustment === null || adjustment === void 0 ? void 0 : adjustment(margin)) !== null && ref3 !== void 0 ? ref3 : margin;
        setOffsetTop(margin);
    }, [
        centerTarget,
        viewportExclusions,
        heightExclusions,
        adjustment
    ]);
    hooks_useIsomorphicLayoutEffect(function() {
        window.addEventListener("resize", calculateOffsetTop);
        return function() {
            return window.removeEventListener("resize", calculateOffsetTop);
        };
    }, [
        calculateOffsetTop
    ]);
    // Remove `marginTop` set during boot-up on template from `mainContainer`
    hooks_useIsomorphicLayoutEffect(function() {
        var ref;
        if ((ref = mainContainer.current) === null || ref === void 0 ? void 0 : ref.style.marginTop) {
            // eslint-disable-next-line no-param-reassign
            mainContainer.current.style.marginTop = "";
        }
    }, [
        mainContainer
    ]);
    (0,react.useEffect)(function() {
        calculateOffsetTop();
    }, [
        centerTarget,
        calculateOffsetTop,
        viewportExclusions,
        heightExclusions
    ]);
    return offsetTop;
};
/* harmony default export */ var hooks_useCenterContainerOffset = (useCenterContainerOffset);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/helper/generateEventDataForLogs.ts

var DeviceType = {
    MOBILE: "MOBILE",
    DESKTOP: "PC",
    TABLET: "TABLET",
    OTHER: "OTHER",
    BOT: "BOT"
};
var _getDeviceType = function() {
    var ref = (0,utils_dist.getClientEnvironmentDetails)(), isMobile = ref.isMobile, isDesktop = ref.isDesktop, isTablet = ref.isTablet;
    if (isMobile) return DeviceType.MOBILE;
    if (isDesktop) return DeviceType.DESKTOP;
    if (isTablet) return DeviceType.TABLET;
    // if (isBot) return DeviceType.BOT;
    return DeviceType.OTHER;
};
var generateEventData = function(param) {
    var environment = param.environment, user = param.user, collector = param.collector, survey = param.survey, pageNumber = param.pageNumber;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var countryCode = environment.countryCode, domain = environment.domain, tld = environment.tld;
    var packageId = user.package, userId = user.id;
    var ref17, _id, ref18, ref19, ref20, ref21, ref22, ref23;
    return {
        collector_id: collector === null || collector === void 0 ? void 0 : collector.id,
        collector_type: collector === null || collector === void 0 ? void 0 : collector.type,
        country: countryCode,
        device_type: _getDeviceType(),
        domain_setting: "".concat(domain, ".").concat(tld),
        footer_status: survey === null || survey === void 0 ? void 0 : (ref = survey.design) === null || ref === void 0 ? void 0 : (ref1 = ref.footer) === null || ref1 === void 0 ? void 0 : ref1.enabled,
        is_custom_theme: survey === null || survey === void 0 ? void 0 : (ref2 = survey.design) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.theme) === null || ref3 === void 0 ? void 0 : ref3.isCustomTheme,
        is_group_theme: survey === null || survey === void 0 ? void 0 : (ref4 = survey.design) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.theme) === null || ref5 === void 0 ? void 0 : ref5.isTeamTheme,
        is_stock_theme: survey === null || survey === void 0 ? void 0 : (ref6 = survey.design) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.theme) === null || ref7 === void 0 ? void 0 : ref7.isStockTheme,
        is_survey_quiz_enabled: survey === null || survey === void 0 ? void 0 : survey.isQuiz,
        language: survey === null || survey === void 0 ? void 0 : survey.language.name,
        logo_status: survey === null || survey === void 0 ? void 0 : (ref8 = survey.design) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.logo) === null || ref9 === void 0 ? void 0 : ref9.enabled,
        package_id: packageId,
        page_count: survey === null || survey === void 0 ? void 0 : (ref10 = survey.pages) === null || ref10 === void 0 ? void 0 : ref10.totalCount,
        page_number: pageNumber,
        question_count: survey === null || survey === void 0 ? void 0 : survey.questionCount,
        response_quality: "",
        survey_id: (ref17 = survey === null || survey === void 0 ? void 0 : survey.id) !== null && ref17 !== void 0 ? ref17 : "",
        survey_language_id: (_id = survey === null || survey === void 0 ? void 0 : survey.language.id) !== null && _id !== void 0 ? _id : "",
        survey_owner_user_id: (ref18 = survey === null || survey === void 0 ? void 0 : survey.userId) !== null && ref18 !== void 0 ? ref18 : "",
        survey_style: (ref19 = survey === null || survey === void 0 ? void 0 : survey.format) !== null && ref19 !== void 0 ? ref19 : null,
        theme_id: (ref20 = survey === null || survey === void 0 ? void 0 : (ref11 = survey.design) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.theme) === null || ref12 === void 0 ? void 0 : ref12.id) !== null && ref20 !== void 0 ? ref20 : "",
        theme_name: (ref21 = survey === null || survey === void 0 ? void 0 : (ref13 = survey.design) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.theme) === null || ref14 === void 0 ? void 0 : ref14.name) !== null && ref21 !== void 0 ? ref21 : "",
        theme_version: (ref22 = survey === null || survey === void 0 ? void 0 : (ref15 = survey.design) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.theme) === null || ref16 === void 0 ? void 0 : ref16.version) !== null && ref22 !== void 0 ? ref22 : "V3",
        user_id: userId,
        version: (ref23 = survey === null || survey === void 0 ? void 0 : survey.version) !== null && ref23 !== void 0 ? ref23 : 1
    };
};
/* harmony default export */ var generateEventDataForLogs = (generateEventData);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/PageNavigation/useStyles.ts


var PageNavigation_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    var ref, ref1, ref2, ref3;
    var _max, _max1, _max2, _max3;
    var _obj, _obj1;
    return {
        // Page Navigation
        pageNavigationContainer: (_obj = {
            display: "flex",
            justifyContent: "center",
            alignItems: "stretch",
            flexWrap: "wrap",
            // negative margin to counter right-side margin on buttons (so they align with the right edge)
            marginRight: "-5px"
        }, (0,_define_property/* default */.Z)(_obj, "@media (max-width: ".concat((_max = (ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref.xs.max) !== null && _max !== void 0 ? _max : "640px", ")"), {
            marginRight: "-10px"
        }), (0,_define_property/* default */.Z)(_obj, "@media (max-width: ".concat((_max1 = (ref1 = theme.breakpoints) === null || ref1 === void 0 ? void 0 : ref1.xxs.max) !== null && _max1 !== void 0 ? _max1 : "480px", ")"), {
            flexWrap: "nowrap"
        }), _obj),
        // Page Navigation Buttons
        navButtons: (_obj1 = {
            marginBottom: "10px",
            marginRight: "5px",
            transition: "all 0.2s linear",
            // reverse button order for RTL
            "&:first-child": {
                order: function(param) {
                    var isRTL = param.isRTL;
                    return isRTL ? 3 : 1;
                }
            },
            "&:last-child": {
                order: function(param) {
                    var isRTL = param.isRTL;
                    return isRTL ? 1 : 3;
                }
            }
        }, (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat((_max2 = (ref2 = theme.breakpoints) === null || ref2 === void 0 ? void 0 : ref2.xs.max) !== null && _max2 !== void 0 ? _max2 : "640px", ")"), {
            marginRight: "10px"
        }), (0,_define_property/* default */.Z)(_obj1, "@media (max-width: ".concat((_max3 = (ref3 = theme.breakpoints) === null || ref3 === void 0 ? void 0 : ref3.xxs.max) !== null && _max3 !== void 0 ? _max3 : "480px", ")"), {
            flexBasis: "100%"
        }), _obj1)
    };
});
/* harmony default export */ var PageNavigation_useStyles = (PageNavigation_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/PageNavigation/PageNavigation.tsx













var PageNavigation_COPY = (0,dist/* defineMessages */.vU)({
    PREVIOUS: {
        id: "SurveyTaking.PageNavigation.Previous",
        defaultMessage: "Previous",
        description: "[Type: button][Vis: high] - Allows the respondent to go back to the previous page to review or edit their response."
    },
    NEXT: {
        id: "SurveyTaking.PageNavigation.Next",
        defaultMessage: "Next",
        description: "[Type: button][Vis: high] - Saves the responses for that page in the Analyze Results section and proceeds to the next page in the survey."
    },
    DONE: {
        id: "SurveyTaking.PageNavigation.Done",
        defaultMessage: "Done",
        description: "[Type: button][Vis: high] - Submits the survey and saves the response as Complete in the Analyze Results section."
    }
});
/**
 * Determine if a translation attribute applies if a user-generated label
 * is not provided
 * @param label - A user-generated label
 * @param defaultLabel - a default label
 * @returns {Object} and object with a label and translation details
 */ function getButtonDetails(label, defaultLabel) {
    return {
        label: label !== null && label !== void 0 ? label : defaultLabel,
        translate: label ? "no" : undefined
    };
}
var PageNavigation = function(param, ref) {
    var labels = param.labels, className = param.className, currentPage = param.currentPage, _totalPages = param.totalPages, totalPages = _totalPages === void 0 ? 1 : _totalPages, onNext = param.onNext, onPrevious = param.onPrevious, onDone = param.onDone, disableSubmit = param.disableSubmit, _showPrevious = param.showPrevious, showPrevious = _showPrevious === void 0 ? false : _showPrevious;
    var ref1;
    var collector = useAppSelectorV2(selectCollector);
    var survey = useAppSelectorV2(selectSurvey);
    var activePage = useAppSelectorV2(selectActivePage);
    var isRTL = (0,react.useContext)(dist/* L10NContext */.kR).isRTL;
    var ref2 = PageNavigation_useStyles({
        isRTL: isRTL
    }), pageNavigationContainer = ref2.pageNavigationContainer, navButtons = ref2.navButtons;
    var prevButton = getButtonDetails(decodeHtmlEntities(labels === null || labels === void 0 ? void 0 : labels.previous), /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
        desc: PageNavigation_COPY.PREVIOUS
    }));
    var doneButton = getButtonDetails(decodeHtmlEntities(labels === null || labels === void 0 ? void 0 : labels.done), /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
        desc: PageNavigation_COPY.DONE
    }));
    var nextButton = getButtonDetails(decodeHtmlEntities(labels === null || labels === void 0 ? void 0 : labels.next), /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
        desc: PageNavigation_COPY.NEXT
    }));
    var ref3 = (0,react.useContext)(StaticContext/* StaticContext */.vN), environment = ref3.environment, user = ref3.user;
    var ref4;
    var pageNumber = (ref4 = activePage === null || activePage === void 0 ? void 0 : (ref1 = activePage.surveyPage) === null || ref1 === void 0 ? void 0 : ref1.position) !== null && ref4 !== void 0 ? ref4 : 1;
    var otherEventData = generateEventDataForLogs({
        environment: environment,
        user: user,
        collector: collector,
        survey: survey,
        pageNumber: pageNumber
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(pageNavigationContainer, className),
        children: [
            currentPage > 1 && showPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyButton/* SurveyButton */.c, {
                translate: prevButton.translate,
                className: navButtons,
                size: "lg",
                onClick: onPrevious,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: prevButton.label
                })
            }),
            currentPage === totalPages && /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyButton/* SurveyButton */.c, {
                translate: doneButton.translate,
                className: navButtons,
                size: "lg",
                onClick: function() {
                    if (!disableSubmit) {
                        onDone();
                    }
                },
                disabled: !!disableSubmit,
                suppressHydrationWarning: true,
                "data-sm-metrics": (0,metrics_dist.generateMetricsAttribute)({
                    data: (0,_object_spread/* default */.Z)({
                        actionType: "final_submit",
                        actionFlow: "survey_completed"
                    }, otherEventData)
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: doneButton.label
                })
            }),
            currentPage < totalPages && /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyButton/* SurveyButton */.c, {
                translate: nextButton.translate,
                className: navButtons,
                size: "lg",
                onClick: onNext,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: nextButton.label
                })
            })
        ]
    });
};
/* harmony default export */ var PageNavigation_PageNavigation = (/*#__PURE__*/(0,react.forwardRef)(PageNavigation));

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/PageNavigation/index.ts


;// CONCATENATED MODULE: ./src/app/components/Survey/ClassicProgressBar/useStyles.ts



var ClassicProgressBar_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    var ref, ref1, ref2, ref3, ref4;
    var _primaryAccentColor, _secondaryAccentColor;
    var _obj;
    return {
        progressBarContainer: (_obj = {
            boxSizing: "border-box",
            height: 24,
            background: (_primaryAccentColor = theme.primaryAccentColor) !== null && _primaryAccentColor !== void 0 ? _primaryAccentColor : {},
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "auto",
            width: "100%",
            padding: "0 24px",
            borderRadius: 12,
            gap: "12px",
            direction: function(param) {
                var isRTL = param.isRTL;
                return isRTL ? "rtl" : null;
            }
        }, (0,_define_property/* default */.Z)(_obj, "@media only screen and (min-width: ".concat((ref = theme.breakpoints) === null || ref === void 0 ? void 0 : ref.sm.min, ")"), {
            width: !isLeftOrRight(theme.layout) ? "75%" : "100%"
        }), (0,_define_property/* default */.Z)(_obj, "@media only screen and (min-width: ".concat((ref1 = theme.breakpoints) === null || ref1 === void 0 ? void 0 : ref1.md.min, ")"), {
            width: !isLeftOrRight(theme.layout) ? "50%" : ""
        }), (0,_define_property/* default */.Z)(_obj, "@media only screen and (min-width: ".concat((ref2 = theme.breakpoints) === null || ref2 === void 0 ? void 0 : ref2.lg.min, ")"), {
            width: isPartialThird(theme.layout) ? "75%" : ""
        }), (0,_define_property/* default */.Z)(_obj, "@media only screen and (min-width: ".concat((ref3 = theme.breakpoints) === null || ref3 === void 0 ? void 0 : ref3.xl.min, ")"), {
            width: isPartialHalf(theme.layout) || isFullLeftOrRight(theme.layout) ? "75%" : "50%"
        }), _obj),
        progressBar: {
            width: "100%"
        },
        label: {
            fontFamily: theme === null || theme === void 0 ? void 0 : (ref4 = theme.questionBody) === null || ref4 === void 0 ? void 0 : ref4.fontFamily,
            color: (_secondaryAccentColor = theme.secondaryAccentColor) !== null && _secondaryAccentColor !== void 0 ? _secondaryAccentColor : {},
            fontSize: 13
        }
    };
});
/* harmony default export */ var ClassicProgressBar_useStyles = (ClassicProgressBar_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/ClassicProgressBar/ClassicProgressBar.tsx





var ClassicProgressBar_getCurrentValue = function(value, total) {
    if (total <= 0) {
        return 0;
    }
    return Math.round(value / total * 100);
};
var ClassicProgressBar = function(param) {
    var _id = param.id, id = _id === void 0 ? "classic-progress" : _id, value = param.value, total = param.total, isRTL = param.isRTL, _showPageCount = param.showPageCount, showPageCount = _showPageCount === void 0 ? true : _showPageCount, _showPercentage = param.showPercentage, showPercentage = _showPercentage === void 0 ? true : _showPercentage;
    var theme = (0,context/* useSurveyTheme */.u7)();
    var progressId = id;
    var progressLabelId = "".concat(progressId, "-label");
    var progressBarId = "".concat(progressId, "-bar");
    var currentValue = ClassicProgressBar_getCurrentValue(value, total);
    var accentColor = theme.secondaryAccentColor;
    var ref = ClassicProgressBar_useStyles({
        isRTL: !!isRTL
    }), progressBarContainer = ref.progressBarContainer, progressBar = ref.progressBar, label = ref.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: progressId,
        className: progressBarContainer,
        children: [
            showPageCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: label,
                children: [
                    value,
                    "\xa0/\xa0",
                    total
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar_ProgressBar, {
                id: progressBarId,
                className: progressBar,
                "aria-labelledby": progressLabelId,
                value: currentValue,
                borderColor: accentColor,
                progressColor: accentColor,
                radius: 12,
                height: 10
            }),
            showPercentage && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: label,
                children: "".concat(ClassicProgressBar_getCurrentValue(value, total), "%")
            })
        ]
    });
};
/* harmony default export */ var ClassicProgressBar_ClassicProgressBar = (ClassicProgressBar);

;// CONCATENATED MODULE: ./src/app/components/Survey/ClassicProgressBar/index.ts


;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/helper/currentSurveyView.ts

var isThankYouView = function(view) {
    return view === SurveyView.ThankYou;
};
var isSurveyTakingView = function(view) {
    return view === SurveyView.Taking;
};
/* harmony default export */ var currentSurveyView = ({
    isThankYouView: isThankYouView,
    isSurveyTakingView: isSurveyTakingView
});

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/smQuestionsCopy.ts

/**
 * Copy used by SMQuestions - re-declaring the messages here allows translation into the
 * 56 languages needed by RespWeb (as opposed to the 16 in SMQuestions)
 */ var smQuestionsCopy_COPY = (0,dist/* defineMessages */.vU)({
    QUESTION_TITLE: {
        id: "QuestionFieldLayoutTemplate.QUESTION_TITLE",
        defaultMessage: "Question Title",
        description: "[Type: Label][Vis: low] - question landmark for screen readers only"
    },
    NPS_QUESTION_TITLE: {
        id: "Nps.QUESTION_TITLE",
        defaultMessage: '<div class="{srOnlyClass}">On a scale of {minValue} to {maxValue}, </div>{heading}<div id="{instructionsId}" class="{srOnlyClass}"> {minValue} for {minLabelText}, {maxValue} for {maxLabelText}</div>',
        description: "[Type: header][Vis: high] - question title"
    },
    OK_LABEL: {
        id: "Button.OK_LABEL",
        defaultMessage: "OK",
        description: "[Type: button][Vis: high] - question ok label"
    },
    PREVIOUS_MONTH: {
        id: "CalendarPicker.previousMonth",
        defaultMessage: "Previous Month",
        description: "[Type: button][Vis: high] - button label to go to previous month"
    },
    NEXT_MONTH: {
        id: "CalendarPicker.nextMonth",
        defaultMessage: "Next Month",
        description: "[Type: button][Vis: high] - button label to go to next month"
    },
    MONTH_SELECT: {
        id: "CalendarPicker.month",
        defaultMessage: "Select a month",
        description: "[Type: label][Vis: high] - label for month selection combo box"
    },
    YEAR_SELECT: {
        id: "CalendarPicker.year",
        defaultMessage: "Select a year",
        description: "[Type: label][Vis: high] - label for year selection combo box"
    },
    MONTHS: {
        id: "CalendarPicker.months",
        defaultMessage: "{months, select, January {January} February {February} March {March} April {April} May {May} June {June} July {July} August {August} September {September} October {October} November {November} December {December}}",
        description: "[Type: label][Vis: high] - label for the months"
    },
    DAY_OF_WEEK_LEGEND_SHORT: {
        id: "Month.dayOfWeekLegendShort",
        defaultMessage: "{dayOfTheWeek, select, Mo {Mo} Tu {Tu} We {We} Th {Th} Fr {Fr} Sa {Sa} Su {Su}}",
        description: "[Type: label][Vis: high] - label for the day of the week in shorthand"
    },
    DAY_OF_WEEK_LEGEND_FULL: {
        id: "Month.dayOfWeekLegendLong",
        defaultMessage: "{dayOfTheWeek, select, Mo {Monday} Tu {Tuesday} We {Wednesday} Th {Thursday} Fr {Friday} Sa {Saturday} Su {Sunday}}",
        description: "[Type: label][Vis: high] - label for the day of the week"
    },
    DAY_OF_MONTH: {
        id: "Day.dayOfMonth",
        defaultMessage: "{dayInCalendar, date, full}",
        description: "[Type: label][Vis: high] - label for the full date"
    },
    DATE_INTL_FORMAT_ERROR: {
        id: "DateTime.dateIntlFormatError",
        defaultMessage: "Please provide date in DD/MM/YYYY format.",
        description: "[Type: label][Vis: high] - label for incorrect or missing date error (using ISO 8601 US date character format notation)"
    },
    DATE_US_FORMAT_ERROR: {
        id: "DateTime.dateUsFormatError",
        defaultMessage: "Please provide date in MM/DD/YYYY format.",
        description: "[Type: label][Vis: high] - label for incorrect or missing date error (using ISO 8601 international date character format notation)"
    },
    ERROR_ENTER_HOURS: {
        id: "DateTime.errorEnterHours",
        defaultMessage: "Please enter hours from 0 to 12.",
        description: "[Type: label][Vis: high] - label for incorrect or missing hour input"
    },
    ERROR_ENTER_MINUTES: {
        id: "DateTime.errorEnterMinutes",
        defaultMessage: "Please enter minutes from 0 to 59.",
        description: "[Type: label][Vis: high] - label for incorrect or missing minute input"
    },
    ERROR_SELECT_PERIOD: {
        id: "DateTime.errorSelectPeriod",
        defaultMessage: "Please select AM/PM.",
        description: "[Type: label][Vis: high] - label for incorrect or missing period selection"
    },
    ARIA_RANK_MOVED_UP: {
        id: "Ranking.AriaRankMovedUp",
        defaultMessage: "{label} moved up to number {position}",
        description: "[Type: button][Vis: high] - accessible ranking moved up label"
    },
    ARIA_RANK_MOVED_DOWN: {
        id: "Ranking.AriaRankMovedDown",
        defaultMessage: "{label} moved down to number {position}",
        description: "[Type: button][Vis: high] - accessible ranking moved down label"
    },
    ARIA_RANK_MOVED_TO_TOP: {
        id: "Ranking.AriaRankAtTop",
        defaultMessage: "{label} moved to the top of the list",
        description: "[Type: button][Vis: high] - accessible ranking at top of list"
    },
    ARIA_RANK_MOVED_TO_BOTTOM: {
        id: "Ranking.AriaRankAtBottom",
        defaultMessage: "{label} moved to the bottom of the list",
        description: "[Type: button][Vis: high] - accessible ranking at bottom of list"
    }
});
/* harmony default export */ var smQuestionsCopy = ((/* unused pure expression or super */ null && (smQuestionsCopy_COPY)));

// EXTERNAL MODULE: ./node_modules/@sm/question-ui/respondent-survey.js
var question_ui_respondent_survey = __webpack_require__(4481);
;// CONCATENATED MODULE: ./src/app/components/core/NativeSelect/useStyles.ts

var NativeSelect_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)({
    selectContainerStyles: {
        maxWidth: "100%",
        position: "relative",
        display: "inline-flex",
        justifyContent: "flex-start",
        alignItems: "center",
        transition: "all 0.1s linear",
        borderRadius: "4px",
        color: "#000"
    },
    selectStyles: {
        position: "relative",
        display: "inline-flex",
        justifyContent: "flex-start",
        alignItems: "center",
        border: "1px solid transparent",
        "&:focus-within, &:hover": {
            border: "1px solid black"
        },
        lineHeight: "normal",
        outline: "none",
        fontWeight: "inherit",
        fontFamily: "inherit",
        fontSize: "inherit",
        backgroundColor: "#fff",
        color: "inherit",
        maxWidth: "100%",
        padding: "6px 1.75em 6px 6px",
        verticalAlign: "bottom",
        textSizeAdjust: "auto",
        // Prevent de fault chevron from showing
        mozAppearance: "none",
        webkitAppearance: "none",
        appearance: "none",
        transition: "border 0.1s linear"
    },
    selectIconStyles: {
        position: "absolute",
        width: "1em",
        height: "1em",
        display: "block",
        margin: "0 .5em",
        right: 0,
        zIndex: 2,
        pointerEvents: "none"
    },
    disabledStyles: {
        opacity: 0.4
    }
});
/* harmony default export */ var NativeSelect_useStyles = (NativeSelect_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/components/core/NativeSelect/NativeSelect.tsx








function NativeSelect(_param) {
    var required = _param.required, children = _param.children, disabled = _param.disabled, className = _param.className, _icon = _param.icon, icon = _icon === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(question_ui_respondent_survey/* CaretDownOutlineIcon */.tE, {}) : _icon, props = (0,_object_without_properties/* default */.Z)(_param, [
        "required",
        "children",
        "disabled",
        "className",
        "icon"
    ]);
    var ref = NativeSelect_useStyles(), selectStyles = ref.selectStyles, selectContainerStyles = ref.selectContainerStyles, selectIconStyles = ref.selectIconStyles, disabledStyles = ref.disabledStyles;
    var _props = icon.props, iconClasses = _props.className, iconProps = (0,_object_without_properties/* default */.Z)(_props, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()(selectContainerStyles, disabled ? disabledStyles : {}, className),
        children: [
            /*#__PURE__*/ react.cloneElement(icon, (0,_object_spread/* default */.Z)({
                // this will apply our placement styles, along with any other supplied classes
                className: classnames_default()(selectIconStyles, iconClasses)
            }, iconProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: selectStyles,
                required: required,
                "aria-required": required,
                "data-testid": "NativeSelect",
                disabled: disabled
            }, props), {
                children: children
            }))
        ]
    });
}
/* harmony default export */ var NativeSelect_NativeSelect = (NativeSelect);

;// CONCATENATED MODULE: ./src/app/components/core/NativeSelect/NativeSelectOption.tsx







var NativeSelectOption_useStyles = (0,react_jss_esm/* createUseStyles */.QM)({
    selectOption: {
        fontFamily: "inherit",
        fontSize: "inherit",
        fontWeight: "inherit"
    }
});
function NativeSelectOption(_param) {
    var children = _param.children, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    var selectOption = NativeSelectOption_useStyles().selectOption;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-testid": "NativeSelectOption",
        className: classnames_default()(selectOption, className)
    }, props), {
        children: children
    }));
}
/* harmony default export */ var NativeSelect_NativeSelectOption = (NativeSelectOption);

;// CONCATENATED MODULE: ./src/app/components/core/NativeSelect/index.ts



;// CONCATENATED MODULE: ./src/app/helpers/visuallyHidden.ts
/**
 * Visually Hidden CSS properties
 * @description common css-properties to visually hide text and available for screen-readers.
 * There may be times where the css-specificity may not be high enough for the class to be invoked,
 * Ergo, the use of `!important` which will help ensure the properties are applied at any specificity.
 * @example
 * // usage with `react-jss`
 * import visuallyHiddenProperties from './utils/visuallyHidden';
 *
 * const useStyles = createUseStyles({
 *   srOnly: {...visuallyHiddenProperties}
 * })
 */ /* harmony default export */ var visuallyHidden = ({
    border: [
        [
            0
        ],
        "!important"
    ],
    /**
   * @desc for backwards compatibility
   * @deprecated
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/clip
   * @see https://caniuse.com/mdn-css_properties_clip
   */ clip: [
        "rect(1px, 1px, 1px, 1px)",
        "!important"
    ],
    /**
   * @desc future-proof version
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/clip-path
   * @see https://caniuse.com/css-clip-path
   */ clipPath: [
        "inset(50%)",
        "!important"
    ],
    height: [
        "1px",
        "!important"
    ],
    margin: [
        "-1px",
        "!important"
    ],
    overflow: [
        "hidden",
        "!important"
    ],
    padding: [
        [
            0
        ],
        "!important"
    ],
    position: [
        "absolute",
        "!important"
    ],
    width: [
        "1px",
        "!important"
    ],
    /**
   * @desc preventing text to be condensed
   * @see https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
   */ whiteSpace: [
        "nowrap",
        "!important"
    ]
});

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/LanguageSelect/useStyles.ts




var LanguageSelect_useStyles_useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    return {
        srOnly: (0,_object_spread/* default */.Z)({}, visuallyHidden),
        selectContainer: {
            fontWeight: 400,
            fontFamily: dist_index_es/* WrenchTheme.type.fontFamily.base */.Qb.type.fontFamily.base,
            fontSize: dist_index_es/* WrenchTheme.type.fontSize.body */.Qb.type.fontSize.body,
            color: theme.titleColor,
            borderRadius: 0,
            "& select": {
                backgroundColor: "transparent",
                paddingRight: "1.5em",
                "&:focus-within, &:hover": {
                    border: "1px solid ".concat(theme.titleColor)
                }
            },
            "& option": {
                color: "#000"
            },
            "& svg": {
                width: "0.75em",
                height: "0.75em"
            }
        }
    };
});
/* harmony default export */ var LanguageSelect_useStyles = (LanguageSelect_useStyles_useStyles);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/LanguageSelect/LanguageSelect.tsx






var LanguageSelect_COPY = (0,dist/* defineMessages */.vU)({
    SELECT_LABEL: {
        id: "SurveyTaking.LanguageSelect.Label",
        defaultMessage: "Change survey language",
        description: "[Type: label][Vis: high] - the text that describes the language select"
    }
});
function LanguageSelect(param) {
    var selectedLangCode = param.selectedLangCode, languages = param.languages, onChange = param.onChange;
    var ref = LanguageSelect_useStyles(), selectContainer = ref.selectContainer, srOnly = ref.srOnly;
    // on initial load currentLang is the default(en) or based on the url of the page if language is already set
    var ref1 = (0,react.useState)(selectedLangCode), currentLang = ref1[0], setCurrentLang = ref1[1];
    // if there is just one language then the survey only supports
    // the currently selected language and we don't show the select
    if (languages.length <= 1) {
        return null;
    }
    var handleLanguageSelect = function(event) {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        if (!event.isDefaultPrevented()) {
            setCurrentLang(event.target.value);
            window.location.assign("?lang=".concat(event.target.value));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: srOnly,
                htmlFor: "survey-language",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                    desc: LanguageSelect_COPY.SELECT_LABEL
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect_NativeSelect, {
                id: "survey-language",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(question_ui_respondent_survey/* CaretDownOutlineIcon */.tE, {}),
                onChange: handleLanguageSelect,
                value: currentLang,
                className: selectContainer,
                "data-testid": "LanguageSelect",
                children: languages.map(function(lang) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeSelect_NativeSelectOption, {
                        id: lang.id,
                        lang: lang.code.split("_")[0],
                        value: lang.code,
                        children: lang.displayName
                    }, lang.id);
                })
            })
        ]
    });
}
/* harmony default export */ var LanguageSelect_LanguageSelect = (LanguageSelect);

;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/components/LanguageSelect/index.ts


;// CONCATENATED MODULE: ./src/app/pages/SurveyTaking/v2/Survey.tsx











































// needed to add SMQuestions copy to the translations list




var Survey_COPY = (0,dist/* defineMessages */.vU)({
    SKIP_LINK_CONTENT: {
        id: "SurveyTaking.Survey.SkipLinkContent",
        defaultMessage: "Skip to content",
        description: "[Type: label][Vis: med] - Skip to content link label (Accessibility)"
    },
    OK_LABEL: {
        id: "SurveyTaking.Survey.OK_LABEL",
        defaultMessage: "OK",
        description: "[Type: button][Vis: high] - question/description ok label for One-Question-At-A-Time mode"
    }
});
var Survey = function(param) {
    var pageRequestId = param.pageRequestId, showRequestId = param.showRequestId, _reqLocale = param.reqLocale, reqLocale = _reqLocale === void 0 ? "en" : _reqLocale;
    var ref, ref1, ref2, ref3, ref4;
    var survey = useAppSelectorV2(selectSurvey);
    var collector = useAppSelectorV2(selectCollector);
    var ref5;
    var currentPageId = (ref5 = useAppSelectorV2(selectCurrentPageId)) !== null && ref5 !== void 0 ? ref5 : "";
    var encrytedSurveyParams = useAppSelectorV2(selectEncrytedSurveyParams);
    var ref6;
    var pagePath = (ref6 = useAppSelectorV2(selectPagePath)) !== null && ref6 !== void 0 ? ref6 : [];
    var activePage = useAppSelectorV2(selectActivePage);
    var activePageMeta = activePage === null || activePage === void 0 ? void 0 : activePage.surveyPage;
    var clientToken = useAppSelectorV2(selectClientToken);
    var views = useAppSelectorV2(selectViews);
    var questions = useAppSelectorV2(selectQuestions);
    var answers = useAppSelectorV2(selectAnswers);
    var collectorKey = useAppSelectorV2(selectCollectorKey);
    var localStorageAnswers = decryptAnswers(collectorKey);
    var hasVersionChanged = useAppSelectorV2(selectHasVersionChanged);
    var pagePathIndex = pagePath.indexOf(parseInt(currentPageId, 10)) || -1;
    var currentPagePosition = pagePathIndex + 1 || 1;
    var currentSurveyView = useAppSelectorV2(selectSurveyView);
    var isCurrentViewCustomThankYou = isThankYouView(currentSurveyView);
    var isCurrentViewSurveyTaking = isSurveyTakingView(currentSurveyView);
    var dispatch = useAppDispatchV2();
    var surveyTheme = (0,context/* useSurveyTheme */.u7)();
    var handlePageReload = (0,react.useCallback)(function() {
        // scroll to top so the viewport starts at top of page on reload
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "auto"
        });
        window.location.reload();
    }, []);
    var layoutContainerRef = react.useRef(null);
    var persistentProgressRef = react.useRef(null);
    var partialContainerRef = react.useRef(null);
    var logoContainerRef = react.useRef(null);
    var toolbarContainerRef = react.useRef(null);
    var topContainerRef = react.useRef(null);
    var mainContainerRef = react.useRef(null);
    var pageNavigationRef = react.useRef(null);
    var surveyFooterRef = react.useRef(null);
    var mainRef = react.useRef(null);
    var ref7 = (0,react.useState)(null), firstViewElement = ref7[0], setFirstViewElement = ref7[1];
    /** Queries the survey version and applies version-changed errors when called */ var verifySurveyVersion = useVerifySurveyVersion();
    (0,react.useEffect)(function() {
        setFirstViewElement(document.getElementById("view-".concat(views[0])));
    }, [
        views
    ]);
    var offsetTop = hooks_useCenterContainerOffset(firstViewElement, mainContainerRef, [
        persistentProgressRef
    ], [
        topContainerRef
    ], function(margin) {
        var ref, ref1;
        if (hasVersionChanged) return margin;
        if ((survey === null || survey === void 0 ? void 0 : (ref = survey.design) === null || ref === void 0 ? void 0 : (ref1 = ref.theme) === null || ref1 === void 0 ? void 0 : ref1.version) === "V3") {
            var cr = window.getComputedStyle(mainContainerRef === null || mainContainerRef === void 0 ? void 0 : mainContainerRef.current);
            return Math.abs(margin / 2 - parseInt(cr.paddingTop, 10));
        }
        return margin;
    });
    /**
   * calculateOffsetBottom
   * Calculate bottom margin for the SurveyFooter. This ensures there is
   * enough room for footer links and last question can move to centre page.
   */ var ref8 = (0,react.useState)(0), offsetBottom = ref8[0], setOffsetBottom = ref8[1];
    hooks_useIsomorphicLayoutEffect(function() {
        var calculateOffsetBottom = function() {
            var ref, ref1, ref2, ref3;
            if ((survey === null || survey === void 0 ? void 0 : survey.format) !== surveyFormatEnum.OQAAT) return;
            var ref4;
            var footerHeight = (ref4 = (ref = surveyFooterRef.current) === null || ref === void 0 ? void 0 : ref.offsetHeight) !== null && ref4 !== void 0 ? ref4 : 0;
            var ref5;
            var progressHeight = (ref5 = (ref1 = persistentProgressRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight) !== null && ref5 !== void 0 ? ref5 : 0;
            var offset = footerHeight + progressHeight;
            setOffsetBottom((survey === null || survey === void 0 ? void 0 : (ref2 = survey.design) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.footer) === null || ref3 === void 0 ? void 0 : ref3.enabled) ? window.innerHeight / 2 - offset : offset);
        };
        window.addEventListener("resize", calculateOffsetBottom);
        calculateOffsetBottom(); // run immediately
        return function() {
            return window.removeEventListener("resize", calculateOffsetBottom);
        };
    }, [
        survey === null || survey === void 0 ? void 0 : (ref = survey.design) === null || ref === void 0 ? void 0 : (ref1 = ref.footer) === null || ref1 === void 0 ? void 0 : ref1.enabled,
        survey === null || survey === void 0 ? void 0 : survey.format,
        surveyFooterRef,
        persistentProgressRef,
        setOffsetBottom
    ]);
    useGlobalAfterFocusChangedHandler();
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,react_hooks_esm/* useMutation */.Db)((SubmitResponsesV2_graphql_default()), {
        context: {
            headers: {
                "x-client-token": clientToken !== null && clientToken !== void 0 ? clientToken : null
            }
        }
    }), 1), submitCurrentResponses = ref9[0];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,react_hooks_esm/* useLazyQuery */.td)((SurveyPage_graphql_default()), {
        onCompleted: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(nextPage) {
                var ref, ref1, pageResponses, _tmp, ref2, _tmp1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            questions = nextPage === null || nextPage === void 0 ? void 0 : (ref = nextPage.surveyPage) === null || ref === void 0 ? void 0 : ref.surveyPageQuestions;
                            pageResponses = overrideAnswersFromLocalStorage(questions, localStorageAnswers);
                            _tmp = {};
                            return [
                                4,
                                dispatch(setActivePage((_tmp.activePage = nextPage, _tmp.questions = questions, _tmp.answers = pageResponses, _tmp)))
                            ];
                        case 1:
                            _state.sent();
                            _tmp1 = {};
                            // set current page id
                            js_cookie_default().set("REPID_".concat(collectorKey), (ref2 = nextPage === null || nextPage === void 0 ? void 0 : (ref1 = nextPage.surveyPage) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : "", (_tmp1.path = "/", _tmp1));
                            return [
                                2
                            ];
                    }
                });
            });
            return function(nextPage) {
                return _ref.apply(this, arguments);
            };
        }(),
        fetchPolicy: "cache-and-network"
    }), 1), nextPageQuestions = ref10[0];
    var _fetchPage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(surveyId, pageId) {
            var isPrevious, isValid, _tmp;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isPrevious = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        runAfterFocusChangedFn();
                        return [
                            4,
                            dispatch(validatePage()).unwrap()
                        ];
                    case 1:
                        isValid = _state.sent();
                        _tmp = {};
                        if (isCurrentViewSurveyTaking && collectorKey) {
                            if (!isValid && !isPrevious) {
                                // only focus and block progression for next, not prev
                                dispatch(focusFirstQuestionError());
                                void verifySurveyVersion();
                                return [
                                    2
                                ];
                            }
                            nextPageQuestions((_tmp.variables = {
                                surveyId: surveyId,
                                pageId: "".concat(pageId),
                                collectionKey: collectorKey,
                                languageCode: reqLocale
                            }, _tmp));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function _fetchPage(surveyId, pageId) {
            return _ref.apply(this, arguments);
        };
    }();
    // Whether the Done button should be disabled
    var ref11 = (0,react.useState)(false), disableSubmit = ref11[0], setDisableSubmit = ref11[1];
    var dateStarted = react.useRef("");
    var smParamForSurveyComplete = react.useRef("");
    // Set StartTime on Load
    (0,react.useEffect)(function() {
        dateStarted.current = new Date().toISOString();
        if ((pagePath === null || pagePath === void 0 ? void 0 : pagePath.length) > 1) {
            // set obfuscated entity ids
            js_cookie_default().set("RE_".concat(collectorKey), encrytedSurveyParams !== null && encrytedSurveyParams !== void 0 ? encrytedSurveyParams : "", {
                path: "/"
            });
            // set current page id
            js_cookie_default().set("REPID_".concat(collectorKey), currentPageId !== null && currentPageId !== void 0 ? currentPageId : "", {
                path: "/"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var surveyDone = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var dateCompleted, isValid, response, _tmp, ref, ref1, _tmp1, _tmp2, _tmp3, _tmp4;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runAfterFocusChangedFn();
                    dateCompleted = new Date().toISOString();
                    return [
                        4,
                        dispatch(validatePage()).unwrap()
                    ];
                case 1:
                    isValid = _state.sent();
                    if (!isCurrentViewSurveyTaking) return [
                        3,
                        3
                    ];
                    if (!isValid) {
                        dispatch(focusFirstQuestionError());
                        void verifySurveyVersion();
                        return [
                            2
                        ];
                    }
                    // disable the Done button while submitting
                    setDisableSubmit(true);
                    _tmp = {};
                    return [
                        4,
                        dispatch(submitSurvey((_tmp.mutation = submitCurrentResponses, _tmp.dateStarted = dateStarted.current, _tmp.dateCompleted = dateCompleted, _tmp.reqLocale = reqLocale, _tmp))).unwrap()
                    ];
                case 2:
                    response = _state.sent();
                    smParamForSurveyComplete.current = (ref = response === null || response === void 0 ? void 0 : response.encryptedSMParamforQuizResults) !== null && ref !== void 0 ? ref : "";
                    _tmp1 = {};
                    _tmp2 = {};
                    _tmp3 = {};
                    if (!(response === null || response === void 0 ? void 0 : response.success)) {
                        dispatch(setErrors((response === null || response === void 0 ? void 0 : response.userErrors) || []));
                        // re-enable Done button if survey submission fails
                        setDisableSubmit(false);
                    } else {
                        if (!(collector === null || collector === void 0 ? void 0 : collector.allowMultipleResponses)) {
                            ;
                            dispatch(setCookie((_tmp1.name = "RP_".concat(collector === null || collector === void 0 ? void 0 : collector.id), _tmp1.value = (ref1 = response === null || response === void 0 ? void 0 : response.encryptedSmParam) !== null && ref1 !== void 0 ? ref1 : "", _tmp1.expiration = 90, _tmp1)));
                        }
                        dispatch(surveyComplete((_tmp2.smParamForSurveyComplete = smParamForSurveyComplete.current, _tmp2.reqLocale = reqLocale, _tmp2)));
                        dispatch(postSurveyCompleteCleanup((_tmp3.collectorKey = collectorKey, _tmp3)));
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    _tmp4 = {};
                    dispatch(surveyComplete((_tmp4.smParamForSurveyComplete = smParamForSurveyComplete.current, _tmp4.reqLocale = reqLocale, _tmp4)));
                    _state.label = 4;
                case 4:
                    setDisableSubmit(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        dispatch,
        isCurrentViewSurveyTaking,
        submitCurrentResponses,
        collector === null || collector === void 0 ? void 0 : collector.allowMultipleResponses,
        collector === null || collector === void 0 ? void 0 : collector.id,
        verifySurveyVersion,
        reqLocale,
        collectorKey, 
    ]);
    var ref12 = SurveyTaking_useStyles({
        offsetTop: offsetTop,
        offsetBottom: offsetBottom
    }), surveyTitleContainer = ref12.surveyTitleContainer, mainContainer = ref12.mainContainer, layoutMainContainer = ref12.layoutMainContainer, questionContainer = ref12.questionContainer, pageFooterContainer = ref12.pageFooterContainer, sronlyFocus = ref12.sronlyFocus, pageDescriptionOkButton = ref12.pageDescriptionOkButton, pageNavigationContainer = ref12.pageNavigationContainer, surveyFooterContainer = ref12.surveyFooterContainer, classicProgressBarTop = ref12.classicProgressBarTop, customThankyouContainer = ref12.customThankyouContainer;
    if (!survey || Object.entries(survey).length === 0) {
        return null;
    }
    var _ref = helper_extrapolateSurveyData(survey), isSurveyTitleEnabled = _ref.isSurveyTitleEnabled, showPageTitles = _ref.showPageTitles, showPageNumbers = _ref.showPageNumbers, isFooterEnabled = _ref.isFooterEnabled, isOQAAT = _ref.isOQAAT, isClassicMode = _ref.isClassicMode, isProgressBarEnabled = _ref.isProgressBarEnabled, answerableQuestionCount = _ref.answerableQuestionCount, isQuestionNumberingEnabled = _ref.isQuestionNumberingEnabled, showRequiredQuestionAsterisks = _ref.showRequiredQuestionAsterisks, surveyTitleAlignment = _ref.surveyTitleAlignment, labels = _ref.labels, totalPages = _ref.totalPages, _logo = _ref.logo, isLogoEnabled = _logo.enabled, _progressBar = _ref.progressBar, progressBarPosition = _progressBar.position, showPercent = _progressBar.showPercent, showPageCount = _progressBar.showPageCount, languages = _ref.languages, logoProps = (0,_object_without_properties/* default */.Z)(_ref.logo, [
        "enabled"
    ]);
    var surveyTitleHTML = survey === null || survey === void 0 ? void 0 : survey.titleHTML;
    var surveyId = survey === null || survey === void 0 ? void 0 : survey.id;
    /**
   * Page Header
   * calculate proper Page Title and Description based on current page
   */ var hasPageDescription = !!(activePageMeta === null || activePageMeta === void 0 ? void 0 : activePageMeta.subHeading);
    var pageDescription = activePageMeta === null || activePageMeta === void 0 ? void 0 : activePageMeta.subHeading;
    var pageTitle = activePageMeta === null || activePageMeta === void 0 ? void 0 : activePageMeta.heading;
    var displayPageTitle = showPageTitles && !!pageTitle;
    /**
   * Skip to content will attempt to move the focus position (without actually focusing)
   * to the Survey Title (if exists), then Page title (if exists), finally to the
   * main-content container (<main>).
   * `tabIndex={-1}` is added to each element (backwards compat with <= IE 11)
   */ var surveyTitleId = "survey-title-".concat(surveyId);
    var pageTitleId = "page-title-".concat(surveyId);
    var mainContentId = "main-content-".concat(surveyId);
    var skipContentId = mainContentId;
    var ref13;
    var currentPage = (ref13 = activePageMeta === null || activePageMeta === void 0 ? void 0 : activePageMeta.position) !== null && ref13 !== void 0 ? ref13 : 1;
    var nextHeadingElement = helper_createHeadingLevel();
    var layoutContainerOptions = {
        layoutContainer: {
            ref: layoutContainerRef,
            "data-survey-format": survey === null || survey === void 0 ? void 0 : survey.format
        },
        partialContainer: {
            ref: partialContainerRef
        },
        topContainer: {
            ref: topContainerRef
        },
        mainContainer: {
            className: layoutMainContainer,
            ref: mainContainerRef
        },
        logoContainer: {
            ref: logoContainerRef
        },
        toolbarContainer: {
            ref: toolbarContainerRef
        }
    };
    var ref14;
    var settings = {
        survey: {
            numberingEnabled: isQuestionNumberingEnabled,
            asteriskEnabled: showRequiredQuestionAsterisks,
            okLabel: (ref14 = decodeHtmlEntities(labels.ok)) !== null && ref14 !== void 0 ? ref14 : (0,dist.t)(Survey_COPY.OK_LABEL),
            isClassic: isClassicMode
        },
        theme: surveyTheme
    };
    /**
   * @todo revisit signature of `onLeaveQuestion`; externalQuestion argument is
   * not used. (should `questions` be swapped with `externalQuestion` in this case?)
   */ var upstreamActions = {
        onLeaveQuestion: function(externalQuestion, answer) {
            if (questions) {
                dispatch(updateAnswer(answer));
            }
        }
    };
    var ref15;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isOQAAT && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveViewScrollManager, {}),
            !(0,utils_dist.getClientEnvironmentDetails)().isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(BypassBlock_BypassBlock, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "#".concat(skipContentId),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.T, {
                        desc: Survey_COPY.SKIP_LINK_CONTENT
                    })
                })
            }),
            hasVersionChanged && /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey_ModifiedSurveyDialog, {
                onConfirmClick: handlePageReload
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Layout, {
                logo: !!isLogoEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, (0,_object_spread/* default */.Z)({}, logoProps)),
                tools: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelect_LanguageSelect, {
                        selectedLangCode: reqLocale,
                        languages: languages
                    })
                }),
                options: layoutContainerOptions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "survey-title-container-".concat(surveyId),
                        className: surveyTitleContainer,
                        children: isSurveyTitleEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyTitleV2_SurveyTitleV2, {
                            id: surveyTitleId,
                            align: surveyTitleAlignment,
                            element: nextHeadingElement(0),
                            text: surveyTitleHTML !== null && surveyTitleHTML !== void 0 ? surveyTitleHTML : ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        id: mainContentId,
                        ref: mainRef,
                        className: mainContainer,
                        tabIndex: -1,
                        children: [
                            isCurrentViewCustomThankYou && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "custom-thank-you-container-".concat(surveyId),
                                className: customThankyouContainer,
                                children: collector === null || collector === void 0 ? void 0 : (ref2 = collector.thankYouPage) === null || ref2 === void 0 ? void 0 : ref2.message
                            }),
                            isCurrentViewSurveyTaking && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        id: "page-header-container-".concat(surveyId),
                                        children: [
                                            displayPageTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle_PageTitle, {
                                                id: pageTitleId,
                                                element: nextHeadingElement(1),
                                                text: pageTitle !== null && pageTitle !== void 0 ? pageTitle : "",
                                                numbered: showPageNumbers,
                                                number: currentPage
                                            }),
                                            hasPageDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyFormatView, {
                                                name: "pageDescription",
                                                noShield: true,
                                                children: function(isActive, setNextActive) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageDescription_PageDescription, {
                                                                text: pageDescription !== null && pageDescription !== void 0 ? pageDescription : ""
                                                            }),
                                                            isOQAAT && /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyButton/* SurveyButton */.c, {
                                                                size: "md",
                                                                translate: "no",
                                                                onClick: setNextActive,
                                                                className: classnames_default()(pageDescriptionOkButton, (0,_define_property/* default */.Z)({}, sronlyFocus, !isActive)),
                                                                children: labels.ok || (0,dist.t)(Survey_COPY.OK_LABEL)
                                                            })
                                                        ]
                                                    });
                                                }
                                            }),
                                            isProgressBarEnabled && isClassicMode && progressBarPosition === "TOP" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classicProgressBarTop,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicProgressBar_ClassicProgressBar, {
                                                    value: currentPage,
                                                    total: totalPages !== null && totalPages !== void 0 ? totalPages : 1,
                                                    showPageCount: showPageCount !== null && showPageCount !== void 0 ? showPageCount : true,
                                                    showPercentage: showPercent !== null && showPercent !== void 0 ? showPercent : true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(respondent_survey/* RespondentSurveyCapabilityProvider */.KR, {
                                        settings: settings,
                                        upstreamActions: upstreamActions,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                            id: "form-".concat(surveyId),
                                            className: questionContainer,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionList_QuestionList, {
                                                    questions: (ref15 = questions === null || questions === void 0 ? void 0 : questions.items) !== null && ref15 !== void 0 ? ref15 : [],
                                                    answers: answers,
                                                    isOQAAT: isOQAAT
                                                }),
                                                isProgressBarEnabled && isOQAAT && /*#__PURE__*/ (0,jsx_runtime.jsx)(PersistentProgressBar_PersistentProgressBar, {
                                                    total: answerableQuestionCount,
                                                    ref: persistentProgressRef
                                                }),
                                                isProgressBarEnabled && isClassicMode && progressBarPosition === "BOTTOM" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicProgressBar_ClassicProgressBar, {
                                                    value: currentPage,
                                                    total: totalPages !== null && totalPages !== void 0 ? totalPages : 1,
                                                    showPageCount: showPageCount !== null && showPageCount !== void 0 ? showPageCount : true,
                                                    showPercentage: showPercent !== null && showPercent !== void 0 ? showPercent : true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                                id: "page-footer-container-".concat(surveyId),
                                className: pageFooterContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyFormatView, {
                                    name: "pageNavigation",
                                    noShield: true,
                                    autoPadding: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavigation_PageNavigation, {
                                        ref: pageNavigationRef,
                                        className: pageNavigationContainer,
                                        labels: labels,
                                        currentPage: currentPagePosition,
                                        totalPages: (pagePath === null || pagePath === void 0 ? void 0 : pagePath.length) || 1,
                                        onNext: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                return [
                                                    2,
                                                    _fetchPage(survey === null || survey === void 0 ? void 0 : survey.id, pagePath[currentPagePosition])
                                                ];
                                            });
                                        }),
                                        onPrevious: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                return [
                                                    2,
                                                    _fetchPage(survey === null || survey === void 0 ? void 0 : survey.id, pagePath[currentPagePosition - 2], true)
                                                ];
                                            });
                                        }),
                                        onDone: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                return [
                                                    2,
                                                    surveyDone()
                                                ];
                                            });
                                        }),
                                        disableSubmit: disableSubmit,
                                        showPrevious: (collector === null || collector === void 0 ? void 0 : collector.editResponseType) !== "NEVER"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                        id: "survey-footer-container-".concat(surveyId),
                        className: surveyFooterContainer,
                        ref: surveyFooterRef,
                        children: isCurrentViewSurveyTaking && isFooterEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey_FooterContainer, {
                            element: "div",
                            showRequestId: showRequestId,
                            pageRequestId: pageRequestId,
                            isGrayScale: !!(survey === null || survey === void 0 ? void 0 : (ref3 = survey.design) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.footer) === null || ref4 === void 0 ? void 0 : ref4.grayscale),
                            showPrivacyCookiePolicy: true,
                            // Below are placeholders, fill in when we get info from query
                            showReportProblem: false,
                            reportProblemURL: "",
                            isGoogleSubdomain: false,
                            googlePrivacyPolicyURL: ""
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var v2_Survey = (Survey);

;// CONCATENATED MODULE: ./src/app/storeV2.ts




var store = (0,redux_toolkit_esm/* configureStore */.xC)({
    reducer: {
        oqaatState: slices_oqaatSlice,
        errorsState: slices_errorsSlice,
        surveyState: slices_surveySlice
    }
});

// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var box_dist_index_es = __webpack_require__(1743);
;// CONCATENATED MODULE: ./src/app/components/SEOBanner/CallToActionButtons/index.tsx




var CallToActionButtons = function(param) {
    var ctaButton0 = param.ctaButton0, ctaButton1 = param.ctaButton1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexDirection: "row",
        flexAlign: "center",
        flexJustify: "center",
        children: [
            ctaButton0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(box_dist_index_es/* Box */.x, {
                mr: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_es/* Button */.zx, {
                    color: "upgrade",
                    size: "sm",
                    href: ctaButton0.uri,
                    children: ctaButton0.label
                })
            }),
            ctaButton1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(box_dist_index_es/* Box */.x, {
                ml: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_es/* Button */.zx, {
                    color: "primary",
                    size: "sm",
                    href: ctaButton1.uri,
                    children: ctaButton1.label
                })
            })
        ]
    });
};
CallToActionButtons.defaultProps = {
    ctaButton0: null,
    ctaButton1: null
};
/* harmony default export */ var SEOBanner_CallToActionButtons = (CallToActionButtons);

;// CONCATENATED MODULE: ./src/app/components/SEOBanner/Logo/useStyles.ts


var useStyle = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    var mediaQueryMinScreenXL = "@media (min-width: ".concat(theme.breakpoints.xl, "px)");
    return {
        seoBannerLogoSmallScreen: (0,_define_property/* default */.Z)({
            width: theme.iconSize.xl
        }, mediaQueryMinScreenXL, {
            display: "none"
        }),
        seoBannerLogoLargeScreen: (0,_define_property/* default */.Z)({
            display: "none"
        }, mediaQueryMinScreenXL, {
            display: "inline-block",
            width: 161,
            height: 24
        })
    };
});
/* harmony default export */ var SEOBanner_Logo_useStyles = (useStyle);

;// CONCATENATED MODULE: ./src/app/components/SEOBanner/Logo/index.tsx






var GOLDIE_ICON = "Logo__GoldieIcon";
var GOLDIE_ICON_WITH_TEXT = "Logo__GoldieIcon_with_text";
/* harmony default export */ function SEOBanner_Logo() {
    var ref = SEOBanner_Logo_useStyles(), seoBannerLogoLargeScreen = ref.seoBannerLogoLargeScreen, seoBannerLogoSmallScreen = ref.seoBannerLogoSmallScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexDirection: "column",
        flexAlign: "center",
        flexJustify: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-testid": GOLDIE_ICON_WITH_TEXT,
                className: seoBannerLogoLargeScreen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logos/* LogoWithText */.u, {
                    color: "primary"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-testid": GOLDIE_ICON,
                className: seoBannerLogoSmallScreen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_es/* IconLogoGoldie */.jNx, {
                    title: "SurveyMonkey Logo",
                    size: "xl",
                    color: "primary"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/app/components/SEOBanner/MessageBody/useStyles.ts


var useStyles_useStyle = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    var mediaQueryMinScreenXL = "@media (min-width: ".concat(theme.breakpoints.xl, ")");
    return {
        seoBannerPlug: (0,_define_property/* default */.Z)({
            color: theme.palette.text.dark,
            textAlign: "center",
            margin: "0 0.3125rem",
            padding: "1rem 0",
            "& p": {
                margin: 0
            }
        }, mediaQueryMinScreenXL, {
            padding: "0 0.8125rem"
        })
    };
});
/* harmony default export */ var MessageBody_useStyles = (useStyles_useStyle);

;// CONCATENATED MODULE: ./src/app/components/SEOBanner/MessageBody/index.tsx




var MessageBody = function(param) {
    var children = param.children;
    var seoBannerPlug = MessageBody_useStyles().seoBannerPlug;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexDirection: "column",
        flexAlign: "center",
        flexJustify: "center",
        ml: 1,
        mr: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: seoBannerPlug,
            children: children
        })
    });
};
/* harmony default export */ var SEOBanner_MessageBody = (MessageBody);

;// CONCATENATED MODULE: ./src/app/components/SEOBanner/BannerBody/index.tsx






/* harmony default export */ function BannerBody(param) {
    var children = param.children, callToActionButtons = param.callToActionButtons;
    var _callToActionButtons = (0,_sliced_to_array/* default */.Z)(callToActionButtons, 2), ctaButton0 = _callToActionButtons[0], ctaButton1 = _callToActionButtons[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEOBanner_Logo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEOBanner_MessageBody, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEOBanner_CallToActionButtons, {
                ctaButton0: ctaButton0,
                ctaButton1: ctaButton1
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/app/components/SEOBanner/helpers/visibilityLogic.ts
/* harmony default export */ function visibilityLogic(forceHide, isRequestFromSearchEngine, collectorType, collectionMethod) {
    if (forceHide) {
        return false;
    }
    var isWeblink = collectorType === "WEBLINK";
    var isNormalCollection = collectionMethod === "NORMAL";
    return isRequestFromSearchEngine && isWeblink && isNormalCollection;
};

;// CONCATENATED MODULE: ./src/app/components/SEOBanner/useStyles.ts


var SEOBanner_useStyles_useStyle = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    var ref, ref1;
    var mediaQueryMinScreenXL = "@media (min-width: ".concat(theme.breakpoints.xl, "px)");
    return {
        seoBanner: {
            position: "relative",
            backgroundColor: theme === null || theme === void 0 ? void 0 : theme.palette.background.light,
            color: theme.palette.background.light,
            fontFamily: theme.type.fontFamily.base,
            fontWeight: "normal",
            fontSize: (ref = theme.type.fontSize) === null || ref === void 0 ? void 0 : ref.body,
            lineHeight: 1.26,
            padding: "8px 2.2rem ".concat(8 * 0.75, "px"),
            borderBottom: (ref1 = theme.border) === null || ref1 === void 0 ? void 0 : ref1.muted
        },
        embeddedContainer: (0,_define_property/* default */.Z)({
            display: "flex",
            flexDirection: "column",
            flexAlign: "center",
            flexJustify: "center"
        }, mediaQueryMinScreenXL, {
            flexDirection: "row"
        }),
        seoBannerContents: (0,_define_property/* default */.Z)({
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingBottom: "0.5rem"
        }, mediaQueryMinScreenXL, {
            paddingTop: "1rem"
        }),
        closeXButton: {
            position: "absolute",
            right: "0.625rem",
            top: "0.625rem",
            "& button": {
                border: "none",
                backgroundColor: "transparent",
                height: "auto",
                padding: "0"
            },
            "& svg": {
                width: 18,
                height: 18
            }
        }
    };
});
/* harmony default export */ var SEOBanner_useStyles = (SEOBanner_useStyles_useStyle);

;// CONCATENATED MODULE: ./src/app/components/SEOBanner/index.tsx







/* harmony default export */ function SEOBanner(param) {
    var _forceDoNotShowBanner = param.forceDoNotShowBanner, forceDoNotShowBanner = _forceDoNotShowBanner === void 0 ? false : _forceDoNotShowBanner, requestFromSearchEngine = param.requestFromSearchEngine, children = param.children, callToActionButtons = param.callToActionButtons, collectorType = param.collectorType, collectionMethod = param.collectionMethod, _closeButtonAriaText = param.closeButtonAriaText, closeButtonAriaText = _closeButtonAriaText === void 0 ? "" : _closeButtonAriaText;
    var ref = (0,react.useState)(forceDoNotShowBanner || false), forceDoNotShow = ref[0], setForceDoNotShow = ref[1];
    var ref1 = SEOBanner_useStyles(), seoBanner = ref1.seoBanner, seoBannerContents = ref1.seoBannerContents, embeddedContainer = ref1.embeddedContainer, closeXButton = ref1.closeXButton;
    if (!visibilityLogic(forceDoNotShow, requestFromSearchEngine, collectorType || "", collectionMethod)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: seoBanner,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: seoBannerContents,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: embeddedContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerBody, {
                        callToActionButtons: callToActionButtons,
                        children: children
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-testid": "SEOBanner__CloseButton",
                className: closeXButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_es/* Button */.zx, {
                    variant: "text",
                    color: "secondary",
                    label: closeButtonAriaText,
                    onClick: function() {
                        return setForceDoNotShow(true);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_es/* IconXCircle */.IF3, {
                        title: ""
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/FourHundredError/index.js + 2 modules
var FourHundredError = __webpack_require__(2512);
;// CONCATENATED MODULE: ./src/app/components/Errors/defaultLinkProps.ts

var defaultLinkProps_COPY = (0,dist/* defineMessages */.vU)({
    HOME: {
        id: "Errors.defaultLinkProps.home",
        defaultMessage: "Home",
        description: "[Type: Label][Vis.: med] - Home link in Error Message"
    },
    SITEMAP: {
        id: "Errors.defaultLinkProps.sitemap",
        defaultMessage: "Sitemap",
        description: "[Type: Label][Vis.: med] - Sitemap link in Error Message"
    },
    HELP_CENTER: {
        id: "Errors.defaultLinkProps.helpCenter",
        defaultMessage: "Help Center",
        description: "[Type: Label][Vis.: med] - Help Center link in Error Message"
    },
    TEMPLATES: {
        id: "Errors.defaultLinkProps.templates",
        defaultMessage: "Templates",
        description: "[Type: Label][Vis.: med] - Templates link in Error Message"
    },
    LEARN_MORE: {
        id: "Errors.defaultLinkProps.learnMore",
        defaultMessage: "Learn More",
        description: "[Type: Label][Vis.: med] - Learn More link in 404 Error Message"
    }
});
var defaultLinks = [
    {
        href: "/",
        label: (0,dist.t)(defaultLinkProps_COPY.HOME)
    },
    {
        href: "/mp/sitemap/",
        label: (0,dist.t)(defaultLinkProps_COPY.SITEMAP)
    },
    {
        href: "https://help.surveymonkey.com/",
        label: (0,dist.t)(defaultLinkProps_COPY.HELP_CENTER)
    },
    {
        href: "/mp/survey-templates/",
        label: (0,dist.t)(defaultLinkProps_COPY.TEMPLATES)
    },
    {
        href: "/mp/take-a-tour/",
        label: (0,dist.t)(defaultLinkProps_COPY.LEARN_MORE)
    }, 
];
/* harmony default export */ var defaultLinkProps = (defaultLinks);

;// CONCATENATED MODULE: ./src/app/components/Errors/defaultSignupButtonProps.ts

var defaultSignupButtonProps_COPY = (0,dist/* defineMessages */.vU)({
    SIGN_UP_TEXT: {
        id: "Errors.defaultSignupButtonProps.signUpText",
        defaultMessage: "Want to create your own survey?",
        description: "[Type: Label][Vis.: med] - Sign up free button description text"
    },
    SIGN_UP_FREE: {
        id: "Errors.defaultSignupButtonProps.signUpFree",
        defaultMessage: "Sign Up FREE",
        description: "[Type: Label][Vis.: med] - Sign up free button"
    }
});
var defaultSignupButtonProps = {
    buttonProps: {
        label: (0,dist.t)(defaultSignupButtonProps_COPY.SIGN_UP_FREE),
        href: "/user/sign-up/?ut_source=404_page"
    },
    signUpText: (0,dist.t)(defaultSignupButtonProps_COPY.SIGN_UP_TEXT)
};
/* harmony default export */ var Errors_defaultSignupButtonProps = (defaultSignupButtonProps);

;// CONCATENATED MODULE: ./src/app/components/Errors/FourHundredError/FourHundredError.tsx






var FourHundredError_COPY = (0,dist/* defineMessages */.vU)({
    SORRY_MESSAGE: {
        id: "Errors.FourHundredError.sorryMessage",
        defaultMessage: "We're sorry",
        description: "[Type: Label][Vis.: med] - We are sorry message"
    },
    CANT_FIND_PAGE: {
        id: "Errors.FourHundredError.cantFindPage",
        defaultMessage: "We can't find the page you're looking for.",
        description: "[Type: Label][Vis.: med] - Cant find page message"
    },
    CHECK_URL: {
        id: "Errors.FourHundredError.checkURL",
        defaultMessage: "Please check the URL you entered to make sure it's spelled correctly.",
        description: "[Type: Label][Vis.: med] - check URL subtitle"
    },
    HELP_FIND_WAY: {
        id: "Errors.FourHundredError.helpFindWay",
        defaultMessage: "Still not sure how to get to the page you want? Maybe we can help you find your way:",
        description: "[Type: Label][Vis.: med] - Help find your way subtitle"
    }
});
function FourHundredError_FourHundredError(param) {
    var _openingMessage = param.openingMessage, openingMessage = _openingMessage === void 0 ? (0,dist.t)(FourHundredError_COPY.SORRY_MESSAGE) : _openingMessage, _errorTitle = param.errorTitle, errorTitle = _errorTitle === void 0 ? (0,dist.t)(FourHundredError_COPY.CANT_FIND_PAGE) : _errorTitle, _titularElementTag = param.titularElementTag, titularElementTag = _titularElementTag === void 0 ? "p" : _titularElementTag, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? [
        (0,dist.t)(FourHundredError_COPY.CHECK_URL),
        (0,dist.t)(FourHundredError_COPY.HELP_FIND_WAY)
    ] : _errorMessage, _signupButtonProps = param.signupButtonProps, signupButtonProps = _signupButtonProps === void 0 ? Errors_defaultSignupButtonProps : _signupButtonProps, _linksProps = param.linksProps, linksProps = _linksProps === void 0 ? {
        links: defaultLinkProps
    } : _linksProps, _showLinks = param.showLinks, showLinks = _showLinks === void 0 ? false : _showLinks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FourHundredError/* FourHundredError */._, {
        openingMessage: openingMessage,
        errorTitle: errorTitle,
        titularElementTag: titularElementTag,
        errorMessage: errorMessage,
        signupButtonProps: signupButtonProps,
        linksProps: linksProps,
        showLinks: showLinks,
        // disable fullscreen styling so that the component can by styled by the parent
        fullscreen: false
    });
}
/* harmony default export */ var Errors_FourHundredError_FourHundredError = (FourHundredError_FourHundredError);

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/index.js + 4 modules
var ClientError = __webpack_require__(7517);
;// CONCATENATED MODULE: ./src/app/components/Errors/FourHundredError/FourHundredErrorPage.tsx


/* harmony default export */ var FourHundredErrorPage = ((0,ClientError/* withClientErrorPage */.Fs)(Errors_FourHundredError_FourHundredError, {
    titularElementTag: "h1",
    errorCode: 400
}));

;// CONCATENATED MODULE: ./src/app/components/Errors/FourHundredError/index.ts



// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ForbiddenError/index.js + 2 modules
var ForbiddenError = __webpack_require__(6262);
;// CONCATENATED MODULE: ./src/app/components/Errors/ForbiddenError/ForbiddenError.tsx





var ForbiddenError_DEFAULT_COPY = (0,dist/* defineMessages */.vU)({
    SORRY_MESSAGE: {
        id: "Errors.ForbiddenError.sorryMessage",
        defaultMessage: "We're sorry",
        description: "[Type: Label][Vis.: med] - We are sorry message"
    },
    PERMISSIONS: {
        id: "Errors.ForbiddenError.permissions",
        defaultMessage: "You do not have permission to see this page.",
        description: "[Type: Label][Vis.: med] - We are sorry message"
    },
    CHECK_URL: {
        id: "Errors.ForbiddenError.checkURL",
        defaultMessage: "Please check the URL you entered to make sure it's spelled correctly.",
        description: "[Type: Label][Vis.: med] - check URL subtitle"
    },
    HELP_FIND_WAY: {
        id: "Errors.ForbiddenError.helpFindWay",
        defaultMessage: "Still not sure how to get to the page you want? Maybe we can help you find your way:",
        description: "[Type: Label][Vis.: med] - Help find your way subtitle"
    }
});
var ForbiddenError_ForbiddenError = function(param) {
    var _openingMessage = param.openingMessage, openingMessage = _openingMessage === void 0 ? (0,dist.t)(ForbiddenError_DEFAULT_COPY.SORRY_MESSAGE) : _openingMessage, _errorTitle = param.errorTitle, errorTitle = _errorTitle === void 0 ? (0,dist.t)(ForbiddenError_DEFAULT_COPY.PERMISSIONS) : _errorTitle, _titularElementTag = param.titularElementTag, titularElementTag = _titularElementTag === void 0 ? "p" : _titularElementTag, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? [
        (0,dist.t)(ForbiddenError_DEFAULT_COPY.CHECK_URL),
        (0,dist.t)(ForbiddenError_DEFAULT_COPY.HELP_FIND_WAY)
    ] : _errorMessage, _linksProps = param.linksProps, linksProps = _linksProps === void 0 ? {
        links: defaultLinkProps
    } : _linksProps, _showLinks = param.showLinks, showLinks = _showLinks === void 0 ? true : _showLinks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ForbiddenError/* default */.Z, {
        openingMessage: openingMessage,
        errorTitle: errorTitle,
        titularElementTag: titularElementTag,
        errorMessage: errorMessage,
        linksProps: linksProps,
        showLinks: showLinks,
        // disable fullscreen styling so that the component can by styled by the parent
        fullscreen: false
    });
};
/* harmony default export */ var Errors_ForbiddenError_ForbiddenError = (ForbiddenError_ForbiddenError);

;// CONCATENATED MODULE: ./src/app/components/Errors/ForbiddenError/ForbiddenErrorPage.tsx


/* harmony default export */ var ForbiddenErrorPage = ((0,ClientError/* withClientErrorPage */.Fs)(Errors_ForbiddenError_ForbiddenError, {
    titularElementTag: "h1",
    errorCode: 403
}));

;// CONCATENATED MODULE: ./src/app/components/Errors/ForbiddenError/index.ts



// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/FourOhFourError/index.js + 2 modules
var FourOhFourError = __webpack_require__(7970);
;// CONCATENATED MODULE: ./src/app/components/Errors/FourOhFourError/FourOhFourError.tsx






var FourOhFourError_COPY = (0,dist/* defineMessages */.vU)({
    SORRY_MESSAGE: {
        id: "Errors.FourOhFourError.sorryMessage",
        defaultMessage: "We're sorry",
        description: "[Type: Label][Vis.: med] - We are sorry message"
    },
    CANT_FIND_PAGE: {
        id: "Errors.FourOhFourError.cantFindPage",
        defaultMessage: "We can't find the page you're looking for.",
        description: "[Type: Label][Vis.: med] - Cant find page message"
    },
    CHECK_URL: {
        id: "Errors.FourOhFourError.checkURL",
        defaultMessage: "Please check the URL you entered to make sure it's spelled correctly.",
        description: "[Type: Label][Vis.: med] - check URL subtitle"
    },
    HELP_FIND_WAY: {
        id: "Errors.FourOhFourError.helpFindWay",
        defaultMessage: "Still not sure how to get to the page you want? Maybe we can help you find your way:",
        description: "[Type: Label][Vis.: med] - Help find your way subtitle"
    }
});
function FourOhFourError_FourOhFourError(param) {
    var _openingMessage = param.openingMessage, openingMessage = _openingMessage === void 0 ? (0,dist.t)(FourOhFourError_COPY.SORRY_MESSAGE) : _openingMessage, _errorTitle = param.errorTitle, errorTitle = _errorTitle === void 0 ? (0,dist.t)(FourOhFourError_COPY.CANT_FIND_PAGE) : _errorTitle, _titularElementTag = param.titularElementTag, titularElementTag = _titularElementTag === void 0 ? "p" : _titularElementTag, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? [
        (0,dist.t)(FourOhFourError_COPY.CHECK_URL),
        (0,dist.t)(FourOhFourError_COPY.HELP_FIND_WAY)
    ] : _errorMessage, _signupButtonProps = param.signupButtonProps, signupButtonProps = _signupButtonProps === void 0 ? Errors_defaultSignupButtonProps : _signupButtonProps, _linksProps = param.linksProps, linksProps = _linksProps === void 0 ? {
        links: defaultLinkProps
    } : _linksProps, _showLinks = param.showLinks, showLinks = _showLinks === void 0 ? false : _showLinks;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FourOhFourError/* FourOhFourError */.c, {
        openingMessage: openingMessage,
        errorTitle: errorTitle,
        titularElementTag: titularElementTag,
        errorMessage: errorMessage,
        signupButtonProps: signupButtonProps,
        linksProps: linksProps,
        showLinks: showLinks,
        // disable fullscreen styling so that the component can by styled by the parent
        fullscreen: false
    });
}
/* harmony default export */ var Errors_FourOhFourError_FourOhFourError = (FourOhFourError_FourOhFourError);

;// CONCATENATED MODULE: ./src/app/components/Errors/FourOhFourError/FourOhFourErrorPage.tsx


/* harmony default export */ var FourOhFourErrorPage = ((0,ClientError/* withClientErrorPage */.Fs)(Errors_FourOhFourError_FourOhFourError, {
    titularElementTag: "h1",
    showLinks: true,
    errorCode: 404
}));

;// CONCATENATED MODULE: ./src/app/components/Errors/FourOhFourError/index.ts



// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/FourTenError/index.js + 2 modules
var FourTenError = __webpack_require__(7111);
;// CONCATENATED MODULE: ./src/app/components/Errors/FourTenError/FourTenError.tsx





var FourTenError_DEFAULT_COPY = (0,dist/* defineMessages */.vU)({
    // Client Error
    OH_BANANAS: {
        id: "Errors.FourTenError.ohBananas",
        defaultMessage: "Oh bananas!",
        description: "[Type: Label][Vis.: med] - Oh bananas message"
    },
    TERMS_VIOLATION: {
        id: "Errors.FourTenError.somethingWentWrong",
        defaultMessage: "This survey is currently closed due to a violation of SurveyMonkey's terms of use.",
        description: "[Type: Label][Vis.: med] - terms of use violation title"
    },
    // Primary Links
    HOME: {
        id: "Errors.FourTenError.home",
        defaultMessage: "SurveyMonkey Home",
        description: "[Type: Label][Vis.: med] - Home link in 410 Error Message"
    },
    SITEMAP: {
        id: "Errors.FourTenError.sitemap",
        defaultMessage: "Sitemap",
        description: "[Type: Label][Vis.: med] - Sitemap link in 410 Error Message"
    },
    LEARN_MORE: {
        id: "Errors.FourTenError.howItWorks",
        defaultMessage: "How It Works",
        description: "[Type: Label][Vis.: med] - How It Works link in 410 Error Message"
    },
    // Secondary Links
    TYPES: {
        id: "Errors.FourTenError.types",
        defaultMessage: "Survey Types",
        description: "[Type: Label][Vis.: med] - Survey Types link in 410 Error Message"
    },
    SATISFACTION_SURVEYS: {
        id: "Errors.FourTenError.satisfactionSurveys",
        defaultMessage: "Customer Satisfaction Surveys",
        description: "[Type: Label][Vis.: med] - Customer Satisfaction Surveys link in 410 Error Message"
    },
    EMPLOYEE_SURVEYS: {
        id: "Errors.FourTenError.employeeSurveys",
        defaultMessage: "Employee Surveys",
        description: "[Type: Label][Vis.: med] - Employee Surveys link in 410 Error Message"
    }
});
var defaultPrimaryLinks = {
    links: [
        {
            label: (0,dist.t)(FourTenError_DEFAULT_COPY.HOME),
            href: "/"
        },
        {
            label: (0,dist.t)(FourTenError_DEFAULT_COPY.SITEMAP),
            href: "/mp/sitemap/"
        },
        {
            label: (0,dist.t)(FourTenError_DEFAULT_COPY.LEARN_MORE),
            href: "/mp/take-a-tour/"
        }, 
    ]
};
var defaultSecondaryLinks = {
    links: [
        {
            label: (0,dist.t)(FourTenError_DEFAULT_COPY.TYPES),
            href: "/mp/survey-types/"
        },
        {
            label: (0,dist.t)(FourTenError_DEFAULT_COPY.SATISFACTION_SURVEYS),
            href: "/mp/customer-satisfaction-surveys/"
        },
        {
            label: (0,dist.t)(FourTenError_DEFAULT_COPY.EMPLOYEE_SURVEYS),
            href: "/mp/employee-surveys/"
        }, 
    ]
};
function FourTenError_FourTenError(param) {
    var _openingMessage = param.openingMessage, openingMessage = _openingMessage === void 0 ? (0,dist.t)(FourTenError_DEFAULT_COPY.OH_BANANAS) : _openingMessage, _errorTitle = param.errorTitle, errorTitle = _errorTitle === void 0 ? (0,dist.t)(FourTenError_DEFAULT_COPY.TERMS_VIOLATION) : _errorTitle, _titularElementTag = param.titularElementTag, titularElementTag = _titularElementTag === void 0 ? "p" : _titularElementTag, _signupButtonProps = param.signupButtonProps, signupButtonProps = _signupButtonProps === void 0 ? Errors_defaultSignupButtonProps : _signupButtonProps, _primaryLinksProps = param.primaryLinksProps, primaryLinksProps = _primaryLinksProps === void 0 ? defaultPrimaryLinks : _primaryLinksProps, _secondaryLinksProps = param.secondaryLinksProps, secondaryLinksProps = _secondaryLinksProps === void 0 ? defaultSecondaryLinks : _secondaryLinksProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FourTenError/* FourTenError */.I, {
        openingMessage: openingMessage,
        errorTitle: errorTitle,
        titularElementTag: titularElementTag,
        signupButtonProps: signupButtonProps,
        primaryLinksProps: primaryLinksProps,
        secondaryLinksProps: secondaryLinksProps,
        // disable fullscreen styling so that the component can by styled by the parent
        fullscreen: false
    });
}
/* harmony default export */ var Errors_FourTenError_FourTenError = (FourTenError_FourTenError);

;// CONCATENATED MODULE: ./src/app/components/Errors/FourTenError/FourTenErrorPage.tsx


/* harmony default export */ var FourTenErrorPage = ((0,ClientError/* withClientErrorPage */.Fs)(Errors_FourTenError_FourTenError, {
    titularElementTag: "h1",
    errorCode: 410
}));

;// CONCATENATED MODULE: ./src/app/components/Errors/FourTenError/index.ts



// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/FiveHundredError/index.js + 2 modules
var FiveHundredError = __webpack_require__(5849);
;// CONCATENATED MODULE: ./src/app/components/Errors/FiveHundredError/FiveHundredError.tsx





var FiveHundredError_DEFAULT_COPY = (0,dist/* defineMessages */.vU)({
    SORRY_MESSAGE: {
        id: "Errors.FiveHundredError.SorryMessage",
        defaultMessage: "We're sorry",
        description: "[Type: Label][Vis.: med] - We are sorry message"
    },
    SOMETHING_WRONG: {
        id: "Errors.FiveHundredError.SomethingWentWrong",
        defaultMessage: "Something went wrong.",
        description: "[Type: Label][Vis.: med] - something went wrong subtitle"
    },
    FIVE_HUNDRED_MESSAGE: {
        id: "Errors.FiveHundredError.Message",
        defaultMessage: "Sorry if you lost your place - we're working hard to get things up and running again. Thanks for your patience!",
        description: "[Type: Label][Vis.: med] - Five Hundred Error Message"
    }
});
function FiveHundredError_FiveHundredError(param) {
    var _openingMessage = param.openingMessage, openingMessage = _openingMessage === void 0 ? (0,dist.t)(FiveHundredError_DEFAULT_COPY.SORRY_MESSAGE) : _openingMessage, _errorTitle = param.errorTitle, errorTitle = _errorTitle === void 0 ? (0,dist.t)(FiveHundredError_DEFAULT_COPY.SOMETHING_WRONG) : _errorTitle, _titularElementTag = param.titularElementTag, titularElementTag = _titularElementTag === void 0 ? "p" : _titularElementTag, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? (0,dist.t)(FiveHundredError_DEFAULT_COPY.FIVE_HUNDRED_MESSAGE) : _errorMessage, _linksProps = param.linksProps, linksProps = _linksProps === void 0 ? {
        links: defaultLinkProps
    } : _linksProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FiveHundredError/* FiveHundredError */.L, {
        openingMessage: openingMessage,
        errorTitle: errorTitle,
        titularElementTag: titularElementTag,
        errorMessage: errorMessage,
        linksProps: linksProps,
        // disable fullscreen styling so that the component can by styled by the parent
        fullscreen: false
    });
}
/* harmony default export */ var Errors_FiveHundredError_FiveHundredError = (FiveHundredError_FiveHundredError);

;// CONCATENATED MODULE: ./src/app/components/Errors/FiveHundredError/FiveHundredErrorPage.tsx


/* harmony default export */ var FiveHundredErrorPage = ((0,ClientError/* withClientErrorPage */.Fs)(Errors_FiveHundredError_FiveHundredError, {
    titularElementTag: "h1",
    errorCode: 500
}));

;// CONCATENATED MODULE: ./src/app/components/Errors/FiveHundredError/index.ts



;// CONCATENATED MODULE: ./src/app/components/Errors/CannedError/CannedError.tsx
// TODO: move FourTenError implementation to CannedError


;// CONCATENATED MODULE: ./src/app/components/Errors/CannedError/CannedErrorPage.tsx


/* harmony default export */ var CannedErrorPage = ((0,ClientError/* withClientErrorPage */.Fs)(Errors_FourTenError_FourTenError, {
    titularElementTag: "h1"
}));

;// CONCATENATED MODULE: ./src/app/components/Errors/CannedError/index.ts



;// CONCATENATED MODULE: ./src/app/components/Errors/index.ts







;// CONCATENATED MODULE: ./pages/r/surveyTaking/[collectKey].page.tsx























var _collectKey_page_COPY = (0,dist/* defineMessages */.vU)({
    META_DESCRIPTION: {
        id: "r.page.metaDescription",
        defaultMessage: "Web survey powered by SurveyMonkey.com. Create your own online survey now with SurveyMonkey's expert certified FREE templates."
    },
    SEO_BANNER_CLOSE_BUTTON_ARIA_TEXT: {
        id: "r.page.seoBannerCloseButtonAriaText",
        defaultMessage: "close SEO banner"
    },
    SEO_BANNER_BODY: {
        id: "r.page.seoBannerBody",
        defaultMessage: "Is this the survey you're looking for? Try creating your own with the world's leading platform."
    },
    SEO_BANNER_SIGNUP_BUTTON: {
        id: "r.page.seoBannerSignupButton",
        defaultMessage: "Sign up free"
    },
    SEO_BANNER_LEARN_MORE: {
        id: "r.page.seoBannerLearnMoreButton",
        defaultMessage: "Learn more"
    }
});
var SurveyTaking = function(param) {
    var pageOptions = param.pageOptions, spageSessionData = param.spageSessionData, surveyPageData = param.surveyPageData, responsesData = param.responsesData, collectorKey = param.collectorKey;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var reqLocale = pageOptions.reqLocale, slLanguageLocale = pageOptions.slLanguageLocale, _isWhiteLabel = pageOptions.isWhiteLabel, isWhiteLabel = _isWhiteLabel === void 0 ? false : _isWhiteLabel;
    var _spageSession = spageSessionData.spageSession, collector = _spageSession.collector, survey = _spageSession.survey, encryptedSmParam = _spageSession.encryptedSmParam, respondent = _spageSession.respondent;
    var ref7 = (0,react.useContext)(StaticContext/* StaticContext */.vN), environment = ref7.environment, user = ref7.user, pageRequestId = ref7.pageRequestId;
    var collectorSubdomain = collector === null || collector === void 0 ? void 0 : (ref = collector.weblink) === null || ref === void 0 ? void 0 : ref.subdomain;
    var ref8;
    var subDomain = (ref8 = pageOptions === null || pageOptions === void 0 ? void 0 : pageOptions.subDomain) !== null && ref8 !== void 0 ? ref8 : "www";
    if (!survey || !subdomain([
        subDomain
    ], collectorSubdomain)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FourOhFourErrorPage, {
            requestId: pageRequestId
        });
    }
    // seo banner config
    var seoBannerCallToActionButtons = [
        {
            label: (0,dist.t)(_collectKey_page_COPY.SEO_BANNER_SIGNUP_BUTTON),
            uri: "https://www.surveymonkey.com/user/sign-up/?ut_source=s_page_search_topbar_desktop"
        },
        {
            label: (0,dist.t)(_collectKey_page_COPY.SEO_BANNER_LEARN_MORE),
            uri: "https://www.surveymonkey.com/mp/take-a-tour/?ut_source=s_page_search_topbar_desktop"
        }, 
    ];
    var spageGoogleFontsLink = (0,spageGoogleFonts/* default */.Z)((ref1 = survey.design) === null || ref1 === void 0 ? void 0 : ref1.theme);
    var ref9;
    var respondentCollectionMethod = (ref9 = respondent === null || respondent === void 0 ? void 0 : respondent.collectionMethod) !== null && ref9 !== void 0 ? ref9 : null;
    var _enabled;
    var isTitleEnabled = (_enabled = survey === null || survey === void 0 ? void 0 : (ref2 = survey.design) === null || ref2 === void 0 ? void 0 : ref2.surveyTitle.enabled) !== null && _enabled !== void 0 ? _enabled : true;
    var surveyTitle = (survey === null || survey === void 0 ? void 0 : survey.titleHTML) || (survey === null || survey === void 0 ? void 0 : survey.title);
    if (!(collector === null || collector === void 0 ? void 0 : collector.surveyId)) {
        return null;
    }
    var questions = surveyPageData === null || surveyPageData === void 0 ? void 0 : (ref3 = surveyPageData.surveyPage) === null || ref3 === void 0 ? void 0 : ref3.surveyPageQuestions;
    store.dispatch(initEnvironment(environment));
    store.dispatch(initializeSurvey({
        respondentSession: spageSessionData === null || spageSessionData === void 0 ? void 0 : spageSessionData.spageSession,
        surveyTakingCurrentPage: surveyPageData
    }));
    // only for multipage survey
    if (((ref4 = spageSessionData.spageSession) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.pagePath) === null || ref5 === void 0 ? void 0 : ref5.length) > 1) {
        var localStorageAnswers = decryptAnswers(collectorKey);
        // update precedence in SPAGE-7621, instead of defaulting from local storage
        var answers = overrideAnswersFromLocalStorage(questions, localStorageAnswers);
        store.dispatch(setAnswers(answers));
    }
    store.dispatch(setCollectorKey(collectorKey));
    var _obj;
    store.dispatch(setMeta((_obj = {}, (0,_define_property/* default */.Z)(_obj, ErrorType.COLLECTOR_CLOSED, {
        url: "/survey-closed/?sm=".concat(encryptedSmParam)
    }), (0,_define_property/* default */.Z)(_obj, ErrorType.REQUEST_IP_DISALLOWED, {
        url: "/survey-closed/?sm=".concat(encryptedSmParam)
    }), _obj)));
    // TODO: fix this type later
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var surveyTheme = (0,helpers/* formatTheme */.Qu)({
        survey: (0,_object_spread/* default */.Z)({}, survey)
    });
    // SPAGE-7677: REX router debug info
    var domain = environment.domain.toLowerCase();
    var showRequestId = [
        "surveymonkey",
        "research"
    ].every(function(d) {
        return d !== domain;
    });
    var ref10;
    var pageNumber = (ref10 = surveyPageData === null || surveyPageData === void 0 ? void 0 : (ref6 = surveyPageData.surveyPage) === null || ref6 === void 0 ? void 0 : ref6.position) !== null && ref10 !== void 0 ? ref10 : 1;
    var commonBiData = generateEventDataForLogs({
        environment: environment,
        user: user,
        collector: collector,
        survey: survey,
        pageNumber: pageNumber
    });
    var SURVEY_FIRST_GET = {
        name: metrics_dist.USER_EVENTS.PAGE_VIEW,
        data: (0,_object_spread/* default */.Z)({
            actionFlow: "survey_load",
            actionType: "first_get"
        }, commonBiData)
    };
    /* @todo: Lang set on the document level https://jira.surveymonkey.com/browse/WEBPLAT-3418 */ return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Provider */.zt, {
            store: store,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: surveyTakingWindowTitle(isTitleEnabled, isWhiteLabel, surveyTitle)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: (0,dist.t)(_collectKey_page_COPY.META_DESCRIPTION)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "viewport",
                            content: "width=device-width, initial-scale=1, user-scalable=yes"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            httpEquiv: "content-language",
                            content: slLanguageLocale
                        }),
                        !!spageGoogleFontsLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "stylesheet preload",
                            href: spageGoogleFontsLink,
                            as: "style"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* SurveyThemeProvider */.Uu, {
                    theme: surveyTheme,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SEOBanner, {
                            callToActionButtons: seoBannerCallToActionButtons,
                            closeButtonAriaText: (0,dist.t)(_collectKey_page_COPY.SEO_BANNER_CLOSE_BUTTON_ARIA_TEXT),
                            requestFromSearchEngine: false,
                            collectionMethod: respondentCollectionMethod,
                            collectorType: collector === null || collector === void 0 ? void 0 : collector.type,
                            children: (0,dist.t)(_collectKey_page_COPY.SEO_BANNER_BODY)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_Survey, {
                            pageRequestId: pageRequestId,
                            showRequestId: showRequestId,
                            reqLocale: reqLocale !== null && reqLocale !== void 0 ? reqLocale : undefined,
                            "data-sm-metrics": (0,metrics_dist.generateMetricsAttribute)(SURVEY_FIRST_GET)
                        })
                    ]
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _collectKey_page = (SurveyTaking);


/***/ }),

/***/ 6524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ SurveyButton_SurveyButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/context.js
var context = __webpack_require__(6322);
;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyButton/useStyles.ts

var defaultSize = "md";
var sizeMap = {
    sm: {
        padding: "0 12px",
        height: 30,
        fontSize: 13
    },
    md: {
        padding: "0 24px",
        height: 40,
        fontSize: 15
    },
    lg: {
        padding: "0 36px",
        height: 50,
        fontSize: 15
    }
};
function getSizeOption() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultSize;
    return sizeMap[size];
}
var _secondaryAccentColor, _primaryAccentColor, ref;
var useStyles = (0,context/* createSurveyStyles */.tF)(function(theme) {
    var ref1;
    return {
        surveyButton: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            boxSizing: "border-box",
            color: (_secondaryAccentColor = theme.secondaryAccentColor) !== null && _secondaryAccentColor !== void 0 ? _secondaryAccentColor : {},
            backgroundColor: (_primaryAccentColor = theme.primaryAccentColor) !== null && _primaryAccentColor !== void 0 ? _primaryAccentColor : {},
            fontFamily: (ref = (ref1 = theme.questionBody) === null || ref1 === void 0 ? void 0 : ref1.fontFamily) !== null && ref !== void 0 ? ref : {},
            fontSize: function(param) {
                var size = param.size;
                return getSizeOption(size).fontSize;
            },
            border: [
                1,
                "solid",
                "transparent"
            ],
            borderRadius: 2,
            padding: function(param) {
                var size = param.size;
                return getSizeOption(size).padding;
            },
            maxWidth: "100%",
            minWidth: 60,
            minHeight: function(param) {
                var size = param.size;
                return getSizeOption(size).height;
            },
            height: "auto",
            cursor: "pointer",
            overflowWrap: "break-word",
            transition: "outline-offset 0.2s linear",
            textDecoration: "none",
            "&:focus, &:hover": {
                outlineOffset: 5,
                outline: "1px solid ".concat(theme.answerColor),
                // Safari seems to have an outline bug, may not render without boxshadow
                boxShadow: "0 0 4px transparent"
            },
            "&[aria-disabled]": {
                opacity: 0.6,
                pointerEvents: "none"
            }
        }
    };
});
/* harmony default export */ var SurveyButton_useStyles = (useStyles);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyButton/SurveyButton.tsx







function SurveyButton(_param) {
    var _size = _param.size, size = _size === void 0 ? "md" : _size, className = _param.className, children = _param.children, disabled = _param.disabled, ariaDisabled = _param["aria-disabled"], props = (0,_object_without_properties/* default */.Z)(_param, [
        "size",
        "className",
        "children",
        "disabled",
        "aria-disabled"
    ]);
    var isDisabled = disabled !== null && disabled !== void 0 ? disabled : ariaDisabled === "true";
    var surveyButton = SurveyButton_useStyles({
        size: size
    }).surveyButton;
    if ("href" in props && props.href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: classnames_default()(surveyButton, className),
            "aria-disabled": isDisabled || undefined
        }, props), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classnames_default()(surveyButton, className),
        type: "button",
        "aria-disabled": isDisabled || undefined
    }, props), {
        children: children
    }));
}
/* harmony default export */ var SurveyButton_SurveyButton = (SurveyButton);

;// CONCATENATED MODULE: ./src/app/components/Survey/SurveyButton/index.ts



/***/ }),

/***/ 9542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getSpageGoogleFontsLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9815);

// custom fonts lookup
var spageGoogleFonts = {
    "merriweather,serif": "Merriweather:300,400,700",
    "droid serif,serif": "Droid+Serif:300,400,700",
    "noto sans tc,sans-serif": "Noto+Sans+TC:300,400,700",
    "noto sans jp,sans-serif": "Noto+Sans+JP:300,400,700",
    "noto sans kr,sans-serif": "Noto+Sans+KR:300,400,700",
    "Yrsa,Times": "Yrsa:300,400,500,600",
    "Source Serif Pro,Times": "Source+Serif+Pro:400,600,700",
    "Cormorant Garamond,Times": "Cormorant+Garamond:300,300i,400,400i,700,700i",
    "Enriqueta,Times": "Enriqueta:400,700",
    "Noto Serif,Times": "Noto+Serif:400,700",
    "Noticia Text,Times": "Noticia+Text:400,400i,700,700i",
    "Playfair Display,Times": "Playfair+Display:400,400i,700,700i,900,900i",
    "Alegreya,Times": "Alegreya:400,400i,500,500i,700,700i",
    "Crimson Text,Times": "Crimson+Text:400,400i,700,700i",
    "Roboto Slab,Georgia": "Roboto+Slab:300,400,700",
    "Arvo,Georgia": "Arvo:400,400i,700,700i",
    "Crete Round,Georgia": "Crete+Round:400,400i",
    "Roboto,Arial,Helvetica": "Roboto:300,400,700",
    "Open Sans,Arial,Helvetica": "Open+Sans:300,400,600,700",
    "Montserrat,Arial,Helvetica": "Montserrat:400,700",
    "ASAP,Arial,Helvetica": "Asap:400,400i,700,700i",
    "Nunito,Arial,Helvetica": "Nunito:300,300i,400,400i,700,700i,900,900i",
    "Ruda,Arial,Helvetica": "Ruda:400,700,Black",
    "Raleway,Arial,Helvetica": "Raleway:300,300i,400,400i,600,600i,700,700i,900,900i",
    "Play,Arial,Helvetica": "Play:400,700",
    "Lato,Arial,Helvetica": "Lato:300,400,700",
    "Oswald,Arial,Helvetica": "Oswald:200,300,400,500,700",
    "Open Sans Condensed,Arial,Helvetica": "Open+Sans+Condensed:300,300i,700",
    "Roboto Condensed,Arial,Helvetica": "Roboto+Condensed:300,300i,400,400i,700,700i",
    "Economica,Arial,Helvetica": "Economica:400,400i,700,700i",
    "BioRhyme,Georgia": "BioRhyme:300,400,700",
    "Caveat,Times": "Caveat:400,700",
    "Gaegu,Times": "Gaegu:300,400,700",
    "Amatic SC": "Amatic+SC:400,700",
    "IM Fell English": "IM+Fell+English:400,400i"
};
var keys = [
    "surveyTitle",
    "questionTitle",
    "questionBody",
    "button",
    "error",
    "pageTitle"
];
function getSpageGoogleFontsLink(theme) {
    if (!theme) {
        return null;
    }
    var fonts = keys.reduce(function(acc, k) {
        var ref;
        var fontFamily = (ref = theme[k]) === null || ref === void 0 ? void 0 : ref.fontFamily;
        var fontQueryElement = fontFamily && spageGoogleFonts[fontFamily];
        if (!fontQueryElement || acc.includes(fontQueryElement)) {
            return acc;
        }
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc).concat([
            fontQueryElement
        ]);
    }, []);
    if (fonts.length > 0) {
        return "https://fonts.googleapis.com/css?family=".concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(fonts).join("|"));
    }
    return null;
};


/***/ }),

/***/ 2948:
/***/ (function(module) {

"use strict";

var doc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "submitSurveyResponseV2"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "surveyId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    },
                    "directives": []
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "SubmitSurveyResponseInput"
                            }
                        }
                    },
                    "directives": []
                }
            ],
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "submitSurveyResponse"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "surveyId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "surveyId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "success"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "userErrors"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "code"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "detail"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "questionId"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "field"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "encryptedSmParam"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "encryptedSMParamforQuizResults"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "respondent"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "surveyVersion"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "status"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "currentPage"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "heading"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    "loc": {
        "start": 0,
        "end": 417
    }
};
doc.loc.source = {
    "body": "mutation submitSurveyResponseV2($surveyId: ID!, $input: SubmitSurveyResponseInput!) {\n  submitSurveyResponse(surveyId: $surveyId, input: $input) {\n    success\n    userErrors {\n      code\n      detail\n      questionId\n      field\n    }\n    encryptedSmParam\n    encryptedSMParamforQuizResults\n    respondent {\n      id\n      surveyVersion\n      status\n      currentPage {\n        id\n        heading\n      }\n    }\n  }\n}\n",
    "name": "GraphQL request",
    "locationOffset": {
        "line": 1,
        "column": 1
    }
};
var names = {};
function unique(defs) {
    return defs.filter(function(def) {
        if (def.kind !== "FragmentDefinition") return true;
        var name = def.name.value;
        if (names[name]) {
            return false;
        } else {
            names[name] = true;
            return true;
        }
    });
}
// Collect any fragment/type references from a node, adding them to the refs Set
function collectFragmentReferences(node, refs) {
    if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
    } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
            refs.add(type.name.value);
        }
    }
    if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
            collectFragmentReferences(selection, refs);
        });
    }
    if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
    if (node.definitions) {
        node.definitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
}
var definitionRefs = {};
(function extractReferences() {
    doc.definitions.forEach(function(def) {
        if (def.name) {
            var refs = new Set();
            collectFragmentReferences(def, refs);
            definitionRefs[def.name.value] = refs;
        }
    });
})();
function findOperation(doc, name) {
    for(var i = 0; i < doc.definitions.length; i++){
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
            return element;
        }
    }
}
function oneQuery(doc, operationName) {
    // Copy the DocumentNode, but clear out the definitions
    var newDoc = {
        kind: doc.kind,
        definitions: [
            findOperation(doc, operationName)
        ]
    };
    if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
    }
    // Now, for the operation we're running, find any fragments referenced by
    // it or the fragments it references
    var opRefs = definitionRefs[operationName] || new Set();
    var allRefs = new Set();
    var newRefs = new Set();
    // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
    opRefs.forEach(function(refName) {
        newRefs.add(refName);
    });
    while(newRefs.size > 0){
        var prevRefs = newRefs;
        newRefs = new Set();
        prevRefs.forEach(function(refName) {
            if (!allRefs.has(refName)) {
                allRefs.add(refName);
                var childRefs = definitionRefs[refName] || new Set();
                childRefs.forEach(function(childRef) {
                    newRefs.add(childRef);
                });
            }
        });
    }
    allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
            newDoc.definitions.push(op);
        }
    });
    return newDoc;
}
module.exports = doc;
module.exports.submitSurveyResponseV2 = oneQuery(doc, "submitSurveyResponseV2");


/***/ }),

/***/ 1401:
/***/ (function(module) {

"use strict";

var doc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "surveyVersionV2"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "surveyId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    },
                    "directives": []
                }
            ],
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "surveyVersion"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "id"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "surveyId"
                                    }
                                }
                            }
                        ],
                        "directives": []
                    }
                ]
            }
        }
    ],
    "loc": {
        "start": 0,
        "end": 73
    }
};
doc.loc.source = {
    "body": "query surveyVersionV2($surveyId: ID!) {\n  surveyVersion(id: $surveyId)\n}\n",
    "name": "GraphQL request",
    "locationOffset": {
        "line": 1,
        "column": 1
    }
};
var names = {};
function unique(defs) {
    return defs.filter(function(def) {
        if (def.kind !== "FragmentDefinition") return true;
        var name = def.name.value;
        if (names[name]) {
            return false;
        } else {
            names[name] = true;
            return true;
        }
    });
}
// Collect any fragment/type references from a node, adding them to the refs Set
function collectFragmentReferences(node, refs) {
    if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
    } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
            refs.add(type.name.value);
        }
    }
    if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
            collectFragmentReferences(selection, refs);
        });
    }
    if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
    if (node.definitions) {
        node.definitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
}
var definitionRefs = {};
(function extractReferences() {
    doc.definitions.forEach(function(def) {
        if (def.name) {
            var refs = new Set();
            collectFragmentReferences(def, refs);
            definitionRefs[def.name.value] = refs;
        }
    });
})();
function findOperation(doc, name) {
    for(var i = 0; i < doc.definitions.length; i++){
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
            return element;
        }
    }
}
function oneQuery(doc, operationName) {
    // Copy the DocumentNode, but clear out the definitions
    var newDoc = {
        kind: doc.kind,
        definitions: [
            findOperation(doc, operationName)
        ]
    };
    if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
    }
    // Now, for the operation we're running, find any fragments referenced by
    // it or the fragments it references
    var opRefs = definitionRefs[operationName] || new Set();
    var allRefs = new Set();
    var newRefs = new Set();
    // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
    opRefs.forEach(function(refName) {
        newRefs.add(refName);
    });
    while(newRefs.size > 0){
        var prevRefs = newRefs;
        newRefs = new Set();
        prevRefs.forEach(function(refName) {
            if (!allRefs.has(refName)) {
                allRefs.add(refName);
                var childRefs = definitionRefs[refName] || new Set();
                childRefs.forEach(function(childRef) {
                    newRefs.add(childRef);
                });
            }
        });
    }
    allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
            newDoc.definitions.push(op);
        }
    });
    return newDoc;
}
module.exports = doc;
module.exports.surveyVersionV2 = oneQuery(doc, "surveyVersionV2");


/***/ }),

/***/ 3063:
/***/ (function(module) {

"use strict";

var doc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "getRespondentSurveyPage"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "surveyId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    },
                    "directives": []
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "pageId"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ID"
                            }
                        }
                    },
                    "directives": []
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "collectionKey"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    },
                    "directives": []
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "languageCode"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "String"
                            }
                        }
                    },
                    "directives": []
                }
            ],
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "surveyPage"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "pageId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "pageId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "surveyId"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "surveyId"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "collectionKey"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "collectionKey"
                                    }
                                }
                            },
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "languageCode"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "languageCode"
                                    }
                                }
                            }
                        ],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "firstQuestionNumber"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "heading"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subHeading"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "position"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "surveyPageQuestions"
                                    },
                                    "arguments": [
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "pageId"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "pageId"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "surveyId"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "surveyId"
                                                }
                                            }
                                        },
                                        {
                                            "kind": "Argument",
                                            "name": {
                                                "kind": "Name",
                                                "value": "languageCode"
                                            },
                                            "value": {
                                                "kind": "Variable",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "languageCode"
                                                }
                                            }
                                        }
                                    ],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "items"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "family"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "hasPiping"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "position"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "inPage"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "inSurvey"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "label"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "pageId"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "heading"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "default"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": [],
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "text"
                                                                                    },
                                                                                    "arguments": [],
                                                                                    "directives": []
                                                                                }
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "assignments"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": [],
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "id"
                                                                                    },
                                                                                    "arguments": [],
                                                                                    "directives": []
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "heading"
                                                                                    },
                                                                                    "arguments": [],
                                                                                    "directives": [],
                                                                                    "selectionSet": {
                                                                                        "kind": "SelectionSet",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "text"
                                                                                                },
                                                                                                "arguments": [],
                                                                                                "directives": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "image"
                                                                                                },
                                                                                                "arguments": [],
                                                                                                "directives": [],
                                                                                                "selectionSet": {
                                                                                                    "kind": "SelectionSet",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "Field",
                                                                                                            "name": {
                                                                                                                "kind": "Name",
                                                                                                                "value": "id"
                                                                                                            },
                                                                                                            "arguments": [],
                                                                                                            "directives": []
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "Field",
                                                                                                            "name": {
                                                                                                                "kind": "Name",
                                                                                                                "value": "url"
                                                                                                            },
                                                                                                            "arguments": [],
                                                                                                            "directives": []
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "variable"
                                                                                    },
                                                                                    "arguments": [],
                                                                                    "directives": [],
                                                                                    "selectionSet": {
                                                                                        "kind": "SelectionSet",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "id"
                                                                                                },
                                                                                                "arguments": [],
                                                                                                "directives": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "name"
                                                                                                },
                                                                                                "arguments": [],
                                                                                                "directives": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "percent"
                                                                                                },
                                                                                                "arguments": [],
                                                                                                "directives": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "position"
                                                                                                },
                                                                                                "arguments": [],
                                                                                                "directives": []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "OpenEndedQuestionQM"
                                                            },
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "MultipleChoiceQuestionQMv2"
                                                            },
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "MultipleChoiceImageQuestionQMv2"
                                                            },
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "PresentationQuestionQMv2"
                                                            },
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "DateTimeQuestionQM"
                                                            },
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "RatingScaleQuestionQM"
                                                            },
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "MatrixQuestionSingleAnswerQM"
                                                            },
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "MatrixQuestionManyAnswersQM"
                                                            },
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "MenuMatrixQuestionQM"
                                                            },
                                                            "directives": []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "OpenEndedQuestionQM"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "OpenEndedQuestionQM"
                }
            },
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "variant"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "layout"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "spacing"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "left"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "right"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "top"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bottom"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "linesCount"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "charsCount"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "placement"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorMessage"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldSet"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "validation"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorMessage"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "TextLengthValidation"
                                        }
                                    },
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "minLength"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "maxLength"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "NumericalValidation"
                                        }
                                    },
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "maxValue"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "minValue"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DateValidation"
                                        }
                                    },
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "maxDate"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "minDate"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "MultipleChoiceQuestionQMv2"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "MultipleChoiceQuestionQM"
                }
            },
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "variant"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "sorting"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "ignoreLast"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "layout"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "spacing"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "left"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "right"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "top"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bottom"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "width"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "format"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "width"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "answerLayout"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "placement"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorMessage"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "min"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "max"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answers"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answerOther"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "requiredErrorText"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "layout"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "linesCount"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "charsCount"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answerNA"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "validation"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorMessage"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "TextLengthValidation"
                                        }
                                    },
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "minLength"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "maxLength"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "NumericalValidation"
                                        }
                                    },
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "maxValue"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "minValue"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "InlineFragment",
                                    "typeCondition": {
                                        "kind": "NamedType",
                                        "name": {
                                            "kind": "Name",
                                            "value": "DateValidation"
                                        }
                                    },
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "maxDate"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "minDate"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "MultipleChoiceImageQuestionQMv2"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "MultipleChoiceImageQuestionQM"
                }
            },
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answerNA"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answersImage"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "image"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "altText"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "url"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "variant"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorMessage"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "max"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "min"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "PresentationQuestionQMv2"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "PresentationQuestionQM"
                }
            },
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "variant"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "heading"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "default"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "text"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "image"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "url"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "alt"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "layout"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "placement"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "spacing"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "left"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "right"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "top"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bottom"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "DateTimeQuestionQM"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "DateTimeQuestionQM"
                }
            },
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "family"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "heading"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "default"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "text"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "image"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "url"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "alt"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "assignments"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "heading"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "text"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "image"
                                                            },
                                                            "arguments": [],
                                                            "directives": [],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "id"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "url"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "alt"
                                                                        },
                                                                        "arguments": [],
                                                                        "directives": []
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "variable"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "name"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "percent"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "position"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "position"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "inPage"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "inSurvey"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "pageId"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "variant"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "layout"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "placement"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "spacing"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "left"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "right"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "top"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bottom"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "width"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "format"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "width"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorMessage"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "min"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "max"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "validation"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorMessage"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldSets"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "RatingScaleQuestionQM"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "RatingScaleQuestionQM"
                }
            },
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "variant"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldSet"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorMessage"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answersWeighted"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "layout"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "spacing"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "left"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "right"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "top"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bottom"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "placement"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answerOther"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "layout"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "linesCount"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "charsCount"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "requiredErrorText"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answerNA"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "MatrixQuestionSingleAnswerQM"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "MatrixQuestionSingleAnswerQM"
                }
            },
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "variant"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "layout"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "spacing"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "left"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "right"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "top"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bottom"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "width"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "format"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "width"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "placement"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isForcedRanking"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldSets"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answersWeighted"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "weight"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorMessage"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "max"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "min"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isWeighted"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answerOther"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "layout"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "linesCount"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "charsCount"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "requiredErrorText"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answerNA"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "MatrixQuestionManyAnswersQM"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "MatrixQuestionManyAnswersQM"
                }
            },
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "family"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "variant"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "layout"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "spacing"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "left"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "right"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "top"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "bottom"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "width"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "format"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "width"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "placement"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answers"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldSets"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answerOther"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "requiredErrorText"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "layout"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "linesCount"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "charsCount"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "MenuMatrixQuestionQM"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "MenuMatrixQuestionQM"
                }
            },
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answerOther"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "requiredErrorText"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "layout"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "linesCount"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "charsCount"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "family"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "fieldSets"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "required"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "errorMessage"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "type"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "min"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "max"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "variant"
                        },
                        "arguments": [],
                        "directives": []
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "answersNested"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "label"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "choices"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "label"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "visible"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "visible"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    "loc": {
        "start": 0,
        "end": 5905
    }
};
doc.loc.source = {
    "body": "query getRespondentSurveyPage($surveyId: ID!, $pageId: ID!, $collectionKey: String!, $languageCode: String!) {\n  surveyPage(pageId: $pageId, surveyId: $surveyId, collectionKey: $collectionKey, languageCode: $languageCode ) {\n    id\n    firstQuestionNumber\n    heading\n    subHeading\n    position\n    surveyPageQuestions(pageId: $pageId, surveyId: $surveyId, languageCode: $languageCode) {\n      items {\n        id\n        family\n        hasPiping\n        position {\n          inPage\n          inSurvey\n          label\n          pageId\n        }\n        heading {\n          default {\n            text\n          }\n          assignments {\n            id\n            heading {\n              text\n              image {\n                id\n                url\n              }\n            }\n            variable {\n              id\n              name\n              percent\n              position\n            }\n          }\n        }\n        ...OpenEndedQuestionQM\n        ...MultipleChoiceQuestionQMv2\n        ...MultipleChoiceImageQuestionQMv2\n        ...PresentationQuestionQMv2\n        ...DateTimeQuestionQM\n        ...RatingScaleQuestionQM\n        ...MatrixQuestionSingleAnswerQM\n        ...MatrixQuestionManyAnswersQM\n        ...MenuMatrixQuestionQM\n      }\n    }\n  }\n}\n\nfragment OpenEndedQuestionQM on OpenEndedQuestionQM {\n  id\n  variant\n  layout {\n    spacing {\n      left\n      right\n      top\n      bottom\n    }\n    linesCount\n    charsCount\n    placement\n  }\n  required {\n    type\n    errorMessage\n  }\n  fieldSet {\n    id\n    label\n    visible\n  }\n  validation {\n    type\n    errorMessage\n    ... on TextLengthValidation {\n      minLength\n      maxLength\n    }\n    ... on NumericalValidation {\n      maxValue\n      minValue\n    }\n    ... on DateValidation {\n      maxDate\n      minDate\n    }\n  }\n}\n\nfragment MultipleChoiceQuestionQMv2 on MultipleChoiceQuestionQM {\n  id\n  variant\n  sorting {\n    ignoreLast\n    type\n  }\n  layout {\n    spacing {\n      left\n      right\n      top\n      bottom\n    }\n    width {\n      format\n      width\n    }\n    answerLayout\n    placement\n  }\n  required {\n    type\n    errorMessage\n    min\n    max\n  }\n  answers {\n    id\n    label\n    visible\n  }\n  answerOther {\n    id\n    label\n    type\n    requiredErrorText\n    layout {\n      linesCount\n      charsCount\n    }\n    visible\n  }\n  answerNA {\n    id\n    label\n    visible\n  }\n  validation {\n    type\n    errorMessage\n    ... on TextLengthValidation {\n      minLength\n      maxLength\n    }\n    ... on NumericalValidation {\n      maxValue\n      minValue\n    }\n    ... on DateValidation {\n      maxDate\n      minDate\n    }\n  }\n}\n\nfragment MultipleChoiceImageQuestionQMv2 on MultipleChoiceImageQuestionQM {\n  answerNA {\n    id\n    label\n    visible\n  }\n  answersImage {\n    id\n    image {\n      altText\n      url\n    }\n    label\n    visible\n  }\n  id\n  variant\n  required {\n    errorMessage\n    max\n    min\n    type\n  }\n}\n\nfragment PresentationQuestionQMv2 on PresentationQuestionQM {\n  id\n  variant\n  heading {\n    default {\n      text\n      image {\n        id\n        url\n        alt\n      }\n    }\n  }\n  layout {\n    placement\n    spacing {\n      left\n      right\n      top\n      bottom\n    }\n  }\n}\n\nfragment DateTimeQuestionQM on DateTimeQuestionQM {\n  id\n  family\n  heading {\n    default {\n      text\n      image {\n        id\n        url\n        alt\n      }\n    }\n    assignments {\n      id\n      heading {\n        text\n      image {\n        id\n        url\n        alt\n      }\n      }\n      variable {\n        id\n        name\n        percent\n        position\n      }\n    }\n  }\n  position {\n    inPage\n    inSurvey\n    label\n    pageId\n  }\n  variant\n  layout {\n    placement\n    spacing {\n      left\n      right\n      top\n      bottom\n    }\n    width {\n      format\n      width\n    }\n  }\n  required {\n    errorMessage\n    type\n    min\n    max\n  }\n  validation {\n    errorMessage\n    type\n  }\n  fieldSets {\n    id\n    label\n    visible\n  }\n}\n\nfragment RatingScaleQuestionQM on RatingScaleQuestionQM {\n  id\n  variant\n  fieldSet {\n    id\n    label\n    visible\n  }\n  required {\n    type\n    errorMessage\n  }\n  answersWeighted {\n    id\n    label\n    visible\n  }\n  layout {\n    spacing {\n      left\n      right\n      top\n      bottom\n    }\n    placement\n  }\n  answerOther {\n    id\n    label\n    layout {\n      linesCount\n      charsCount\n    }\n    requiredErrorText\n    type\n    visible\n  }\n  answerNA {\n    id\n    label\n    visible\n  }\n}\n\nfragment MatrixQuestionSingleAnswerQM on MatrixQuestionSingleAnswerQM {\n  id\n  variant\n  layout {\n    spacing {\n      left\n      right\n      top\n      bottom\n    }\n    width {\n      format\n      width\n    }\n    placement\n  }\n  isForcedRanking\n  fieldSets {\n    visible\n    label\n    id\n  }\n  answersWeighted {\n    id\n    label\n    visible\n    weight\n  }\n  required {\n    errorMessage\n    max\n    min\n    type\n  }\n  isWeighted\n  answerOther {\n    id\n    label\n    layout {\n      linesCount\n      charsCount\n    }\n    requiredErrorText\n    type\n    visible\n  }\n  answerNA {\n    id\n    label\n    visible\n  }\n}\n\nfragment MatrixQuestionManyAnswersQM on MatrixQuestionManyAnswersQM {\n  id\n  family\n  variant\n  layout {\n    spacing {\n      left\n      right\n      top\n      bottom\n    }\n    width {\n      format\n      width\n    }\n    placement\n  }\n  answers {\n    id\n    label\n    visible\n  }\n  fieldSets {\n    visible\n    label\n    id\n  }\n  answerOther {\n    visible\n    type\n    requiredErrorText\n    layout {\n      linesCount\n      charsCount\n    }\n    label\n    id\n  }\n}\n\nfragment MenuMatrixQuestionQM on MenuMatrixQuestionQM {\n  answerOther {\n    id\n    label\n    type\n    requiredErrorText\n    layout {\n      linesCount\n      charsCount\n    }\n    visible\n  }\n  family\n  fieldSets {\n    id\n    label\n    visible\n  }\n  required {\n    errorMessage\n    type\n    min\n    max\n  }\n  variant\n  answersNested {\n    id\n    label\n    choices {\n      id\n      label\n      visible\n    }\n    visible\n  }\n}\n",
    "name": "GraphQL request",
    "locationOffset": {
        "line": 1,
        "column": 1
    }
};
var names = {};
function unique(defs) {
    return defs.filter(function(def) {
        if (def.kind !== "FragmentDefinition") return true;
        var name = def.name.value;
        if (names[name]) {
            return false;
        } else {
            names[name] = true;
            return true;
        }
    });
}
// Collect any fragment/type references from a node, adding them to the refs Set
function collectFragmentReferences(node, refs) {
    if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
    } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
            refs.add(type.name.value);
        }
    }
    if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
            collectFragmentReferences(selection, refs);
        });
    }
    if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
    if (node.definitions) {
        node.definitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
}
var definitionRefs = {};
(function extractReferences() {
    doc.definitions.forEach(function(def) {
        if (def.name) {
            var refs = new Set();
            collectFragmentReferences(def, refs);
            definitionRefs[def.name.value] = refs;
        }
    });
})();
function findOperation(doc, name) {
    for(var i = 0; i < doc.definitions.length; i++){
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
            return element;
        }
    }
}
function oneQuery(doc, operationName) {
    // Copy the DocumentNode, but clear out the definitions
    var newDoc = {
        kind: doc.kind,
        definitions: [
            findOperation(doc, operationName)
        ]
    };
    if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
    }
    // Now, for the operation we're running, find any fragments referenced by
    // it or the fragments it references
    var opRefs = definitionRefs[operationName] || new Set();
    var allRefs = new Set();
    var newRefs = new Set();
    // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
    opRefs.forEach(function(refName) {
        newRefs.add(refName);
    });
    while(newRefs.size > 0){
        var prevRefs = newRefs;
        newRefs = new Set();
        prevRefs.forEach(function(refName) {
            if (!allRefs.has(refName)) {
                allRefs.add(refName);
                var childRefs = definitionRefs[refName] || new Set();
                childRefs.forEach(function(childRef) {
                    newRefs.add(childRef);
                });
            }
        });
    }
    allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
            newDoc.definitions.push(op);
        }
    });
    return newDoc;
}
module.exports = doc;
module.exports.getRespondentSurveyPage = oneQuery(doc, "getRespondentSurveyPage");
module.exports.OpenEndedQuestionQM = oneQuery(doc, "OpenEndedQuestionQM");
module.exports.MultipleChoiceQuestionQMv2 = oneQuery(doc, "MultipleChoiceQuestionQMv2");
module.exports.MultipleChoiceImageQuestionQMv2 = oneQuery(doc, "MultipleChoiceImageQuestionQMv2");
module.exports.PresentationQuestionQMv2 = oneQuery(doc, "PresentationQuestionQMv2");
module.exports.DateTimeQuestionQM = oneQuery(doc, "DateTimeQuestionQM");
module.exports.RatingScaleQuestionQM = oneQuery(doc, "RatingScaleQuestionQM");
module.exports.MatrixQuestionSingleAnswerQM = oneQuery(doc, "MatrixQuestionSingleAnswerQM");
module.exports.MatrixQuestionManyAnswersQM = oneQuery(doc, "MatrixQuestionManyAnswersQM");
module.exports.MenuMatrixQuestionQM = oneQuery(doc, "MenuMatrixQuestionQM");


/***/ }),

/***/ 2480:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3372,4065,610,7517,4693,9921,8975,2715,9774,2888,179], function() { return __webpack_exec__(8876); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);